import React, { Component } from 'react';
const swea = require('swea');
import s from './Index.scss';
import * as globals from '../globals';
const withStyles = swea.withStyles;
const i18n = swea.i18n;
const Menu = swea.react.components.menu.Menu;
const MenuItem = swea.react.components.menu.MenuItem;
const ContextMenu = swea.react.components.menu.ContextMenu;
const ContextMenuCondition = swea.react.components.menu.ContextMenuCondition;
const Viewer = swea.react.components.viewer.Viewer;
const Model = swea.scene.models.Model;
const LoadedModel = swea.scene.models.LoadedModel;
const SkyModel = swea.scene.models.SkyModel;
const ProgressScreen = swea.react.components.progress.ProgressScreen;
const ViewerManager = swea.editor.ViewerManager;
const ModelManager = swea.editor.ModelManager;
const InteractionManager = swea.editor.InteractionManager;
const Version = swea.react.components.version.Version;
const eventCodes = swea.editor.interactions.eventCodes;
const DirectionalLight = swea.scene.lights.DirectionalLight;
const MoveInteraction = swea.editor.interactions.MoveInteraction;
const DeleteInteraction = swea.editor.interactions.DeleteInteraction;
const HandleInteraction = swea.editor.interactions.HandleInteraction;
const DebugInteraction = swea.editor.interactions.DebugInteraction;
const FlyToInteraction = swea.editor.interactions.FlyToInteraction;
const Handle = swea.scene.models.Handle;
const Classification = swea.config.Classification;
const ImageCatalogueService = swea.react.services.ImageCatalogueService;
const EditorStateServiceActions = swea.react.actions.EditorStateServiceActions;
const EditorStateService = swea.react.services.EditorStateService;
const InstructionServiceActions = swea.react.actions.InstructionServiceActions;
const InstructionService = swea.react.services.InstructionService;
const ContextMenuStateServiceActions = swea.react.actions.ContextMenuStateServiceActions;
const ModelCatalogueService = swea.react.services.ModelCatalogueService;
const ModelCatalogueServiceActions = swea.react.actions.ModelCatalogueServiceActions;
const FavoriteServiceActions = swea.react.actions.FavoriteServiceActions;
const FavoriteService = swea.react.services.FavoriteService;
const ShaderPaletteServiceActions = swea.react.actions.ShaderPaletteServiceActions;
const ShaderPaletteService = swea.react.services.ShaderPaletteService;
const ImageViewerService = swea.react.services.ImageViewerService;
const ContextMenuStateService = swea.react.services.ContextMenuStateService;
const ToggleModelsServiceActions = swea.react.actions.ToggleModelsServiceActions;
const ToggleModelsService = swea.react.services.ToggleModelsService;
const ToggleModelsContextMenu = swea.react.components.contextmenus.ToggleModelsContextMenu;
const DialogServiceActions = swea.react.actions.DialogServiceActions;
const DialogService = swea.react.services.DialogService;
const SpriteModelCommand = swea.editor.primitivemodelcommands.SpriteModelCommand;
const MeasureContextMenu = swea.react.components.contextmenus.MeasureContextMenu;
const AnnotationContextMenu = swea.react.components.annotation.AnnotationContextMenu;
const AnnotationFilterPanel = swea.react.components.annotation.AnnotationFilterPanel;

const ShaderPaletteContextMenu = swea.react.components.contextmenus.ShaderPaletteContextMenu;
const EyeDropperContextMenu = swea.react.components.contextmenus.EyeDropperContextMenu;
const TextureLabelEyeDropperContextMenu = swea.react.components.contextmenus.TextureLabelEyeDropperContextMenu;
const AnnotationServiceActions = swea.react.actions.AnnotationServiceActions;
const AnnotationService = swea.react.services.AnnotationService;
const HTTP = swea.editor.HTTP;
const UnitsAdapter = swea.editor.UnitsAdapter;
const traversalMasks = swea.scene.nodes.traversalMasks;
const InspectionAdapter = swea.editor.InspectionAdapter;
const ColorPicker = swea.react.components.colorpicker.ColorPicker;
const TextEditor = swea.react.components.texteditor.TextEditor;
const Extruder = swea.react.components.extruder.Extruder;
const Slider = swea.react.components.slider.Slider;
const Report = swea.react.components.report.Report;
const AnnotationReport = swea.react.components.annotation.AnnotationReport;
const BrowserInfo = swea.react.helpers.BrowserInfo;
const ImageCache = swea.scene.models.ImageCache;
const TextureCache = swea.scene.models.TextureCache;
const TimeContextMenu = swea.react.components.contextmenus.TimeContextMenu;
const MeasureServiceActions = swea.react.actions.MeasureServiceActions;
const Globals = swea.react.constants.globals;
const ImageViewerServiceActions = swea.react.actions.ImageViewerServiceActions;
const ImageCatalogueServiceActions = swea.react.actions.ImageCatalogueServiceActions;
const AnnotationModel = swea.scene.models.AnnotationModel;
const VolumeModel = swea.scene.models.VolumeModel;
const SelectCommand = swea.editor.SelectCommand;
const MeasureService = swea.react.services.MeasureService;
const InspectServiceActions = swea.react.actions.InspectServiceActions;
const VersionsServiceActions = swea.react.actions.VersionsServiceActions;
const VersionsService = swea.react.services.VersionsService;
const VersionsContextMenu = swea.react.components.contextmenus.VersionsContextMenu;
const CameraInteraction = swea.editor.interactions.CameraInteraction;
const CameraControl = swea.react.components.cameracontrol.CameraControl;
const LabelFilterControl = swea.react.components.labelfiltercontrol.LabelFilterControl;
const ShortcutInteraction = swea.editor.interactions.ShortcutInteraction;
const TextureLabelAdapter = swea.editor.TextureLabelAdapter;
const DistributedContextMenu = swea.react.components.contextmenus.DistributedContextMenu;
const ResolutionContextMenu = swea.react.components.contextmenus.ResolutionContextMenu;
const Compass = swea.react.components.compass.Compass;
const Altitude = swea.react.components.altitude.Altitude;
const AxesIndicator = swea.react.components.axesindicator.AxesIndicator;
const SpecifyTransformContextMenu = swea.react.components.contextmenus.SpecifyTransformContextMenu;
const ClassificationGroupModel = swea.scene.models.ClassificationGroupModel;
const ElevationInteraction = swea.editor.interactions.ElevationInteraction;
const TextureLabelServiceActions = swea.react.actions.TextureLabelServiceActions;
const SubloadTextureManager = swea.scene.viewers.SubloadTextureManager;
const DragViewInteraction = swea.editor.interactions.DragViewInteraction;
const SubloadGeometryManager = swea.scene.viewers.SubloadGeometryManager;
const ImageSlider = swea.react.components.imageslider.ImageSlider;
const OrbitManipulator = swea.scene.viewers.OrbitManipulator;
const ContextInput = swea.react.components.contextinput.ContextInput;
const MaskService = swea.react.services.MaskService;
const MaskServiceActions = swea.react.actions.MaskServiceActions;
const MaskClassesContextMenu = swea.react.components.contextmenus.MaskClassesContextMenu;

import ModelContextMenu from './ModelContextMenu.jsx';
import ViewStateManager from '../helpers/ViewStateManager';
import CustomBestCamerasInteraction from '../interactions/CustomBestCamerasInteraction';
import CustomMeasureInteraction from '../interactions/CustomMeasureInteraction';
import CustomSelectInteraction from '../interactions/CustomSelectInteraction';
import CustomBulldozeInteraction from '../interactions/CustomBulldozeInteraction';
import CustomPlaceModelInteraction from '../interactions/CustomPlaceModelInteraction';
import CustomLoadModelCommand from '../commands/CustomLoadModelCommand';
import CustomAreaInteraction from '../interactions/CustomAreaInteraction';
import CustomImageSelectionInteraction from '../interactions/CustomImageSelectionInteraction';
import CustomCreateAnnotationInteraction from '../interactions/CustomCreateAnnotationInteraction';
import CustomTextAreaInteraction from '../interactions/CustomTextAreaInteraction';
import CustomTextLineInteraction from '../interactions/CustomTextLineInteraction';
import CustomPerpendicularViewInteraction from '../interactions/CustomPerpendicularViewInteraction';
import CustomEyeDropperInteraction from '../interactions/CustomEyeDropperInteraction';
import CustomTextureLabelEyeDropperInteraction from '../interactions/CustomTextureLabelEyeDropperInteraction';
import CustomTextureLabelRectangleInteraction from '../interactions/CustomTextureLabelRectangleInteraction';
import InspectVisualizedCamerasInteraction from '../interactions/InspectVisualizedCamerasInteraction';
import CustomResolutionInteraction from '../interactions/CustomResolutionInteraction';
import flirPalettes from '../palettes/flirPalettes.json';
import depthPalettes from '../palettes/depthPalettes.json';
import CustomImmediateInspectInteraction from '../interactions/CustomImmediateInspectInteraction';
import CustomDepthInteraction from '../interactions/CustomDepthInteraction';
import CustomSpecifyTransformInteraction from '../interactions/CustomSpecifyTransformInteraction';
import CustomDepthProfileInteraction from '../interactions/CustomDepthProfileInteraction';
import CustomCameraRectangleInteraction from '../interactions/CustomCameraRectangleInteraction';
import CustomSectionVolumeInteraction from '../interactions/CustomSectionVolumeInteraction';
import Profiler from '../helpers/Profiler';
const SectionVolumeExtruder = swea.react.components.extruder.SectionVolumeExtruder;


// Metadata
// --------
// https://spotscale-team.atlassian.net/wiki/spaces/SPOT/pages/505839626/Spotscale+Viewer+metadata

// title (previously handled by index.php but removed )

// view
//   eye
//   center
//   xrot
//   yrot
//   zrot
//   pitchUpLimit
//   pitchDownLimit
//   yawLeftLimit
//   yawRightLimit
//   zoomOutLimit
//   zoomInLimit
//   flyToTop
//   top
//   clipNear
//   clipFar
//   strafe
//   cylindereye
//   cylindertarget
//   cylinderdiameter

// thermal
//   radiometricMin
//   radiometricMax
//   radiometricMulti
//   radiometricSynced
//   ir
//   pure
//   irlow
//   irhigh
//   irlowimage
//   irhighimage
//   palette
//   lockModelInterval
//   lockImageInterval
//   lockModelPalette
//   lockImagePalette
//   jpegExtension
//   presentThresholdTemperature

// texturelabels
//   enabled
//   filtersurl
//   reducedclasses
//   classesurl
//   globalfilenames
//   gisurl
//   contoururl
//   disabledurl
//   filtercolors

// environment
// sky
// limit
// light
// anisotropy
// shadow
// headlamp

// tools (true = enabled, false = disabled, undefined = removed)
//   menu
//   toggle3d
//   undo_redo_delete
//   inspect
//   inspectionhighlight
//   immediateinspect
//   remainafterimmediateinspect
//   smartinspect
//   measure
//   restart_measure
//   refine_measure
//   area_edge_lengths
//   ortho (separate free, top and later also facade buttons)
//   free_top_toggle (one button toggling between free and top)
//   cylinderview
//   filter (image filter star icon)
//   filter_camera_type (filter camera type in image catalog, if there are multiple types)
//   move
//   movelines
//   movepolygons
//   clonelines
//   clonepolygons
//   home
//   units
//   annotationreport (avoid with classificationreport and workspaceinfo!)
//   measurementreport (include measurements in annotationreport which is requred)
//   share (copy link to clipboard)
//   saveimage (save screenshot as image)
//   switchannotations
//   togglelights
//   downloadimage
//   compass
//   altitude
//   depthcolor
//   toggletexture
//   occludeLines

//   loadsave
//   annotate
//   annotationcreator (show annotation creator from portal)
//   annotationtimestamps (show annotation created/updated timestamps)
//   annotationnumbers (automatic consecutive numbers in annotation text)
//   areas
//   lines
//   solid
//   extrude
//   transform
//   bulldoze
//   catalog
//   togglemodels (don't use together with classification)
//   time
//   texturelabels
//   texturelabeleyedropper
//   texturelabelrectangle
//   texturelabelstats
//   togglemeasurements
//   toggleannotations
//   filterannotations
//   annotationlods
//   annotationlodrange
//   annotationlowlodrange
//   measurementlods
//   measurementlodrange
//   measurementlowlodrange
//   movableannotations
//   downloadcsv
//   depthprofile
//   cylinderprofile
//   elevation
//   versions
//   compare
//   togglesweamodel

//   thermal
//   eyedropper
//   eyedropper2d
//   eyedropperdelta
//   thermaldemo (avoids temperature per image if true)

//   classification (don't use together with togglemodels)
//   classificationreport (classifications and placed models, don't use together with annotationreport and info!)

//   workspaceinfo (workspace info, avoid with annotationreport and classificationreport!)

//   imperial
//   debug

// color
//   measureAreaColor
//   measureLineColor

// otherModel
// planes
// collisionModel
// collisionDelta
// gsdModel
// depthOnly

// gsd
//    coverage
//    texture

// annotationfields

// workspaceInfoBaseUrl

// epsg
// offset
// xrot (moved to view but kept for backward compatibility)
// yrot (moved to view but kept for backward compatibility)
// zrot (moved to view but kept for backward compatibility)

// smartinspect
//   images

// openseadragon
// dzia

// prefetchcameras
// camerameta
// cameramappings
// rotateUpsideDownCameras

// locked

// decimals

// classification

// cameras
// orderedCameras
// cameraScale

// profile

// Asynchronous function call order:
// componentDidMount: wait for fetching metadata
// _checkSpeed: wait for fetching MB file
// _finishMounting: wait for _updateFromMetadata
// _metadataLoaded : wait for classes.json to load
// _loadBaseModel: wait for _baseModel.whenLoaded and possibly TextureLabelAdapter.readGlobalMappings
// _globalMappingsLoaded: wait for TextureLabels.setGisUrl
// _featuresLoaded: wait for InspectionAdapter.prefetchFiles and/or ToggleModelsService.whenLoaded
// _modelAndCamerasLoaded: wait for otherModel.whenLoaded
// _otherModelLoaded: wait for collisionModel.whenLoaded
// _collisionModelLoaded: wait for planeModel.whenLoaded
// _planeModelLoaded: wait for all loaded GSD models
// _gsdModelsLoaded


const LANGUAGES = [
  'en',
  'sv'
];

const ViewType = {
  FREE: 0,
  TOP: 1,
  SIDE: 2,
  CYLINDER: 3
};

const GsdType = {
  GENERAL: 0,
  COVERAGE: 1,
  TEXTURE: 2
};

// Warn if bandwidth from storage is below this limit in MBit/s
const SPEED_WARNING_LIMIT = 10.0;

/**
 * @constant COLOR_PALETTE Solid area color palette.
 * @type {string[]}
 */
const SOLID_COLOR_PALETTE = [
  '#c0c0c0', // Bright gray
  '#808080', // Medium gray
  '#404040', // Dark gray
  '#4e4730', // Dark brown
  '#b1a369', // Medium brown
  '#b47e68', // Orange
  '#74985b', // Dark green
  '#cddda3', // Bright green
];

/**
 * @constant SECTION_COLOR_PALETTE Section volume color palette.
 * @type {string[]}
 */
const SECTION_COLOR_PALETTE = [
  '#74985b', // Dark green
  '#cddda3', // Bright green
  '#F2993A', // Amber/orange (section default)
  '#E06050', // Warm red
  '#5BA8C8', // Sky blue
  '#8B6DB0', // Purple
];

/**
 * @constant DEFAULT_DISTANCE_SLIDER_VALUES Default values for the near clip slider
 * @type {string[]}
 */
const DEFAULT_DISTANCE_SLIDER_VALUES = [0.1, 10];

/**
 * @constant Fraction of progress time spent loading model with old non-octree bestCameras (empirically found, of course very approximate).
 * @type { number }
 */
const PROGRESS_MODEL_FRACTION = 0.99;

/**
 * @constant Fraction of progress time spent loading global labels (empirically found, of course very approximate).
 * @type { number }
 */
const PROGRESS_GLOBAL_LABELS_FRACTION = 0.2;

/**
 * @constant Fraction of progress time spent loading features (empirically found, of course very approximate).
 * @type { number }
 */
const PROGRESS_FEATURES_FRACTION = 0.7;

/**
 * @constant Timeout in seconds after which to show navigation info.
 * @type { number }
 */
const BEFORE_NAV_INFO_TIMEOUT = 30.0;

/**
 * @constant Timeout in seconds to show navigation info.
 * @type { number }
 */
const NAV_INFO_TIMEOUT = 10.0;

/**
 * @constant Timeout in seconds before flying to initial top view.
 * @type { number }
 */
const FLY_TO_TOP_TIMEOUT = 0.5;

/**
 * @constant Default texture anisotropy.
 * @type { number }
 */
const DEFAULT_ANISOTROPY = 8.0;

/**
 * @constant Timeout in seconds before a warning about being idle (30 minutes).
 * @type { number }
 */
const IDLE_TIMEOUT = 30 * 60;

/**
 * The distance from an annotation used to zoom to it when switching annotations.
 * @type { number }
 */
const SWITCH_ANNOTATION_DISTANCE = 10.0;

/**
 * The minimum viewing height used to zoom to it when switching annotations.
 * @type { number }
 */
const SWITCH_ANNOTATION_MIN_HEIGHT_FACTOR = 0.25;

/**
 * The default maximum canvas width in pixels.
 * NOTE: Disabled for now since it resulted in all sorts of problems with sprites, annotations, etc.
 * @type { number }
 */
//const DEFAULT_MAX_WIDTH = 1920;

/**
 * Interval time in ms for rotating headlamp.
 * @type { number }
 */
const ROTATE_HEADLAMP_INTERVAL = 33;

/**
 * Angle in radians rotating headlamp each interval.
 * @type { number }
 */
const ROTATE_HEADLAMP_ANGLE = 2.0 * Math.PI / 180.0;


/**
 * Spotscale Viewer Component
 * @class
 * @extends Component
 * @memberOf react.components
 */
class Index extends Component {
  /**
   * The constructor.
   * @param { object } The initial options/props.
   */
  constructor(props) {
    super(props);

    // Set empty unload and beforeunload events to avoid expensive back-forwards cache
    window.addEventListener('beforeunload', this._emptyBeforeUnload);
    window.addEventListener('unload', this._emptyOnUnload);

    // Add lodscale 1.8 if mobile
    if (BrowserInfo.isMobile() && window.location.search.indexOf('lodscale') === -1) {
      window.location.search += '&lodscale=1.8';
    }

    this._metadata = undefined;
    this._origMetadata = undefined;

    // Fetch max canvas width
    this._maxWidth = swea.util.getQueryParameters().maxWidth;

    // NOTE: Default disabled for now since it resulted in all sorts of problems with sprites, annotations, etc.
    /*
    if (this._maxWidth === undefined) {
      this._maxWidth = DEFAULT_MAX_WIDTH;
    }
    */

    // Fetch decimals parameter
    const decimalsParam = swea.util.getQueryParameters().decimals;

    const exemptPrefixes = [
      'blocked_',
      'L0_', 'L1_', 'L2_', 'L3_', 'L4_', 'L5_', 'L6_', 'L7_', 'L8_', 'L9_',
      'textured_',
      'thermal_',
      'blockedgesimage',
      'label_'
    ];
    ImageCache.instance().setExemptPrefixes(exemptPrefixes);
    TextureCache.instance().setExemptPrefixes(exemptPrefixes);

    // Set any custom subload parameters
    // (budget in componentDidMount when viewer has been created and subload size here before creating viewer and pager)
    const subloadTextureSize = swea.util.getQueryParameters().texsubloadsize;
    if (subloadTextureSize !== undefined) {
      SubloadTextureManager.instance().setSubloadSize(subloadTextureSize);
    }
    const subloadGeometrySize = swea.util.getQueryParameters().geomsubloadsize;
    if (subloadGeometrySize !== undefined) {
      SubloadGeometryManager.instance().setSubloadSize(subloadGeometrySize);
    }

    // Fetch any back link
    this._backUrl = swea.util.getQueryParameters().back;

    // Let sub-model and main model questions be remembered together
    if (swea.util.getQueryParameters().rememberGotoModelReply === '1') {
      DialogService.instance().setRememberedReply(swea.i18n.t('components.sub_model_dialog.title'), true);
      DialogService.instance().setRememberedReply(swea.i18n.t('components.main_model_dialog.title'), true);
    }

    // Get any transformation
    let xOffset = swea.util.getQueryParameters().x;
    let yOffset = swea.util.getQueryParameters().y;
    let zOffset = swea.util.getQueryParameters().z;
    this._initialPosition = [
      xOffset !== undefined ? parseFloat(xOffset) : 0.0,
      yOffset !== undefined ? parseFloat(yOffset) : 0.0,
      zOffset !== undefined ? parseFloat(zOffset) : 0.0
    ]
    let xRotation = swea.util.getQueryParameters().xrot;
    let yRotation = swea.util.getQueryParameters().yrot;
    let zRotation = swea.util.getQueryParameters().zrot;
    this._initialRotation = [
      xRotation !== undefined ? parseFloat(xRotation) * Math.PI / 180.0 : 0.0,
      yRotation !== undefined ? parseFloat(yRotation) * Math.PI / 180.0 : 0.0,
      zRotation !== undefined ? parseFloat(zRotation) * Math.PI / 180.0 : 0.0
    ];

    // Same type of tranformation for "other" model, will be added to main transformation
    xOffset = swea.util.getQueryParameters().otherx;
    yOffset = swea.util.getQueryParameters().othery;
    zOffset = swea.util.getQueryParameters().otherz;
    this._otherInitialPosition = [
      xOffset !== undefined ? parseFloat(xOffset) : 0.0,
      yOffset !== undefined ? parseFloat(yOffset) : 0.0,
      zOffset !== undefined ? parseFloat(zOffset) : 0.0
    ]
    xRotation = swea.util.getQueryParameters().otherxrot;
    yRotation = swea.util.getQueryParameters().otheryrot;
    zRotation = swea.util.getQueryParameters().otherzrot;
    this._otherInitialRotation = [
      xRotation !== undefined ? parseFloat(xRotation) * Math.PI / 180.0 : 0.0,
      yRotation !== undefined ? parseFloat(yRotation) * Math.PI / 180.0 : 0.0,
      zRotation !== undefined ? parseFloat(zRotation) * Math.PI / 180.0 : 0.0
    ];

    // Get field-of-view
    const fov = swea.util.getQueryParameters().fov;
    this._fov = (fov === undefined ? 60.0 : fov);

    // Visualize cameras?
    this._visualizeCameras = (swea.util.getQueryParameters().cameras === '1');
    this._visualizeCamerasOrdered = (swea.util.getQueryParameters().orderedCameras === '1');

    // Get IR on/off, palette, limits and locking from URL
    this._startRadiometricFromUrl = (swea.util.getQueryParameters().ir !== undefined);
    this._startRadiometric = (swea.util.getQueryParameters().ir === '1');
    this._paletteFromUrl = (swea.util.getQueryParameters().palette !== undefined);
    this._lowLimitFromUrl = (swea.util.getQueryParameters().irlow !== undefined);
    this._highLimitFromUrl = (swea.util.getQueryParameters().irhigh !== undefined);
    this._lowLimitImageFromUrl = (swea.util.getQueryParameters().irlowimage !== undefined);
    this._highLimitImageFromUrl = (swea.util.getQueryParameters().irhighimage !== undefined);
    this._lockModelPaletteFromUrl = (swea.util.getQueryParameters().lockModelPalette !== undefined);
    this._lockImagePaletteFromUrl = (swea.util.getQueryParameters().lockImagePalette !== undefined);
    this._lockModelIntervalFromUrl = (swea.util.getQueryParameters().lockModelInterval !== undefined);
    this._lockImageIntervalFromUrl = (swea.util.getQueryParameters().lockImageInterval !== undefined);
    this._palette = 'iron';
    const palette = swea.util.getQueryParameters().palette;
    if (palette !== undefined && palette !== '') {
      this._palette = palette;
    }
    this._radiometricLimits = [0.0, 1.0];
    const irlow = parseFloat(swea.util.getQueryParameters().irlow);
    if (!isNaN(irlow)) {
      this._radiometricLimits[0] = irlow;
    }
    const irhigh = parseFloat(swea.util.getQueryParameters().irhigh);
    if (!isNaN(irhigh)) {
      this._radiometricLimits[1] = irhigh;
    }
    this._radiometricLimitsImage = this._radiometricLimits.slice();
    const irlowImage = parseFloat(swea.util.getQueryParameters().irlowimage);
    if (!isNaN(irlowImage)) {
      this._radiometricLimitsImage[0] = irlowImage;
    }
    const irhighImage = parseFloat(swea.util.getQueryParameters().irhighimage);
    if (!isNaN(irhighImage)) {
      this._radiometricLimitsImage[1] = irhighImage;
    }

    const gsdToggledPerType = {};
    for (const type in GsdType) {
      gsdToggledPerType[type] = false;
    }

    this.state = {
      modelImgPath: '',
      modelName: '',
      modelComment: undefined,
      viewState: ViewStateManager.ViewStates.STATE_3D,
      filter: false,
      cloudSave: undefined,
      showMenu: false,
      showControlsOutsideMenu: false,
      showSwitchAnnotations: false,
      imageOpen: false,
      catalogOpen: false,
      dialogOpen: false,
      topRightDialogOpen: false,
      interactions: [],
      viewType: ViewType.FREE,
      clipFactors: [0.0, 1.0],
      distanceValues: DEFAULT_DISTANCE_SLIDER_VALUES,
      radiometric: this._startRadiometric,
      showClassificationReport: false,
      showAnnotationReport: false,
      showLogo: true,
      imperial: false,
      lowerElevationLimit: swea.util.getQueryParameters().lowerlimit,
      backgroundColor: swea.util.getQueryParameters().background,
      showProgressText: swea.util.getQueryParameters().noprogresstext !== '1',
      fullProgressLogo: swea.util.getQueryParameters().fullprogress === '1',
      measureAccuracy: (decimalsParam === undefined ? 0.01 : 1.0 / Math.pow(10.0, parseFloat(decimalsParam))),
      sky: true,
      guid: '',
      splitScreenUrl: undefined,
      workspaceInfoUrl: undefined,
      version: 1,
      hasVersions: false,
      lit: (swea.util.getQueryParameters().lit === '1'),
      textured: (swea.util.getQueryParameters().textured !== '0'),
      depthColored: false,
      lockModelPalette: (swea.util.getQueryParameters().lockModelPalette === '1'),
      lockImagePalette: (swea.util.getQueryParameters().lockImagePalette === '1'),
      lockModelInterval: (swea.util.getQueryParameters().lockModelInterval === '1'),
      lockImageInterval: (swea.util.getQueryParameters().lockImageInterval === '1'),
      visualizeCameras: false,
      visualizeCameraLines: this._visualizeCamerasOrdered,
      visualizedCameraThumbUrl: undefined,
      visualizedCameraName: undefined,
      visualizedCameraControl: false,
      visualizedCamerasInspected: false,
      visualizedCamerasScale: parseFloat(swea.util.getQueryParameters().cameraScale || 1.0),
      visualizedCamerasScaleDialogActive: false,
      textureLabels: false,
      labelClasses: undefined,
      reducedLabelClasses: undefined,
      distanceSlider: false,
      filterDefs: [],
      lang: swea.util.getQueryParameters().lang || 'en',
      helpOpen: false,
      annotationsToggled: true,
      annotationFilter: undefined,
      showAnnotationFilterPanel: false,
      measurementsToggled: true,
      gsdToggledPerType: gsdToggledPerType,
      copiedPose: undefined,
      copiedThermal: undefined,
      showLanguageMenu: false,
      showDebugMenu: false,
      modelInvisible: false,
      splatInvisible: false,
      invisibleInImage: true,
      classificationBacksides: false,
      contextMenuTaken: false,
      gotoModelUrl: undefined,
      helpLoaded: false,
      hasGsdPointCloud: false,
      comparisonImageUrl: undefined,
      comparisonMaskUrl: undefined,
      comparisonVersionName: '',
      currentVersionName: '',
      comparisonOpacity: 0.0,
      comparingVersions: false,
      visualizeMask: false,
      maskAvailableClasses: [],
      maskActiveClass: null,
      maskActive: false,
      versionDropdownOpen: false,
      sectionVolumesVisible: false,
      sectionVolumeToolActive: false
    };

    this._showMenuFromStart = false;
    this._viewer = undefined;
    this._progressScreen = undefined;
    this._startImperial = false;
    this._previousRadiometric = this._startRadiometric;
    this._supportsRadiometric = false;
    this._supportsDepthColor = false;
    this._headlampEnabled = false;
    this._cameraScaleInput = null;
    this._cameraScaleFromUserOrMeta = (swea.util.getQueryParameters().cameraScale !== undefined);
    this._otherTransparency = swea.util.getQueryParameters().otherTransparency || 0;
    this._changingVersionFromDropdown = false;
    this._versionDropdownRef = null;

    // Listen for 2D/3D state change
    ViewStateManager.instance().addListener(globals.STATE_CHANGED, this._stateChanged);

    // Get the correct model
    this._modelDirectory = swea.util.getQueryParameters().model;
    let modelPath = this._modelDirectory;
    this._modelIsPointCloud = false;
    this._pointSize = undefined;
    this._pointCircles = true;
    this._pointPixelSizeType = true;
    if (modelPath !== undefined) {
      if(modelPath.endsWith('/')){
        //Remove special sign which can cause labels not to load properly.
        modelPath = modelPath.slice(0, -1);
      }
      if (modelPath.endsWith('cloud.js') || modelPath.endsWith('cloud.json')) {
        // Potree point cloud
        this._modelIsPointCloud = true;
      }
      else if (modelPath.endsWith('.gltf')) {
        this._modelDirectory = swea.util.getUrlDirname(modelPath);
      }
      else {
        // Not a Potree point cloud or GLTF, add standard model.ogjs filename
        modelPath += '/model.osgjs';
      }
      this._modelPaths = [modelPath];
    }
    else {
      this._modelPaths = undefined;
    }

    // Get any separate block or inside model
    this._otherModelPath = swea.util.getQueryParameters().block;
    if (this._otherModelPath === undefined) {
      this._otherModelPath = swea.util.getQueryParameters().inside;
    }
    if (this._otherModelPath === undefined) {
      this._otherModelPath = swea.util.getQueryParameters().other;
    }

    if (this._otherModelPath !== undefined && (this._otherModelPath.endsWith('cloud.js') || this._otherModelPath.endsWith('cloud.json'))) {
      // Potree point cloud
      this._modelIsPointCloud = true;
    }

    // Get any collision model
    this._collisionModelPath = swea.util.getQueryParameters().collision;

    // Get any GSD model (only with debuggui)
    this._gsdModels = [];
    const gsdModelPathFromUrl = swea.util.getQueryParameters().gsd;
    if (swea.util.getQueryParameters().debuggui === '1' && gsdModelPathFromUrl !== undefined && (gsdModelPathFromUrl.endsWith('cloud.js') || gsdModelPathFromUrl.endsWith('cloud.json'))) {
      this._gsdModels.push({
        urls: [gsdModelPathFromUrl],
        type: GsdType.GENERAL
      });
      this._modelIsPointCloud = true;
    }

    // Get point cloud query parameters
    this._pointSize = swea.util.getQueryParameters().pointSize;
    this._pointCircles = (swea.util.getQueryParameters().pointCircles !== '0');
    this._pointPixelSizeType = (swea.util.getQueryParameters().pointPixelSizeType !== '0');

    this._skyModel = undefined;

    // Get any gaussian splat model (transform JSON according to splatfacto)
    this._splatModelPath = swea.util.getQueryParameters().splat;

    this._splatModel = undefined;
    if (this._splatModelPath !== undefined && this._modelDirectory === undefined) {
      // Support splat without model
      this._modelDirectory = swea.util.getUrlDirname(this._splatModelPath);
    }

    // NOTE: This seems to transform incorrectly on splat level, better to transform offline
    this._splatTransformPath = swea.util.getQueryParameters().splatTransform;

    // Render model to depth buffer for intersection only
    this._depthOnly = (swea.util.getQueryParameters().depthOnly === '1');

    // Fetch any top-right overlay HTML URL
    this._overlayUrl = swea.util.getQueryParameters().overlay;
    if (this._overlayUrl !== undefined && !this._overlayUrl.startsWith('http')) {
      this._overlayUrl = this._modelDirectory + '/' + this._overlayUrl;
    }

    this._annotationFieldUrl = swea.util.getQueryParameters().annotationfields;
    this._annotationFields = undefined;
    this._annotationFieldsControlColor = false;

    this._noLogo = swea.util.getQueryParameters().no_logo || swea.util.getQueryParameters().nologo;
    this._logo = swea.util.getQueryParameters().logo;
    this._logo2 = swea.util.getQueryParameters().logo2;
    this._progressLogo = swea.util.getQueryParameters().progresslogo;
    this._progressLogo2 = swea.util.getQueryParameters().progresslogo2;
    this._shadow = false;
    this._startShadow = (swea.util.getQueryParameters().startshadow === '1');
    this._timeControl = false;
    this._presentThresholdTemperature = false;
    this._linesMovable = false;
    this._polygonsMovable = false;
    this._linesClonable = false;
    this._polygonsClonable = false;

    this._handle = new Handle();
    this._baseModel = undefined;
    this._setupMetadata();

    this._shadowModelsPreLitStates = {};

    this._helpText = undefined;
    this._thirdPartyLicenseText = undefined;

    this._communicationId = undefined;
    const communication = swea.util.getQueryParameters().communication;
    if (communication !== undefined) {
      this._communicationId = parseInt(communication);
    }

    this._smartInspectImages = undefined;

    this._registerIframeEvents();

    // Set annotation boxes to be invisible in image view for mobile (doesn't work properly anyway)
    if (BrowserInfo.isMobile()) {
      AnnotationServiceActions.setInvisibleInImage(true);
    }

    // Set annotation default options with narrow window alternatives
    AnnotationServiceActions.setDefaultOptions({
      width: 128,
      height: 64,
      narrowWidth: 85,
      narrowHeight: 40,
      activeWidth: 52,
      narrowActiveWidth: 34,
      anchorPoint: [15, 58],
      narrowAnchorPoint: [10, 36],
      offset: [0.4, -3],
      narrowOffset: [0.4, -2.5],
      shortenedTextCharacterSize: 17.5,
      narrowShortenedTextCharacterSize: 14
    });

    this._idleTimeout = undefined;
    this._splitScreenSelectListener = undefined;

    // TODO: Remove when splitscreen works in image view!
    this._hideAnnotationInternalLinksInImage = true;

    this._loadingWorkspace = false;

    this._closeRefinementDialogListener = undefined;

    this._shaderPaletteInitialized = false;

    this._imageVisibilityModels = [];

    this._compass = undefined;
    this._altitude = undefined;
    this._axesIndicator = undefined;
    this._headlamp = undefined;

    this._storedGlobalIds = [];

    this._cylinderEye = undefined;
    this._cylinderTarget = undefined;
    this._animatingCylinderView = false;
    
    // Set default progress fractions
    this._modelProgressFraction = PROGRESS_MODEL_FRACTION;
    this._globalMappingsProgressFraction = 0.0;
    this._featureProgressFraction = 0.0;
    this._imageProgressFraction = 1.0 - PROGRESS_MODEL_FRACTION;
    this._currentProgressFactor = PROGRESS_MODEL_FRACTION;
    this._currentProgressOffset = 0.0;
  }

  _openWorkspace(workspaceGuid) {
    if (this.state.guid !== '' && swea.react.constants.globals.config.cloudServer !== undefined) {
      swea.util.addUrlParams({ cloudSave: workspaceGuid });
      this._setCloudSave(workspaceGuid);
      this._fetchToolConfig(swea.react.constants.globals.config.cloudServer).then(() => {
        this._setupInteractions();
        this.loadFromCloud();
        this._updateFromMetadata();
      });
    }
  }

  _closeWorkspace() {
    swea.util.removeUrlParams(['cloudSave']);
    EditorStateServiceActions.undoAll(true);
    EditorStateServiceActions.setCloudSaveReportActive(false);
    this._setCloudSave(undefined);
    this._fetchToolConfig(swea.react.constants.globals.config.cloudServer).catch((err) => {
      console.error(err);
      this._metadata === undefined;
      this._setupMetadata();
    }).finally(() => {
      this._updateFromMetadata();
      this.forceUpdate();

      // Remove any idle warning
      if (this._idleTimeout !== undefined) {
        clearTimeout(this._idleTimeout);
        this._idleTimeout = undefined;
      }

      // Remove any warn-before-leave-warning and add the empty event again to avoid expensive back-forwards cache
      window.removeEventListener('beforeunload', this._warnBeforeLeave);
      window.addEventListener('beforeunload', this._emptyBeforeUnload);

      // Reset next annotation number
      AnnotationService.instance().resetNextAnnotationNumber();
    });
  }

  // IBM: Zoom to defect bbox in given image
  // bbox: [<lower_left_horizontal_pixel>, <lower_left_vertical_pixel>, <upper_right_horizontal_pixel>, <upper_right_vertical_pixel>]
  _zoomImage(imageName, bbox) {
    if (imageName === undefined || imageName === '') {
      console.error('Invalid image name for zoomImage command.');
      return;
    }
    if (bbox === undefined || bbox.length !== 4) {
      console.error('Invalid bounding box for zoomImage command.');
      return;
    }

    const camera = InspectionAdapter.getCameraByName(imageName);
    if (camera === undefined) {
      console.error('Did not find ' + imageName + ' for zoomImage command.');
      return;
    }

    const llx = bbox[0];
    const lly = bbox[1];
    const urx = bbox[2];
    const ury = bbox[3];

    const sceneViewer = this._viewer.getSceneViewer();
    const eye = [0, 0, 0];
    const target = [0, 0, 0];
    sceneViewer.getViewFromCamera(camera, eye, target, [[llx, ury], [llx, lly], [urx, lly], [urx, ury]], 2.0);
    sceneViewer.flyToSimple(eye, target);
  }

  _registerIframeEvents() {
    if (this._communicationId !== undefined) {
      window.addEventListener('message', (evt) => {
        if (evt.data.id === this._communicationId) {
          switch (evt.data.command) {
            case 'thermal':
              this.toggleRadiometric();
              break;
            case 'classification':
              ToggleModelsServiceActions.toggle(evt.data.value);
              break;
            case 'openWorkspace':
              this._openWorkspace(evt.data.value);
              break;
            case 'closeWorkspace':
              this._closeWorkspace();
              break;
            case 'zoomImage':
              // IBM
              this._zoomImage(evt.data.image, evt.data.bbox);
              break;
            default:
              break;
          }
        }
      });
    }
  }

  _requireLogin(server, message) {
    if (server !== undefined) {
      alert(message);
      window.location = server + (server.endsWith('/') ? '' : '/') + 'login/';
    }
    else {
      alert('No connection to the Spotscale Cloud.');
      document.body.style.display = 'none';
    }
  }

  _refuse() {
    this._progressScreen.setState({
      text: '',
      showProgressBar: false
    });
    InstructionServiceActions.hideInstruction();
  }

  _disableToolsWithoutData() {
    if (this._metadata == undefined || this._metadata.tools == undefined) {
      return;
    }
    if ('togglemodels' in this._metadata.tools && swea.util.getQueryParameters().toggle === undefined) {
      delete this._metadata.tools.togglemodels;
    }
    if ('classification' in this._metadata.tools && swea.util.getQueryParameters().classification === undefined && this._metadata.classification === undefined) {
      delete this._metadata.tools.classification;
    }
    if ('catalog' in this._metadata.tools && this._cataloguePath === undefined) {
      delete this._metadata.tools.catalog;
    }
  }

  _openInternalLink = (url) => {
    this.setState({
      splitScreenUrl: url,
      showMenu: false
    });
    this.state.splitScreenUrl = url; // So that _setPortalOverlayVisibilityFromState reads new state
    this._setPortalOverlayVisibilityFromState();
    this._splitScreenSelectListener = ModelManager.instance().addListener(swea.react.constants.globals.SELECTED_MODEL_EVENT, this._updateSplitscreen);

    this._toggleInternalLinks();
  };

  _openSubModelLink = (url) => {
    // Get current pose
    const sceneViewer = this._viewer.getSceneViewer();
    const eye = [0, 0, 0];
    const center = [0, 0, 0];
    sceneViewer.getSimpleView(eye, center);
    if (swea.util.getVectorLength(eye) === 0.0 && swea.util.getVectorLength(center) === 0.0) {
      const up = [0, 0, 0];
      sceneViewer.getView(eye, center, up);
    }

    // Build back link and collect any parameters that we want to transport (help, language, decimals)
    let transportedParams = '';
    const urlParts = window.location.href.split('?');
    if (urlParts.length < 2) {
      // Shouldn't happen
      return;
    }
    let backParameters = '&eye=' + eye[0] + ',' + eye[1] + ',' + eye[2];
    backParameters += '&center=' + center[0] + ',' + center[1] + ',' + center[2];

    // Keep all parameters but eye and center in back link and collect parameters to transport to sub-model
    const parameters = urlParts[1].split('&');
    for (let i = 0; i < parameters.length; ++i) {
      const parameter = parameters[i];
      if (!(parameter.startsWith('eye=') || parameter.startsWith('center='))) {
        if (parameter.startsWith('model=')) {
          backParameters = '?' + parameter + backParameters;
        }
        else {
          backParameters += '&' + parameter;
        }
      }
      if (
        parameter.startsWith('help=') ||
        parameter.startsWith('lang=') ||
        parameter.startsWith('showlang=') ||
        parameter.startsWith('decimals=')
      ) {
        transportedParams += '&' + parameter;
      }
    }

    // Set model link and ask user (if not remembered)
    const subModelUrl = url + transportedParams + '&back=' + encodeURIComponent(urlParts[0] + backParameters);
    this.setState({
      gotoModelUrl: subModelUrl
    });
    if (DialogService.instance().getRememberedReply(swea.i18n.t('components.sub_model_dialog.title')) === true) {
      this._goToModel(subModelUrl);
    }
    else {
      DialogServiceActions.open({
        title: swea.i18n.t('components.sub_model_dialog.title'),
        text: swea.i18n.t('components.sub_model_dialog.text'),
        alignment: DialogService.AlignmentType.CENTER,
        small: true,
        yesNo: true,
        yesTooltip: swea.i18n.t('components.sub_model_dialog.yes'),
        noTooltip: swea.i18n.t('components.sub_model_dialog.no'),
        rememberCheckbox: true,
        rememberLabel: swea.i18n.t('components.sub_model_dialog.remember')
      });
    }
  };

  _exitSplitScreen = () => {
    if (this.state.splitScreenUrl !== undefined) {
      this.setState({
        splitScreenUrl: undefined,
        showMenu: this._showMenuFromStart
      });
      this.state.splitScreenUrl = undefined; // So that _setPortalOverlayVisibilityFromState reads new state
      this._setPortalOverlayVisibilityFromState();
    }
    if (this._splitScreenSelectListener !== undefined) {
      ModelManager.instance().removeListener(this._splitScreenSelectListener);
      this._splitScreenSelectListener = undefined;
    }
    this._viewer.getSceneViewer().stopMotion();

    this._toggleInternalLinks();
  };

  _updateSplitscreen = () => {
    const model = ModelManager.instance().getSelectedModel();
    if (model instanceof AnnotationModel) {
      this._exitSplitScreen();
      const url = model.getInternalLink();
      if (url !== undefined && url !== '') {
        this._openInternalLink(url);
      }
    }
  };

  _transportSettings(source, target) {
    if (source === undefined || target === undefined) {
      return;
    }
    for (const outerKey in source) {
      const sourcePart = source[outerKey];
      if (sourcePart === undefined) {
        continue;
      }
      if (outerKey in target) {
        // Key is already in current metadata but if pointing to an object
        // there can still be keys in this object not in corresponding object in current metadata
        if (typeof sourcePart === 'object') {
          const targetPart = target[outerKey];
          for (const innerKey in sourcePart) {
            if (innerKey == 'loadsave') {
              continue;
            }

            const value = sourcePart[innerKey];
            if (value !== undefined && !(innerKey in targetPart)) {
              targetPart[innerKey] = value;
            }
          }
        }
      }
      else {
        // Key is not in current metadata - transport! (value, object or array)
        target[outerKey] = sourcePart;
      }
    }
  }

  _fetchToolConfig(server) {
    return new Promise((resolve, reject) => {
      let configUrl = server + '/projects/' + this.state.guid + '/get_tool_config';
      const cloudSaveGuid = swea.util.getQueryParameters().cloudSave;
      if (cloudSaveGuid !== undefined) {
        configUrl += '/cloud_saves/' + cloudSaveGuid
      }
      HTTP.get(configUrl, '', null, null, true).then((res) => {
        // Transport certain settings from model metadata to avoid override from portal
        this._metadata.tools = (res.data.tools == undefined ? {} : res.data.tools);
        this._transportSettings(this._origMetadata, this._metadata);

        this._disableToolsWithoutData();
        this.forceUpdate();
        resolve();
      }).catch((res) => {
        if (res.status === 403) {
          reject('You don\'t have access to this model. You will be sent to the Spotscale Cloud, please login and try again.');
        }
        else {
          let debugInfo = 'Unknown error';
          if (res && res.status) {
            debugInfo = 'Status: ' + res.status;
          } else if (res && res.message) {
            debugInfo = 'Message: ' + res.message;
          }
          reject(`Failed to determine your permissions (DEBUG: ${debugInfo}). You will be sent to the Spotscale Cloud, please login in and try again.`);
        }
      });
    });
  }

  componentDidMount() {
    // Set any custom subload parameters
    // (budget here when viewer has been created and subload size in constructor before creating viewer and pager)
    const subloadTextureBudget = swea.util.getQueryParameters().texsubloadbudget;
    if (subloadTextureBudget !== undefined) {
      this._viewer.getSceneViewer().getPager().setSubloadTextureBudget(parseFloat(subloadTextureBudget));
    }
    const subloadGeometryBudget = swea.util.getQueryParameters().geomsubloadbudget;
    if (subloadGeometryBudget !== undefined) {
      this._viewer.getSceneViewer().getPager().setSubloadGeometryBudget(parseFloat(subloadGeometryBudget));
    }

    // Hide instructions until model has been loaded
    InstructionServiceActions.setHidden(true);

    // Register function opening internal links and sub-model links from annotations
    AnnotationServiceActions.registerInternalLinkFunction(this._openInternalLink);
    AnnotationServiceActions.registerSubModelLinkFunction(this._openSubModelLink);

    if (this._compass !== undefined) {
      // Initialize compass if not already initialized
      this._compass.initialize(this._viewer.getSceneViewer());
    }

    if (this._altitude !== undefined) {
      // Initialize altitude if not already initialized
      this._altitude.initialize(this._viewer.getSceneViewer());
    }

    // Add overlay html to top-right corner
    if (this._overlayUrl !== undefined && this._overlayDiv !== undefined) {
      HTTP.get(this._overlayUrl).then((res) => {
        this._overlayDiv.innerHTML = res.data;
      });
    }

    // Warn and refuse if Facebook or Instagram browser
    if (BrowserInfo.isFacebook() || BrowserInfo.isInstagram()) {
      const div = document.createElement('div');
      div.className = s.failText;
      const span1 = document.createElement('span');
      span1.innerHTML = 'Please open this link in your normal browser instead.<br/>Click ';
      div.appendChild(span1);
      const linkSpan = document.createElement('span');
      linkSpan.className = s.failLink;
      linkSpan.innerHTML = 'here';
      linkSpan.onclick = () => {
        this._copyLinkToClipboard();
      };
      div.appendChild(linkSpan);
      const span2 = document.createElement('span');
      span2.innerHTML = ' to copy the link to your clipboard.';
      div.appendChild(span2);
      document.body.appendChild(div);
      this._refuse();
      return;
    }

    // Override classification style
    Classification.colorMap = {
      'WINDOW': '#ff0000',
      'ROOF': '#ff00ff',
      'FACADE': '#0000ff',
      'DOOR': '#00ffff',
      'OTHER': '#00ff00'
    };
    Classification.contourColorMap = {
      'WINDOW': '#ffffff',
      'ROOF': '#ffffff',
      'FACADE': '#ffffff',
      'DOOR': '#ffffff',
      'OTHER': '#ffffff'
    };
    Classification.transparencyMap = { 'OTHER': 0.6 };

    const projectGuid = swea.util.getQueryParameters().project;
    if (projectGuid !== undefined) {
      this.setState({
        guid: projectGuid
      });
    }

    // Set strafe mode from URL
    if (swea.util.getQueryParameters().strafe === '1') {
      this._viewer.getSceneViewer().setStrafe(true);
    }

    // Add cloud save change handler
    EditorStateService.instance().addCloudSaveChangeListener(this.cloudSaveChangeHandler);

    // Add image favorite change handler
    FavoriteService.instance().addChangeListener(this.onFavoriteChange);

    // Listen for opening and closing image catalog
    ImageCatalogueService.instance().addChangeListener(this._onImageCatalogChange);

    // Listen for opening and closing model catalog
    ModelCatalogueService.instance().addChangeListener(this._onModelCatalogChange);

    // Listen for opening and closing of image viewer
    ImageViewerService.instance().addChangeListener(this._onImageViewerChange);

    // Listen for top or right dialogs to tell portal to hide top icons and for help to close
    DialogService.instance().addChangeListener(this._onDialogChange);

    // Listen for context menu to open, in order to close any label filter control to avoid collision
    ContextMenuStateService.instance().addChangeListener(this._onContextMenuChange);
    
    // Listen for lock annotation checkbox state
    AnnotationService.instance().addChangeListener(() => this.forceUpdate());

    // Listen for mask changes
    MaskService.instance().addChangeListener(this._onMaskChange);
    // Sync section volumes visibility state from ModelManager (bidirectional with filter panel)
    ModelManager.instance().addListener('sectionVolumesVisibleChanged', (visible) => {
      this.setState({ sectionVolumesVisible: visible });
    });

    // Set database path
    if (this._modelDirectory !== undefined && !this._modelIsPointCloud) {
      this._viewer.getSceneViewer().setDatabasePath(this._modelDirectory);
    }

    // Setup catalogue data
    this._cataloguePath = swea.util.getQueryParameters().catalog;
    if (this._cataloguePath === undefined) {
      this._cataloguePath = 'https://swearesourcestorage.blob.core.windows.net/urbancatalog';
    }

    // Get the model metadata (add random parameter to fool cache)
    const metadataPath = this._modelDirectory + '/metadata.json?' + Math.random();
    HTTP.get(metadataPath).then((res) => {
      // Warn and bail out if invalid JSON
      if (typeof res.data !== 'object') {
        DialogServiceActions.open({
          title: swea.i18n.t('components.metadata_warning.title'),
          text: swea.i18n.t('components.metadata_warning.text'),
          alignment: DialogService.AlignmentType.CENTER,
          small: true,
        });
        return;
      }

      this._metadata = res.data;

      // Set specific progress fractions
      if (this._metadata.texturelabels !== undefined && this._metadata.texturelabels.enabled && this._metadata.texturelabels.gisurl !== undefined && swea.util.getQueryParameters().nogis !== '1') {
        this._modelProgressFraction = PROGRESS_MODEL_FRACTION - PROGRESS_FEATURES_FRACTION - PROGRESS_GLOBAL_LABELS_FRACTION; // 0.99 - 0.7 - 0.2 = 0.09
        this._globalMappingsProgressFraction = PROGRESS_GLOBAL_LABELS_FRACTION; // 0.2
        this._featureProgressFraction = PROGRESS_FEATURES_FRACTION; // 0.7
        this._imageProgressFraction = 1.0 - this._featureProgressFraction - this._modelProgressFraction - this._globalMappingsProgressFraction; // 1 - 0.7 - 0.09 - 0.2 = 0.01
      }
    
      // Save original metadata before modifying, to be able to transport certain settings from it later
      this._origMetadata = swea.util.cloneObject(this._metadata);

      // Setup from metadata
      this._setupMetadata();

      // Check if model is locked
      if (this._metadata.locked) {
        window.location.href = 'locked.html';
        return;
      }

      // Set anisotropic texture filtering
      this._viewer.setTextureAnisotropy(this._metadata.environment.anisotropy === undefined ? DEFAULT_ANISOTROPY : this._metadata.environment.anisotropy);

      // Unlock any demo-locked tools from URL parameter
      if (swea.util.getQueryParameters().unlocktools === '1') {
        this._unlockTools();
      }
    }).catch(() => {
      console.warn('No metadata file.');
    }).finally(() => {
      // Disable any tools without required URL parameters
      this._disableToolsWithoutData();

      // Get overriding tool config from portal, if any
      const server = swea.react.constants.globals.config.cloudServer;
      if (this.state.guid !== '' && server !== undefined) {
        this._fetchToolConfig(server).then(() => {
          this._checkSpeed();
        }).catch((err) => {
          this._requireLogin(server, err);
        });
      }
      else {
        // Check connection speed
        this._checkSpeed();
      }
    });

    // prevents browser zoom
    document.addEventListener('keydown', this.handleKeyDown);
    document.addEventListener('wheel', this.handleWheel, { passive: false });

    // Close version dropdown when clicking outside
    document.addEventListener('mousedown', this._handleVersionDropdownClickOutside);
  }

  // This function prevents keyboard zoom
  handleKeyDown = (event) => {
    if (event.ctrlKey && ['=', '-', '+', '0'].includes(event.key)) {
      event.preventDefault();
    }
  };

  // This function prevents mouse wheel zoom
  handleWheel = (event) => {
    if (event.ctrlKey) {
      event.preventDefault();
    }
  };

  _checkSpeed() {
    if (this._modelDirectory !== undefined && this._modelDirectory.startsWith('https')) {
      const oneMegabyteFileUrl = swea.util.getUrlDirname(this._modelDirectory) + 'speed/1MB.bin';
      const startTime = new Date().getTime();
      HTTP.get(oneMegabyteFileUrl).then(() => {
        const elapsedTime = (new Date().getTime() - startTime) / 1000.0;
        const speed = 8.0 / elapsedTime;
        console.info('Measured speed: ' + swea.util.round(speed, 0.1) + ' Mbit/s');
        if (speed < SPEED_WARNING_LIMIT) {
          InstructionServiceActions.setHidden(false);
          InstructionServiceActions.showInstruction('instructions.speed_warning');
        }
      }).finally(() => {
        this._finishMounting();
      });
    }
    else {
      this._finishMounting();
    }
  }

  _includeHelp(key) {
    if (key.startsWith('debug_') && swea.util.getQueryParameters().debuggui === '1') {
      if (key === 'debug_togglegsd') {
        if (this._metadata.gsdModel === undefined && swea.util.getQueryParameters().gsd === undefined) {
          return false;
        }
      }
      else if (key === 'debug_togglecoveragegsd') {
        if (this._metadata.gsd === undefined || this._metadata.gsd.coverage === undefined) {
          return false;
        }
      }
      else if (key === 'debug_toggletexturegsd') {
        if (this._metadata.gsd === undefined || this._metadata.gsd.texture === undefined) {
          return false;
        }
      }
      return true;
    }
    if (key === 'help' && swea.util.getQueryParameters().help !== '0') {
      return true;
    }
    if (key === 'language' && swea.util.getQueryParameters().showlang === '1') {
      return true;
    }
    if (key === 'shadow' && swea.util.getQueryParameters().shadow === '1') {
      return true;
    }
    if (key === 'time' && swea.util.getQueryParameters().time === '1') {
      return true;
    }
    if ((key === 'togglecameras' || key === 'inspectcameras') && this._visualizeCameras) {
      return true;
    }
    if (key === 'inspectionhighlight' && swea.util.getQueryParameters().inspectionhighlight === '1') {
      return true;
    }
    if (key === 'annotationfields' && (this._metadata.annotationfields !== undefined || swea.util.getQueryParameters().annotationfields !== undefined)) {
      return true;
    }
    if (key === 'annotate_color' && !BrowserInfo.isMobile() && !this._annotationFieldsControlColor) {
      return true;
    }
    if (key === 'gsdpalette' && swea.util.getQueryParameters().debuggui === '1') {
      return true;
    }
    if (key === 'toggletexture' && swea.util.getQueryParameters().toggletexture === '1') {
      return true;
    }
    if (key === 'toggleclip' && ((this._metadata.tools.distance_slider === true && swea.util.getQueryParameters().nearclipslider !== '0' ) || swea.util.getQueryParameters().nearclipslider === '1')) {
      return true;
    }
    if (key === 'restart_measure') {
      // Other false values mean disabled "teasers", but restart_measure actually means disable
      return (this._metadata.tools[key] === true);
    }
    if (key === 'dashed' || key === 'delete_corner_points') {
      return true;
    }
    if (key === 'extrude') {
      return (this._metadata.tools.extrudemeasurements === true || swea.util.getQueryParameters().extrudemeasurements === '1');
    }
    if (!(key in this._metadata.tools)) {
      return false;
    }
    return (this._metadata.tools[key] === true);
  }

  _addHelpSections(sections) {
    // Key: From metadata.tools
    // Help element:
    // titles: Titles from tooltip section of locale, separated with /
    // text: Help text from help section of locale
    // icons: Icon .svg names, separated with /
    // dependencies: List of dependency tools, if they exist their names are added as suffix before searching the help section
    // additions: List of tools that if they exist will add sections with their names as suffixes
    for (const key in sections) {
      const section = sections[key];
      if (this._includeHelp(key)) {
        for (let i = 0; i < section.length; ++i) {
          const subSection = section[i];
          const dependencies = subSection.dependencies;
          let dependencySuffix = '';
          if (dependencies !== undefined) {
            for (let j = 0; j < dependencies.length; ++j) {
              if (this._includeHelp(dependencies[j])) {
                dependencySuffix += '_' + dependencies[j];
              }
            }
          }
          let text = i18n.t('help.' + subSection.text + dependencySuffix);
          if (BrowserInfo.isMobile()) {
            const touchText = i18n.t('help.' + subSection.text + dependencySuffix + '_touch');
            // Avoid same result string if there's no touch version
            if (touchText !== 'help.' + subSection.text + dependencySuffix + '_touch') {
              text = touchText;
            }
          }
          if (text === '') {
            continue;
          }

          const additions = subSection.additions;
          if (additions !== undefined) {
            for (let j = 0; j < additions.length; ++j) {
              if (this._includeHelp(additions[j])) {
                const additionKey = 'help.' + additions[j];
                const addedText = i18n.t(additionKey);
                if (BrowserInfo.isMobile()) {
                  const touchText = i18n.t(additionKey + '_touch');
                  if (touchText !== additionKey + '_touch') {
                    // If we don't want this addition for mobile we use an enpty _touch string
                    if (touchText !== '') {
                      text += '<br /><br />' + touchText;
                    }
                  }
                  else if (addedText !== additionKey) {
                    text += '<br /><br />' + addedText;
                  }
                }
                else if (addedText !== additionKey) {
                  text += '<br /><br />' + addedText;
                }
              }
            }
          }

          // Special cases
          if (key === 'thermal' && this._modelIsPointCloud && this._gsdModels.length > 0) {
            text += '<br /><br />' + i18n.t('help.thermal_gsd');
          }

          this._helpText += '<h4 class="helpTitle">';
          for (let j = 0; j < subSection.icons.length; ++j) {
            if (j > 0) {
              this._helpText += ' / &nbsp;';
            }
            this._helpText += '<img class="helpIcon" src="img/' + subSection.icons[j] + '" />';
          }
          this._helpText += ' ';
          for (let j = 0; j < subSection.titles.length; ++j) {
            if (j > 0) {
              this._helpText += ' / ';
            }
            this._helpText += i18n.t('tooltip.' + subSection.titles[j]);
          }
          this._helpText += '</h4><p class="helpText">';
          this._helpText += text;
          this._helpText += '</p>';
        }
      }
    }
  }

  _calculateWorkspaceInfoUrl(cloudSaveGuid) {
    return new Promise((resolve, reject) => {
      if (this._metadata.workspaceInfoBaseUrl === undefined) {
        reject();
      }
      let url = this._metadata.workspaceInfoBaseUrl;
      if (!url.endsWith('/')) {
        url += '/';
      }
      url += cloudSaveGuid + '/index.html';
      HTTP.get(url).then(() => {
        resolve(url);
      }).catch(() => {
        reject();
      });
    });
  }

  _setCloudSave(cloudSaveGuid) {
    let cloudSave = undefined;
    if (cloudSaveGuid !== undefined) {
      cloudSave = {
        guid: cloudSaveGuid,
        project_guid: this.state.guid
      };
    }
    EditorStateService.instance().setCurrentCloudSave(cloudSave);
    this.state.cloudSave = cloudSave; // For synchronous behavior after this function
    this.setState({ cloudSave: cloudSave });

    if (cloudSave !== undefined) {
      // Look for info belonging to this workspace
      this._calculateWorkspaceInfoUrl(cloudSaveGuid).then((url) => {
        this.state.workspaceInfoUrl = url; // For synchronous behavior after this function
        this.setState({
          workspaceInfoUrl: url
        });
      }).catch(() => {
      });
    }
  }

  _updateFromMetadata() {
    return new Promise((resolve) => {
      // Rotate upside-down cameras
      if (this._metadata.rotateUpsideDownCameras === true) {
        ImageViewerServiceActions.setRotateUpsideDownCameras(true);
      }

      // Set sections from metadata
      if (this._metadata.sections !== undefined) {
        AnnotationServiceActions.setSections(this._metadata.sections);
        // Create 3D volume sections from metadata (type "volume")
        if (this._viewer) {
          const sectionsReadOnly = (this._metadata.tools.sectionvolumes !== true);
          ModelManager.instance().setSectionsReadOnly(sectionsReadOnly);
          ModelManager.instance().createSectionsFromMetadata(this._metadata.sections, this._viewer.getId(), this._handle.getId());
          // Start with sections hidden, respecting read-only flag
          ModelManager.instance().setSectionVolumesVisible(false, sectionsReadOnly);
          this.setState({ sectionVolumesVisible: false });
        }
      }

      // Disable combined free/top toggle if ortho is active with separate free, side and top buttons
      if (this._metadata.tools.free_top_toggle !== undefined && this._metadata.tools.ortho) {
        delete this._metadata.tools.free_top_toggle;
      }

      // Rotation, if not overridden by query arguments
      if (swea.util.getQueryParameters().xrot === undefined) {
        if (this._metadata.view !== undefined && this._metadata.view.xrot !== undefined) {
          this._initialRotation[0] = this._metadata.view.xrot * Math.PI / 180.0;
        }
        else if (this._metadata.xrot !== undefined) {
          // Backward compatibility
          this._initialRotation[0] = this._metadata.xrot * Math.PI / 180.0;
        }
      }
      if (swea.util.getQueryParameters().yrot === undefined) {
        if (this._metadata.view !== undefined && this._metadata.view.yrot !== undefined) {
          this._initialRotation[1] = this._metadata.view.yrot * Math.PI / 180.0;
        }
        else if (this._metadata.yrot !== undefined) {
          // Backward compatibility
          this._initialRotation[1] = this._metadata.yrot * Math.PI / 180.0;
        }
      }
      if (swea.util.getQueryParameters().zrot === undefined) {
        if (this._metadata.view !== undefined && this._metadata.view.zrot !== undefined) {
          this._initialRotation[2] = this._metadata.view.zrot * Math.PI / 180.0;
        }
        else if (this._metadata.zrot !== undefined) {
          // Backward compatibility
          this._initialRotation[2] = this._metadata.zrot * Math.PI / 180.0;
        }
      }

      // Cylinder navigation
      if (this._metadata.view !== undefined && this._metadata.view.cylinderdiameter !== undefined) {
        this._viewer.getSceneViewer().setCylinderDiameter(this._metadata.view.cylinderdiameter);
      }
      if (this._metadata.view !== undefined && this._metadata.view.cylindereye !== undefined && this._metadata.view.cylindertarget !== undefined) {
        this._cylinderEye = this._metadata.view.cylindereye.slice();
        this._cylinderTarget = this._metadata.view.cylindertarget.slice();
      }

      // Camera visualization
      if (swea.util.getQueryParameters().cameras === undefined && this._metadata.cameras !== undefined) {
        this._visualizeCameras = this._metadata.cameras;
      }
      if (swea.util.getQueryParameters().orderedCameras === undefined && this._metadata.orderedCameras !== undefined) {
        this._visualizeCamerasOrdered = this._metadata.orderedCameras;
        this.setState({ visualizeCameraLines: this._visualizeCamerasOrdered });
      }
      if (swea.util.getQueryParameters().cameraScale === undefined && this._metadata.cameraScale !== undefined) {
        this._cameraScaleFromUserOrMeta = true;
        this.state.visualizedCamerasScale = parseFloat(this._metadata.cameraScale);
        this.setState({ visualizedCamerasScale: parseFloat(this._metadata.cameraScale) });
      }

      // Read smartinspect images from metadata
      if (this._metadata.smartinspect !== undefined) {
        this._smartInspectImages = this._metadata.smartinspect.images;
      }

      // Enable smart inspect if the tool is enabled
      InspectServiceActions.setSmartInspect(this._metadata.tools.smartinspect === true);

      // Enable annotation LODs
      AnnotationServiceActions.enableLods(this._metadata.tools.annotationlods === true, this._metadata.tools.annotationlodrange, this._metadata.tools.annotationlowlodrange);

      // Enable measurement LODs
      MeasureServiceActions.enableLods(this._metadata.tools.measurementlods === true, this._metadata.tools.measurementlodrange, this._metadata.tools.measurementlowlodrange);
      
      // Enable automatic annotation numbers
      AnnotationServiceActions.enableAutomaticNumbering(this._metadata.tools.annotationnumbers === true);

      // Enable movable annotations
      AnnotationServiceActions.enableMovableAnnotations(this._metadata.tools.movableannotations === true);
      
      // Present threshold temperature, let URL parameter override
      this._presentThresholdTemperature = (this._metadata.thermal !== undefined && this._metadata.thermal.presentThresholdTemperature);
      if (swea.util.getQueryParameters().presentThresholdTemperature === '1') {
        this._presentThresholdTemperature = true;
      }
      else if (swea.util.getQueryParameters().presentThresholdTemperature === '0') {
        this._presentThresholdTemperature = false;
      }

      // Enable move of lines and polygons (default false, override metadata with query argument both with 1 and 0)
      this._linesMovable = (this._metadata.tools.movelines === true);
      if (swea.util.getQueryParameters().movelines === '1') {
        this._linesMovable = true;
      }
      else if (swea.util.getQueryParameters().movelines === '0') {
        this._linesMovable = false;
      }
      ModelManager.instance().setLinesMovable(this._linesMovable);
      this._polygonsMovable = (this._metadata.tools.movepolygons === true);
      if (swea.util.getQueryParameters().movepolygons === '1') {
        this._polygonsMovable = true;
      }
      else if (swea.util.getQueryParameters().movepolygons === '0') {
        this._polygonsMovable = false;
      }
      ModelManager.instance().setPolygonsMovable(this._polygonsMovable);

      // Enable clone of lines and polygons (default false, override metadata with query argument both with 1 and 0)
      this._linesClonable = (this._metadata.tools.clonelines === true);
      if (swea.util.getQueryParameters().clonelines === '1') {
        this._linesClonable = true;
      }
      else if (swea.util.getQueryParameters().clonelines === '0') {
        this._linesClonable = false;
      }
      ModelManager.instance().setLinesClonable(this._linesClonable);
      this._polygonsClonable = (this._metadata.tools.clonepolygons === true);
      if (swea.util.getQueryParameters().clonepolygons === '1') {
        this._polygonsClonable = true;
      }
      else if (swea.util.getQueryParameters().clonepolygons === '0') {
        this._polygonsClonable = false;
      }
      ModelManager.instance().setPolygonsClonable(this._polygonsClonable);

      // Make lines occluded based on their picked normals or not (default true)
      ModelManager.instance().setOccludeLines(this._metadata.tools.occludeLines === undefined ? true : this._metadata.tools.occludeLines);

      // Let URL headlamp override metadata
      this._headlampEnabled = (this._metadata.environment.headlamp === true);
      if (swea.util.getQueryParameters().headlamp === '1') {
        this._headlampEnabled = true;
      }
      else if (swea.util.getQueryParameters().headlamp === '0') {
        this._headlampEnabled = false;
      }
      if (this._headlampEnabled) {
        InstructionServiceActions.showInstruction('instructions.headlamp');
        this.setState({
          lit: true
        });
      }

      this._setupInteractions();

      // Set strafe mode from metadata
      if (this._metadata.view.strafe) {
        this._viewer.getSceneViewer().setStrafe(true);
      }

      // Shadows controlled from metadata and overridden by URL
      this._shadow = (this._metadata.environment.shadow === true);
      if (swea.util.getQueryParameters().shadow === '1') {
        this._shadow = true;
      }
      else if (swea.util.getQueryParameters().shadow === '0') {
        this._shadow = false;
      }

      // Time tool controlled from metadata and overridden by URL
      this._timeControl = (this._metadata.tools !== undefined && this._metadata.tools.time === true);
      if (swea.util.getQueryParameters().time === '1') {
        this._timeControl = true;
      }
      else if (swea.util.getQueryParameters().time === '0') {
        this._timeControl = false;
      }

      // Listen for selection and deselection if user can show all measurements
      // NOTE: Previous checkbox replaced by toggle button behaving like the annotation toggle
      /*
      if (this._metadata.tools.togglemeasurements) {
        ModelManager.instance().addListener(swea.react.constants.globals.SELECTED_MODEL_EVENT, () => {
          this.toggleMeasurements(this.state.showAllMeasurements);
        });
        ModelManager.instance().addListener(swea.react.constants.globals.DESELECTED_MODEL_EVENT, () => {
          this.toggleMeasurements(this.state.showAllMeasurements);
        });
      }
      */

      // Listen for selected annotation model if user can switch between annotations
      if (this._metadata.tools.switchannotations) {
        ModelManager.instance().addListener(swea.react.constants.globals.SELECTED_MODEL_EVENT, () => {
          // Set directly to make _setPortalLowerRightLogoVisibilityFromState work below
          this.state.showSwitchAnnotations = (ModelManager.instance().getSelectedModel() instanceof AnnotationModel && !this.state.imageOpen && !this.state.catalogOpen);
          this.setState({
            showSwitchAnnotations: this.state.showSwitchAnnotations
          });
          this._setPortalLowerRightLogoVisibilityFromState();
        });
        ModelManager.instance().addListener(swea.react.constants.globals.DESELECTED_MODEL_EVENT, () => {
          // Set directly to make _setPortalLowerRightLogoVisibilityFromState work below
          this.state.showSwitchAnnotations = false;
          this.setState({
            showSwitchAnnotations: this.state.showSwitchAnnotations
          });
          this._setPortalLowerRightLogoVisibilityFromState();
        });
      }

      if (this._metadata.tools.thermal && this._metadata.thermal !== undefined && this._metadata.thermal.radiometricMin !== undefined && this._metadata.thermal.radiometricMax !== undefined) {
        this._supportsRadiometric = true;
        if (!this._shaderPaletteInitialized) {
          // Set radiometric palettes and limits, but only if not initialized previously (avoids reset when loading workspace)
          ShaderPaletteServiceActions.setPalettes(flirPalettes.palettes);
          ShaderPaletteServiceActions.setPaletteByName(this._palette, true, true);
          // Important to set image limits first and then model image, as we are in model now
          ShaderPaletteServiceActions.setPaletteLimits(this._radiometricLimitsImage[0], this._radiometricLimitsImage[1], false, true);
          ShaderPaletteServiceActions.setPaletteLimits(this._radiometricLimits[0], this._radiometricLimits[1], true, false);
          this._shaderPaletteInitialized = true;
        }

        // Set radiometric sync status, image filename prefix and extension
        ImageViewerService.instance().setRadiometricSynced(this._metadata.thermal.radiometricSynced !== false); // Default true
        ImageViewerService.instance().setRadiometricPrefix('thermal_');
        ImageViewerService.instance().setRadiometricExtension('png');
        ImageViewerService.instance().setRadiometricJpegExtension(this._metadata.thermal.jpegExtension);

        // Listen for radiometric mode change
        ShaderPaletteService.instance().addChangeListener(this._onShaderPaletteStateChange);
      }

      // Set pure-thermal specifically to know if we should check for radiometric prefix or not (can differ)
      if (this._metadata.thermal !== undefined && Object.keys(this._metadata.thermal).length > 0) {
        ImageViewerService.instance().setPureThermal(this._metadata.thermal.pure === true);
      }

      ImageViewerService.instance().setInspectionHighlight(this._metadata.tools.inspectionhighlight === true || swea.util.getQueryParameters().inspectionhighlight === '1');

      if (this._metadata.tools.depthcolor || swea.util.getQueryParameters().depthcolor === '1') {
        this._supportsDepthColor = true;
        ShaderPaletteServiceActions.setPalettes(depthPalettes.palettes);
      }

      // Restart measurement is default, make sure it's true (for help, etc.) if not specified
      this._metadata.tools.restart_measure = (this._metadata.tools.restart_measure === undefined ? true : this._metadata.tools.restart_measure);

      // Set compass, altitude and elevation from URL to work in help as well
      if (swea.util.getQueryParameters().compass === '1') {
        this._metadata.tools.compass = true;
      }
      if (swea.util.getQueryParameters().altitude === '1') {
        this._metadata.tools.altitude = true;
      }
      if (swea.util.getQueryParameters().elevation === '1') {
        this._metadata.tools.elevation = true;
      }
      if (swea.util.getQueryParameters().axes === '1') {
        this._metadata.tools.axes = true;
      }

      if (this._imageSelectInteraction !== undefined) {
        this._imageSelectInteraction.setForceOverlayViewer(this._metadata.tools.compass === true || this._metadata.tools.altitude === true);
      }

      // Annotation fields (if not from URL)
      if (this._annotationFieldUrl === undefined) {
        this._annotationFieldUrl = this._metadata.annotationfields;
      }

      // Load units if necessary
      let customUnitsUrl = '';
      if (swea.util.getQueryParameters().units !== undefined) {
        this._startImperial = (swea.util.getQueryParameters().units === 'imperial');

        // The units query argument can also be a URL to a custom units file
        if (swea.util.getQueryParameters().units.endsWith('.json')) {
          customUnitsUrl = swea.util.getQueryParameters().units;
        }
      }
      else if (this._metadata.tools.imperial !== undefined) {
        this._startImperial = this._metadata.tools.imperial;
      }

      if (customUnitsUrl) {
        // Read custom units
        UnitsAdapter.read(customUnitsUrl).catch(() => {
          console.error('Reading units failed!');
        }).finally(() => {
          resolve();
        });
      }
      else if (this._startImperial) {
        // Read imperial units
        UnitsAdapter.read('imperial').catch(() => {
          console.error('Reading units failed!');
        }).finally(() => {
          this.setState({
            imperial: true
          });
          resolve();
        });
      }
      else {
        resolve();
      }
    });
  }

  _finishMounting() {
    // Set versions

    // Backward compatible from array of URL strings
    if (this._metadata.versions !== undefined && this._metadata.versions.length > 0 && typeof this._metadata.versions[0] === 'string') {
      for (let i = 0; i < this._metadata.versions.length; ++i) {
        this._metadata.versions[i] = {
          url: this._metadata.versions[i]
        };
      }
    }

    let regularVersion = {
      name: '',
      url: this._modelDirectory
    };
    if (this._metadata.versions !== undefined && this._metadata.versions.length > 0) {
      for (let i = 0; i < this._metadata.versions.length; ++i) {
        if (this._metadata.versions[i].url === undefined || this._metadata.versions[i] === '') {
          regularVersion = this._metadata.versions[i];
          regularVersion.url = this._modelDirectory;
          this._metadata.versions.splice(i, 1);
          break;
        }
      }
    }

    VersionsServiceActions.setVersions(this._metadata.versions, regularVersion).finally(() => {
      const cloudSaveGuid = swea.util.getQueryParameters().cloudSave;
      if (this.state.guid !== '' && cloudSaveGuid !== undefined) {
        this._setCloudSave(cloudSaveGuid);
        this.loadFromCloud();
      }

      this._updateFromMetadata().then(() => {
        // Load any annotation fields (small so do it in parallel)
        if (this._annotationFieldUrl !== undefined) {
          HTTP.get(this._annotationFieldUrl).then((res) => {
            this._annotationFields = res.data;
            this._annotationFieldsControlColor = false;
            if (this._annotationFields !== undefined) {
              // Find out if any field controls the annotation color
              for (const name in this._annotationFields) {
                const field = this._annotationFields[name];
                if (
                  field.type === 'CHOICE' && field.colors !== undefined && field.values !== undefined &&
                  field.values.length > 0 && field.colors.length === field.values.length
                ) {
                  this._annotationFieldsControlColor = true;
                }
              }
            }
            this._injectSectionField();
          }).catch((err) => {
            console.warn('Failed loading annotation fields: ', err);
          });
        } else {
          this._injectSectionField();
        }

        if (this._modelPaths !== undefined) {
          this._metadataLoaded();
        }
        else {
          this._currentProgressFactor = 1.0;
          this._currentProgressOffset = 0.0;
          if (this._progressScreen !== undefined) {
            this._progressScreen.setState({
              text: '',
              totalFactor: this._currentProgressFactor,
              totalOffset: this._currentProgressOffset
            });
          }
          this._modelAndCamerasLoaded();
        }
      });
    });
  }
  
  /**
   * Called when metadata has been loaded.
   */
  _metadataLoaded() {
    if (this._metadata.texturelabels !== undefined && this._metadata.texturelabels.enabled) {
      // Set database path to support labels in multiple sub-models
      if (this._modelDirectory !== undefined) {
        TextureLabelAdapter.setDatabasePath(this._modelDirectory);
      }
      
      // Read label class names
      let classesUrl = 'classes.json';
      if (this._metadata.texturelabels.classesurl !== undefined) {
        classesUrl = this._metadata.texturelabels.classesurl;
        if (!classesUrl.startsWith('http')) {
          classesUrl = this._modelDirectory + '/' + classesUrl;
        }
      }
      HTTP.get(classesUrl).then((res) => {
        const labelClasses = res.data;
        const reducedLabelClasses = swea.util.cloneObject(labelClasses);
        if (this._metadata.texturelabels !== undefined && this._metadata.texturelabels.reducedclasses !== undefined) {
          // Filter given classes from metadata
          for (const key in labelClasses) {
            if (this._metadata.texturelabels.reducedclasses.indexOf(labelClasses[key].name) === -1) {
              delete reducedLabelClasses[key];
            }
          }
        }
        this.setState({
          labelClasses: labelClasses,
          reducedLabelClasses: reducedLabelClasses
        });
        TextureLabelAdapter.setClasses(labelClasses);
      }).catch((err) => {
        console.warn('Failed loading classes', err);
      }).finally(() => {
        this._loadBaseModel();
      });
    }
    else {
      this._loadBaseModel();
    }
  }

  _unlockTools() {
    if (this._metadata === undefined || this._metadata.tools === undefined) {
      return;
    }
    for (const key in this._metadata.tools) {
      if (this._metadata.tools[key] === false) {
        this._metadata.tools[key] = true;
      }
    }
  }

  _setupMetadata() {
    if (this._metadata === undefined || typeof this._metadata !== 'object') {
      this._metadata = {
        environment: {}, view: {}, thermal: {}
      };
    }
    this._metadata.tools = (this._metadata.tools === undefined ? {
      menu: true,
      undo_redo_delete: true,
      free_top_toggle: true,
      inspect: true,
      inspectionhighlight: true,
      measure: true,
      annotate: true,
      move: true,
      debug: false
    } : this._metadata.tools);
    this._metadata.view = (this._metadata.view === undefined ? {} : this._metadata.view);
    this._metadata.environment = (this._metadata.environment === undefined ? {} : this._metadata.environment);
    this._metadata.thermal = (this._metadata.thermal === undefined ? {} : this._metadata.thermal);
    this._metadata.cameraexclusions = (this._metadata.cameraexclusions === undefined ? [] : this._metadata.cameraexclusions);

    this._textureLabelsEnabled = (this._metadata.texturelabels !== undefined && this._metadata.texturelabels.enabled && this._metadata.tools.texturelabels);
    if (this._textureLabelsEnabled && swea.util.getQueryParameters().decimals === undefined) {
      // Set default accuracy to 0.1 mm if we have texture labels and decimals wasn't given on URL
      this.setState({
        measureAccuracy: 0.0001
      });
    }

    if (swea.util.getQueryParameters().filtercameratype === '1') {
      // Set it this way instead of checking query parameter later to make help addition work
      this._metadata.tools.filter_camera_type = true;
    }

    // Enable section volumes from URL
    if (swea.util.getQueryParameters().sectionvolumes === '1') {
      this._metadata.tools.sectionvolumes = true;
    }

    // Set exclusion from URL
    const getCameraExclusionsString = swea.util.getQueryParameters().cameraexclusions;
    if (typeof getCameraExclusionsString === 'string' && getCameraExclusionsString.length > 0) { //Handle as string if from URL
      InspectionAdapter.excludeCamerasByName(getCameraExclusionsString.split(','), true);
    }
  }

  _setupInteractions() {
    InteractionManager.instance().stopAllInteractions();
    InteractionManager.instance().removeAllContinuousInteractions();

    const shortcutCallbacks = {};
    if (this._metadata.tools.undo_redo_delete === true) {
      shortcutCallbacks[eventCodes.Z] = this.undo;
      shortcutCallbacks[eventCodes.Y] = this.redo;
    }
    if (this._textureLabelsEnabled) {
      shortcutCallbacks[eventCodes.E] = this.toggleTextureLabels;
    }
    if (this._metadata.tools.toggleannotations === true) {
      shortcutCallbacks[eventCodes.J] = this.toggleAnnotations;
    }
    if (this._metadata.tools.togglemeasurements === true) {
      shortcutCallbacks[eventCodes.M] = this.toggleMeasurements;
    }
    if (this._metadata.tools.toggletexture === true || swea.util.getQueryParameters().toggletexture === '1') {
      shortcutCallbacks[eventCodes.T] = this.toggleTexture;
    }
    if (this._splatModelPath !== undefined && swea.util.getQueryParameters().model !== undefined) {
      shortcutCallbacks[eventCodes.KEY_0] = this.toggleModelAboveSplat;
      shortcutCallbacks[eventCodes.KEY_9] = this.toggleSplat;
    }
    if (swea.util.getQueryParameters().debuggui === '1') {
      shortcutCallbacks[eventCodes.K] = this.toggleCameras;
      shortcutCallbacks[eventCodes.INSERT] = this.toggleModel;
      shortcutCallbacks[eventCodes.U] = this.toggleModelInImage;
      shortcutCallbacks[eventCodes.END] = this.toggleClassificationBacksides;
      shortcutCallbacks[eventCodes.L] = this.copyThermal;
      shortcutCallbacks[eventCodes.H] = this.toggleGsd.bind(this, GsdType.GENERAL);
      shortcutCallbacks[eventCodes.Q] = this.copyOrPastePose;
      shortcutCallbacks[eventCodes.F] = this.storeDisabledLabels;
    }

    shortcutCallbacks[eventCodes.PAGE_UP] = this.updateSensitivity;
    shortcutCallbacks[eventCodes.PAGE_DOWN] = this.updateSensitivity;
    shortcutCallbacks[eventCodes.HOME] = this.updateSensitivity;

    this._shortutInteraction = new ShortcutInteraction({ callbacks: shortcutCallbacks });

    const interactions = [this._shortutInteraction];

    const cylinder = (this._metadata.tools.cylinderview === true && this._metadata.view.cylinderdiameter !== undefined);
    if (swea.util.getQueryParameters().drag === '1' || cylinder) {
      this._dragViewInteraction = new DragViewInteraction({
        viewer: this._viewer.getSceneViewer(),
        buttons: (cylinder ? [0, 2] : 1),
        enabled: !cylinder
      });
      interactions.push(this._dragViewInteraction);
    }

    this._imageSelectInteraction = new CustomImageSelectionInteraction({
      enableFavorites: this._metadata.tools.filter === true,
      showDownload: this._metadata.tools.downloadimage !== false,
      showOrthogonalGsd: (swea.util.getQueryParameters().debug === '1' || swea.util.getQueryParameters().debuggui === '1'),
      orthogonalGsdTitle: swea.i18n.t('components.image_viewer.ortho_gsd_title'),
      forceOverlayViewer: (this._metadata.tools.compass === true || this._metadata.tools.altitude === true),
      filterCameraType: this._metadata.tools.filter_camera_type === true
    });

    this._textureLabelEyeDropperInteraction = undefined;
    if (this._metadata.tools.menu !== undefined) {
      if (this._metadata.tools.inspect !== undefined) {
        interactions.push(this._imageSelectInteraction);
      }
      if (this._metadata.tools.texturelabeleyedropper) {
        if (this._metadata.tools.texturelabeleyedropper) {
          const labelsActive = (
            this.state.textureLabels === true ||
            swea.util.getQueryParameters().labels === '1' ||
            (this._metadata.texturelabels !== undefined && this._metadata.texturelabels.enabled && this._metadata.texturelabels.active === true && swea.util.getQueryParameters().labels !== '0')
          );
          this._textureLabelEyeDropperInteraction = new CustomTextureLabelEyeDropperInteraction({
            enabled: labelsActive,
            initialPosition: this._initialPosition,
            initialRotation: this._initialRotation,
            callback: (swea.util.getQueryParameters().reportPickedLabels === '1' ? this.reportPickedLabels : undefined),
            imageSelectionInteraction: this._imageSelectInteraction
          });
          interactions.push(this._textureLabelEyeDropperInteraction);
        }
      }
      if (this._metadata.tools.transform || this._metadata.tools.sectionvolumes) {
        interactions.push(new HandleInteraction());
      }
      interactions.push(new CustomSelectInteraction({
        useBoxSelection: this._metadata.tools.classification === true && (swea.util.getQueryParameters().classification !== undefined || this._metadata.classification !== undefined),
        onlyAnnotations: false,
        extrude: this._metadata.tools.extrude === true
      }));
      if (this._metadata.tools.move) {
        interactions.push(new MoveInteraction());
      }
      if (this._metadata.tools.undo_redo_delete) {
        interactions.push(new DeleteInteraction());
      }
      if (swea.util.getQueryParameters().nozoom !== '1' && swea.util.getQueryParameters().lowerlimit === undefined) {
        this._flyToInteraction = new FlyToInteraction();
        interactions.push(this._flyToInteraction);
      }
      if (this._metadata.tools.debug || swea.util.getQueryParameters().debug === '1') {
        interactions.push(new DebugInteraction({ tileDebug: true, componentWithMenu: this }));
      }
      if ((this._visualizeCameras || swea.util.getQueryParameters().debuggui === '1') && !BrowserInfo.isMobile()) {
        this._cameraInteraction = new CameraInteraction({
          callback: this._showCameraSolo,
          lines: this.state.visualizeCameraLines,
          customScale: this.state.visualizedCamerasScale,
          radiometric: this._startRadiometric
        });
        interactions.push(this._cameraInteraction);
      }
    }
    if (this._metadata.tools.immediateinspect || swea.util.getQueryParameters().immediateinspect === '1') {
      this._immediateInspectInteraction = new CustomImmediateInspectInteraction({
        imageSelectionInteraction: this._imageSelectInteraction,
        remain: (this._metadata.tools.remainafterimmediateinspect || swea.util.getQueryParameters().remainafterimmediateinspect === '1')
      });
      interactions.push(this._immediateInspectInteraction);
    }
    this.setState({ interactions: interactions });
  }

  _showCameraSolo = (index, subset) => {
    const camera = InspectionAdapter.getCameraByIndex(index);
    this.setState({
      visualizedCameraName: (camera !== undefined && !subset ? camera.name : undefined),
      visualizedCameraThumbUrl: (camera !== undefined && !subset ? InspectionAdapter.getBaseUrl() + '/images/thumbs/' + camera.name : undefined),
      visualizedCameraControl: (camera !== undefined || subset)
    });

    if (this.state.visualizedCamerasInspected) {
      this.setState({
        visualizedCamerasInspected: false
      });
    }
  };

  _rotateHeadlampLeft = () => {
    this._viewer.getSceneViewer().rotateHeadlamp([-ROTATE_HEADLAMP_ANGLE, 0]);
  };

  _rotateHeadlampRight = () => {
    this._viewer.getSceneViewer().rotateHeadlamp([ROTATE_HEADLAMP_ANGLE, 0]);
  };

  _rotateHeadlampUp = () => {
    this._viewer.getSceneViewer().rotateHeadlamp([0, ROTATE_HEADLAMP_ANGLE]);
  };

  _rotateHeadlampDown = () => {
    this._viewer.getSceneViewer().rotateHeadlamp([0, -ROTATE_HEADLAMP_ANGLE]);
  };

  _clearHeadlampRotation = () => {
    this._viewer.getSceneViewer().clearHeadlampRotation();
  };

  _registerHeadlampKeys() {
    let headlampInterval = undefined;

    window.addEventListener('keydown', (evt) => {
      if (evt.shiftKey || evt.ctrlKey || headlampInterval !== undefined) {
        return;
      }
      switch (evt.keyCode) {
        case eventCodes.NUM_4:
          headlampInterval = setInterval(this._rotateHeadlampLeft, ROTATE_HEADLAMP_INTERVAL);
          break;
        case eventCodes.NUM_6:
          headlampInterval = setInterval(this._rotateHeadlampRight, ROTATE_HEADLAMP_INTERVAL);
          break;
        case eventCodes.NUM_8:
          headlampInterval = setInterval(this._rotateHeadlampUp, ROTATE_HEADLAMP_INTERVAL);
          break;
        case eventCodes.NUM_2:
          headlampInterval = setInterval(this._rotateHeadlampDown, ROTATE_HEADLAMP_INTERVAL);
          break;
        case eventCodes.NUM_5:
          this._clearHeadlampRotation();
          break;
        default:
          break;
      }
    });

    window.addEventListener('keyup', (evt) => {
      if (evt.shiftKey || evt.ctrlKey || headlampInterval === undefined) {
        return;
      }
      switch (evt.keyCode) {
        case eventCodes.NUM_4:
        case eventCodes.NUM_6:
        case eventCodes.NUM_8:
        case eventCodes.NUM_2:
          clearInterval(headlampInterval);
          headlampInterval = undefined;
          break;
        default:
          break;
      }
    });
  }

  _loadBaseModel() {
    let replaceTextureRules = undefined;
    if (this._metadata.thermal !== undefined && this._supportsRadiometric && this._metadata.thermal.radiometricMulti !== true && this._metadata.thermal.pure !== true) {
      // Replace with radiometric textures to start with if desired and not pure thermal
      replaceTextureRules = {
        fromPrefix: '',
        toPrefix: 'thermal_',
        fromExtension: 'jpg',
        toExtension: 'png'
      };
    }

    const usesSplat = (swea.util.getQueryParameters().splat !== undefined && swea.util.getQueryParameters().splat !== '');

    // Activate splat in ModelManager
    if (usesSplat) {
      ModelManager.instance().activateSplat();
    }

    // Load base model
    this._baseModel = new LoadedModel({
      paths: this._modelPaths,
      nodeOptions: {
        lit: this.state.lit,
        textured: this.state.textured,
        pickable: true,
        invisibleInImage: !this._textureLabelsEnabled,
        initialPosition: this._initialPosition,
        initialRotation: this._initialRotation,
        mask: traversalMasks.BASE_MODEL_MASK,
        castShadows: this._shadow,
        receiveShadows: this._shadow,
        depthOnly: this._depthOnly
      },
      modelOptions: {
        singleSided: true,
        flattenable: true,
        supportsRadiometric: this._supportsRadiometric,
        radiometricMulti: (this._metadata.thermal !== undefined && this._metadata.thermal.radiometricMulti === true),
        pureThermal: (this._metadata.thermal !== undefined && this._metadata.thermal.pure === true),
        supportsTextureLabels: this._textureLabelsEnabled,
        supportsDepthColor: this._supportsDepthColor
      },
      databasePath: (this._modelIsPointCloud ? '' : this._modelDirectory),
      progressCallback: this._progressScreen ? this._progressScreen.progressCallback : undefined,
      replaceTextureRules: replaceTextureRules,
      anisotropy: this._metadata.environment.anisotropy === undefined ? DEFAULT_ANISOTROPY : this._metadata.environment.anisotropy,
      pointSize: (this._pointSize !== undefined ? parseFloat(this._pointSize) : undefined),
      pointCircles: this._pointCircles,
      pointPixelSizeType: this._pointPixelSizeType
    });

    if (this._shadow && this._startShadow) {
      // Set lit afterwards if we want shadows to start with
      // (so that lit=false/undefined in options above leads to fake-lit at first)
      this._baseModel.enableLighting();
    }

    // Add the base model
    this._baseModel.whenLoaded().then(() => {
      try {
        // If we're using iframe communication we need to load any classifications now since user won't open the menu manually
        // NOTE: This was probably for the automatic small spinning demo on the website, but ruins usage in portal
        /*
        if (swea.util.getQueryParameters().communication !== undefined) {
          const classificationTogglePath = swea.util.getQueryParameters().classification;
          // TODO: If reintroduced, use this._metadata.classification as alternative
          if (classificationTogglePath !== undefined) {
            ToggleModelsServiceActions.read(classificationTogglePath, this._viewer.getId());
          }
        }
        */
        
        if (this._metadata.texturelabels !== undefined && this._metadata.texturelabels.enabled) {
          // Now that classes and base model are loaded, apply palette texture
          TextureLabelAdapter.applyPaletteTexture(this._baseModel.getMeshNode());
        }

        if (this._textureLabelsEnabled) {
          // Set any custom filters
          if (this._metadata.texturelabels !== undefined && this._metadata.texturelabels.enabled && this._metadata.texturelabels.filtersurl !== undefined && swea.util.getQueryParameters().notexturelabelfilter !== '1') {
            let filtersUrl = this._metadata.texturelabels.filtersurl;
            if (!filtersUrl.startsWith('http')) {
              filtersUrl = this._modelDirectory + '/' + filtersUrl;
            }

            HTTP.get(filtersUrl).then((res) => {
              const filterDefs = res.data.defs;

              // TEMP: Avoid filtering on length for now
              for (let i = 0; i < filterDefs.length; ++i) {
                if (filterDefs[i].name.toLowerCase().indexOf('length') > -1) {
                  filterDefs.splice(i, 1);
                  break;
                }
              }

              // Remove any invalid filters and override any limits from URL
              for (let i = 0; i < filterDefs.length; ++i) {
                const filterDef = filterDefs[i];
                const minUrlParamName = filterDef.name + '_min';
                const maxUrlParamName = filterDef.name + '_max';

                let urlMin = undefined;
                if (minUrlParamName in swea.util.getQueryParameters()) {
                  urlMin = parseFloat(swea.util.getQueryParameters()[minUrlParamName]);
                }

                let urlMax = undefined;
                if (maxUrlParamName in swea.util.getQueryParameters()) {
                  urlMax = parseFloat(swea.util.getQueryParameters()[maxUrlParamName]);
                }

                const stats = filterDef.stats;
                const classIndicesToBeRemoved = [];
                for (const classIndex in stats) {
                  const minMax = stats[classIndex];
                  if (urlMin !== undefined) {
                    minMax.min = urlMin;
                  }
                  if (urlMax !== undefined) {
                    minMax.max = urlMax;
                  }

                  if (minMax.min === minMax.max) {
                    classIndicesToBeRemoved.push(classIndex);
                  }
                }
                for (let j = 0; j < classIndicesToBeRemoved; ++j) {
                  delete stats[classIndicesToBeRemoved[j]];
                }
              }

              this.setState({
                filterDefs: filterDefs
              });
              TextureLabelAdapter.setFilterDefs(filterDefs);
            }).catch((err) => {
              console.warn('Failed loading texture label filters', err);
            });
          }

          // Set label adapter settings from metadata (independent of global labels)
          if (this._metadata.texturelabels !== undefined && this._metadata.texturelabels.enabled) {
            TextureLabelAdapter.setBinaryByteOffsets(this._metadata.texturelabels.binarybyteoffsets === true);
            TextureLabelAdapter.setHierarchical(this._metadata.texturelabels.hierarchical === true);
          }

          // Reads global label ID mapping if URL is given in metadata.
          if (this._metadata.texturelabels !== undefined && this._metadata.texturelabels.enabled && this._metadata.texturelabels.globalfilenames !== undefined) {
            this._currentProgressFactor = this._globalMappingsProgressFraction;
            this._currentProgressOffset = this._modelProgressFraction;
            let globalMappingsProgressCallback = undefined;
            if (this._progressScreen !== undefined) {
              this._progressScreen.setState({
                text: (this.state.showProgressText ? swea.i18n.t('components.progress.globalMappings') : ''),
                totalFactor: this._currentProgressFactor,
                totalOffset: this._currentProgressOffset
              });
              globalMappingsProgressCallback = (fraction) => {
                this._progressScreen.progressCallback(fraction);
              };
              this._progressScreen.progressCallback(0);
            }

            TextureLabelAdapter.readGlobalMappings(this._metadata.texturelabels.globalfilenames, globalMappingsProgressCallback).finally(() => {
              this._globalMappingsLoaded();
            }).catch((err) => {
              console.warn('Failed loading global IDs', err);
            });
          }
          else {
            this._globalMappingsLoaded();
          }
        }
        else {
          this._globalMappingsLoaded();
        }
      }
      catch (e) {
        console.error(e);
      }
    }).catch((e) => {
      console.error('Failed loading ' + this._modelPaths + '\n', e);
      alert('Oops! Invalid model link. Try another one.');
    });
  }

  /**
   * Called after global mappings has been loaded.
   * @private
   */
  _globalMappingsLoaded() {
    // Sets GIS (GeoPackage) URL for labels
    if (this._metadata.texturelabels !== undefined && this._metadata.texturelabels.enabled && this._metadata.texturelabels.gisurl !== undefined && swea.util.getQueryParameters().nogis !== '1') {
      this._currentProgressFactor = this._featureProgressFraction;
      this._currentProgressOffset = this._modelProgressFraction + this._globalMappingsProgressFraction;
      let featureProgressCallback = undefined;
      if (this._progressScreen !== undefined) {
        this._progressScreen.setState({
          text: (this.state.showProgressText ? swea.i18n.t('components.progress.features') : ''),
          totalFactor: this._currentProgressFactor,
          totalOffset: this._currentProgressOffset
        });
        featureProgressCallback = (evt) => {
          this._progressScreen.progressCallback(evt.loaded / evt.total);
        };
        this._progressScreen.progressCallback(0);
      }
      TextureLabelAdapter.setGisUrl(this._metadata.texturelabels.gisurl, this._metadata.offset, this._metadata.texturelabels.contoururl, featureProgressCallback).finally(() => {
        this._featuresLoaded();
      }).catch((err) => {
        console.error(err);
      });
    }
    else {
      this._featuresLoaded();
    }
  }
  
  /**
   * Called after loading features.
   * @private
   */
  _featuresLoaded() {
    if (this._metadata.texturelabels !== undefined && this._metadata.texturelabels.enabled && this._metadata.texturelabels.gisurl !== undefined && swea.util.getQueryParameters().nogis !== '1') {
      // Set any disabled GIS features
      if (this._metadata.texturelabels.disabledurl !== undefined) {
        let disabledUrl = this._metadata.texturelabels.disabledurl;
        if (!disabledUrl.startsWith('http')) {
          disabledUrl = this._modelDirectory + '/' + disabledUrl;
        }
        HTTP.get(disabledUrl).then((res) => {
          this._disableGlobalIds(res.data.globalids);
        }).catch((err) => {
          console.warn('Failed loading disabled features', err);
        });
      }

      // Set initial label color state (default is to color by filter)
      if (this._metadata.texturelabels.filtercolors === false || swea.util.getQueryParameters().labelfiltercolors === '0') {
        TextureLabelServiceActions.setLabelColoring(false);
      }
    }

    // Sky controlled from metadata and overridden by URL (default is true now)
    let sky = (this._metadata.environment.sky !== false && !this._headlampEnabled);
    if (swea.util.getQueryParameters().sky === '1') {
      sky = true;
    }
    else if (swea.util.getQueryParameters().sky === '0' || this._headlampEnabled) {
      sky = false;
    }
    if (sky) {
      // Default white background if sky or black if splat
      this.setState({
        sky: true,
        backgroundColor: (swea.util.getQueryParameters().background == undefined ? 'ffffff' : swea.util.getQueryParameters().background)
      });

      let minZ;
      try {
        minZ = this._baseModel.getBoundingBoxMin()[2];
      }
      catch (err) {
        err;
        minZ = 0.0;
      }

      const usesSplat = (swea.util.getQueryParameters().splat !== undefined && swea.util.getQueryParameters().splat !== '');

      this._skyModel = new SkyModel({
        nodeOptions: {
          initialPosition: [0, 0, minZ],
          invisibleInImage: true,
          enabled: !usesSplat
        },
        longitude: 15.623353,
        latitude: 58.410795,
        year: 2021,
        month: 6,
        day: 26,
        hour: 12,
        minute: 0,
        second: 0,
        /*ground: true,
        groundColor: [0.261, 0.300, 0.357],*/
        mirror: false
      });
      ViewerManager.instance().addModelToViewer(this._skyModel.getId(), this._viewer.getId());

      if (this._metadata.environment.limit) {
        this.setState({
          lowerElevationLimit: minZ
        });
      }
    }
    else {
      this.setState({
        sky: false,
        backgroundColor: swea.util.getQueryParameters().background
      });

      if (this._headlampEnabled) {
        // Headlamp
        this._headlamp = new DirectionalLight({
          lightOptions: {
            diffuse: [0.9, 0.9, 0.9],
            specular: [1.0, 1.0, 1.0],
            ambient: [0.4, 0.4, 0.4]
          }
        });
        ViewerManager.instance().addLightToViewer(this._headlamp.getId(), this._viewer.getId());
        this._viewer.getSceneViewer().setHeadlamp(this._headlamp);
        this._registerHeadlampKeys();
        this.setState({
          lit: true
        });
      }
      else if (this._metadata.environment.light) {
        // Sun light without sky
        const center = this._baseModel.getBoundingSphereCenter(true);
        const sun = new DirectionalLight({
          nodeOptions: {
            initialPosition: swea.util.addVectors(center, [-20000, -80000, 40000]),
            initialRotation: [Math.PI / 4.0, -Math.PI / 8.0, 0.0]
          },
          lightOptions: {
            diffuse: [0.8, 0.8, 0.8],
            specular: [1.0, 1.0, 1.0],
            ambient: [0.4, 0.4, 0.4]
          }
        });
        ViewerManager.instance().addLightToViewer(sun.getId(), this._viewer.getId());
      }
    }

    if (this._metadata.tools === undefined || this._metadata.prefetchcameras !== false) {
      // Update progress for camera fetching
      this._currentProgressFactor = this._imageProgressFraction;
      this._currentProgressOffset = this._modelProgressFraction + this._globalMappingsProgressFraction + this._featureProgressFraction;
      if (this._progressScreen !== undefined) {
        this._progressScreen.setState({
          text: (this.state.showProgressText ? swea.i18n.t('components.progress.images') : ''),
          totalFactor: this._currentProgressFactor,
          totalOffset: this._currentProgressOffset
        });
        this._progressScreen.progressCallback(0);
      }

      //Find camera to exclude when viewing images with the inspect tool.
      if (swea.util.getQueryParameters().cameraexclusions === undefined && this._metadata.cameraexclusions !== undefined) {
        InspectionAdapter.excludeCamerasByName(this._metadata.cameraexclusions); //Handle as array straight from metadata
      }

      // Fetch cameras
      InspectionAdapter.prefetchFiles(
        this._initialPosition,
        this._initialRotation,
        this._progressScreen ? this._progressScreen.progressCallback : undefined,
        this._metadata.camerameta,
        this._metadata.cameramappings
      ).catch(() => {
        if (this._metadata.tools !== undefined) {
          if ('inspect' in this._metadata.tools) {
            delete this._metadata.tools.inspect;
          }
          if ('refine_measure' in this._metadata.tools) {
            delete this._metadata.tools.refine_measure;
          }
          if ('texturelabeleyedropper' in this._metadata.tools) {
            delete this._metadata.tools.texturelabeleyedropper;
          }
          if ('filter_camera_type' in this._metadata.tools) {
            delete this._metadata.tools.filter_camera_type;
          }
        }
      }).finally(() => {
        // Flip versions tool, now that versions and version dates have been set
        const hasVersions = (VersionsService.instance().getState().versions !== undefined && VersionsService.instance().getState().versions.length > 0);
        this.setState({
          hasVersions: hasVersions
        });
        if (hasVersions) {
          VersionsService.instance().addChangeListener(this._onVersionsServiceChange);
        }

        // Clear progress text and set almost full progress
        // (in case hanging here on bad bandwidth and there actually were no images)
        this._currentProgressFactor = 1.0;
        this._currentProgressOffset = 0.0;
        if (this._progressScreen !== undefined) {
          this._progressScreen.setState({
            text: '',
            totalFactor: this._currentProgressFactor,
            totalOffset: this._currentProgressOffset
          });
        }
        this._progressScreen.progressCallback(0.99);

        if (swea.util.getQueryParameters().communication !== undefined && (swea.util.getQueryParameters().classification !== undefined || this._metadata.classification !== undefined)) {
          // Wait for classification
          ToggleModelsService.instance().whenLoaded().finally(() => {
            this._modelAndCamerasLoaded();
          });
        }
        else {
          this._modelAndCamerasLoaded();
        }
      });
    }
    else {
      // No cameras to load, but update progress as if there were
      if (this._progressScreen !== undefined) {
        this._currentProgressFactor = this._imageProgressFraction;
        this._currentProgressOffset = this._modelProgressFraction + this._globalMappingsProgressFraction + this._featureProgressFraction;
        this._progressScreen.setState({
          totalFactor: this._currentProgressFactor,
          totalOffset: this._currentProgressOffset
        });
        this._progressScreen.progressCallback(0);
      }

      if (swea.util.getQueryParameters().communication !== undefined && (swea.util.getQueryParameters().classification !== undefined || this._metadata.classification !== undefined)) {
        // Wait for classification
        ToggleModelsService.instance().whenLoaded().finally(() => {
          this._modelAndCamerasLoaded();
        });
      }
      else {
        this._modelAndCamerasLoaded();
      }
    }

    // Start with or without labels
    if (this._textureLabelsEnabled) {
      const labelsActive = (
        swea.util.getQueryParameters().labels === '1' ||
        (this._metadata.texturelabels !== undefined && this._metadata.texturelabels.enabled && this._metadata.texturelabels.active === true && swea.util.getQueryParameters().labels !== '0')
      );

      ModelManager.instance().setTextureLabels(labelsActive);
      if (labelsActive !== this.state.textureLabels) {
        this.state.textureLabels = labelsActive; // For _setPortalLowerRightLogoVisibilityFromState below
        this.setState({
          textureLabels: labelsActive
        });
        this._setPortalLowerRightLogoVisibilityFromState();
      }
    }
  }


  _loadHelp() {
    return new Promise((resolve) => {
      // Load help if activated
      if (swea.util.getQueryParameters().help !== '0') {
        HTTP.get('help.json').then((res) => {
          this._helpText = i18n.t('help.general');
          this._helpText += '<hr />';
          if (this._metadata.tools.cylinderview === true && this._metadata.view.cylinderdiameter !== undefined) {
            this._helpText += (BrowserInfo.isMobile() ? i18n.t('help.navigation_cylinder_touch') : i18n.t('help.navigation_cylinder'));
          }
          else {
            this._helpText += (BrowserInfo.isMobile() ? i18n.t('help.navigation_touch') : i18n.t('help.navigation'));
          }
          if (!BrowserInfo.isMobile() && this._metadata.view.strafe || swea.util.getQueryParameters().strafe === '1') {
            this._helpText += i18n.t('help.strafe');
          }
          if (this._backUrl !== undefined) {
            this._helpText += i18n.t('help.backfromsub');
          }
          if (!BrowserInfo.isMobile() && this._metadata.tools.texturelabeleyedropper) {
            this._helpText += '<h4>' + i18n.t('help.texturelabeleyedroppertitle') + '</h4>';
            this._helpText += i18n.t(TextureLabelAdapter.areGlobalIdsAvailable() && swea.util.getQueryParameters().nogis !== '1' ? 'help.texturelabeleyedropper_global' : 'help.texturelabeleyedropper');
          }
          if (!BrowserInfo.isMobile() && (this._metadata.tools.immediateinspect || swea.util.getQueryParameters().immediateinspect === '1')) {
            this._helpText += '<h4>' + i18n.t('help.immediateinspecttitle') + '</h4>';
            this._helpText += i18n.t('help.immediateinspect');
            if (this._metadata.tools.remainafterimmediateinspect || swea.util.getQueryParameters().remainafterimmediateinspect === '1') {
              this._helpText += ('<br /><br />' + i18n.t('help.remainafterimmediateinspect'));
            }
            else {
              this._helpText += ('<br /><br />' + i18n.t('help.exitafterimmediateinspect'));
            }
          }
          this._helpText += '<hr />';
          this._helpText += (BrowserInfo.isMobile() ? i18n.t('help.transformation_touch') : i18n.t('help.transformation'));
          if (!BrowserInfo.isMobile() && (this._metadata.tools.extrude || this._metadata.tools.catalog)) {
            this._helpText += i18n.t('help.transformation_clone');
          }
          if (!BrowserInfo.isMobile() && this._metadata.tools.classification && (swea.util.getQueryParameters().classification !== undefined || this._metadata.classification !== undefined)) {
            this._helpText += i18n.t('help.transformation_multiple');
          }
          if (!BrowserInfo.isMobile() && this._headlampEnabled) {
            this._helpText += i18n.t('help.headlamp');
          }
          this._helpText += '<hr />';
          this._helpText += i18n.t('help.basic');
          this._addHelpSections(res.data.basic);
          if (swea.util.getQueryParameters().debuggui === '1') {
            this._helpText += '<hr />';
            this._helpText += i18n.t('help.debug');
            this._addHelpSections(res.data.debug);
          }
          this._helpText += '<hr />';
          this._helpText += i18n.t('help.tools');
          this._addHelpSections(res.data.tools);
          this._helpText += '<hr />';

          HTTP.get('licenses.json').then((licres) => {
            this._helpText += '<h3>' + i18n.t('help.thirdparty') + '</h3>';
            this._helpText += i18n.t('help.thirdpartytext');
            this._thirdPartyLicenseText = '';
            for (const name in licres.data) {
              this._thirdPartyLicenseText += '<h4>' + name + '</h4>';
              this._thirdPartyLicenseText += '<div style="font-size: 0.65em;">';
              this._thirdPartyLicenseText += swea.util.addLineBreaks(licres.data[name], 120, true);
              this._thirdPartyLicenseText += '</div>';
            }
          }).finally(() => {
            this.setState({
              helpLoaded: true
            });
            resolve();
          });
        }).catch(() => {
          this.setState({
            helpLoaded: true
          });
          resolve();
        });
      }
      else {
        resolve();
      }
    });
  }

  _modelAndCamerasLoaded() {
    // Load help
    this._loadHelp();

    // Load any block or inside model, double-sided and non-pickable, but first check if there is any such path in metadata
    if (this._otherModelPath === undefined && this._metadata !== undefined) {
      this._otherModelPath = this._metadata.otherModel;
    }
    if (this._otherModelPath !== undefined && this._otherModelPath !== '') {
      if (!this._otherModelPath.startsWith('http')) {
        this._otherModelPath = this._modelDirectory + '/' + this._otherModelPath;
      }

      const otherModel = new LoadedModel({
        paths: [this._otherModelPath],
        nodeOptions: {
          lit: (swea.util.getQueryParameters().otherLit === '1'),
          resetDepth: (swea.util.getQueryParameters().otherAlwaysVisible === '1'),
          pickable: false,
          invisibleInImage: true,
          initialPosition: swea.util.addVectors(this._initialPosition, this._otherInitialPosition),
          initialRotation: swea.util.addVectors(this._initialRotation, this._otherInitialRotation)
        },
        modelOptions: {
          flattenable: true,
          singleSided: false,
          transparency: this._otherTransparency,
        },
        pointSize: (this._pointSize !== undefined ? parseFloat(this._pointSize) : undefined),
        pointCircles: this._pointCircles,
        pointPixelSizeType: this._pointPixelSizeType
      });

      // Add the other model
      otherModel.whenLoaded().then(() => {
        ViewerManager.instance().addModelToViewer(otherModel.getId(), this._viewer.getId());
        this._otherModelLoaded();
      });
    }
    else {
      this._otherModelLoaded();
    }
  }

  _otherModelLoaded() {
    // Load any collision model, but first check if there is any such path in metadata
    if (this._collisionModelPath === undefined && this._metadata !== undefined) {
      this._collisionModelPath = this._metadata.collisionModel;
    }
    if (this._collisionModelPath !== undefined && this._collisionModelPath !== '') {
      if (!this._collisionModelPath.startsWith('http')) {
        this._collisionModelPath = this._modelDirectory + '/' + this._collisionModelPath;
      }

      const collisionModel = new LoadedModel({
        paths: [this._collisionModelPath],
        nodeOptions: {
          enabled: true,
          pickable: false,
          initialPosition: this._initialPosition,
          initialRotation: this._initialRotation
        }
      });

      // Add the collision model
      collisionModel.whenLoaded().then(() => {
        this._viewer.getSceneViewer().addCollisionModel(collisionModel, this._metadata.collisionDelta);
        this._collisionModelLoaded();
      });
    }
    else {
      this._collisionModelLoaded();
    }
  }

  _collisionModelLoaded() {
    // Load any plane model for isect
    if (this._metadata !== undefined && this._metadata.planes !== undefined && this._metadata.planes !== '') {
      const planeModel = new LoadedModel({
        path: this._modelDirectory + '/' + this._metadata.planes,
        nodeOptions: {
          pickable: true,
          lit: false,
          enabled: false,
          initialPosition: this._initialPosition,
          initialRotation: this._initialRotation,
          mask: traversalMasks.ISECT_MASK
        },
        modelOptions: {
          singleSided: true
        }
      });

      // Add the block model
      planeModel.whenLoaded().then(() => {
        ViewerManager.instance().addModelToViewer(planeModel.getId(), this._viewer.getId());
        this._planeModelLoaded();
      });
    }
    else {
      this._planeModelLoaded();
    }
  }

  _planeModelLoaded() {
    // Load any GSD model (only with debuggui)
    let numGsdModels = this._gsdModels.length;
    if (swea.util.getQueryParameters().debuggui === '1' && numGsdModels === 0 && this._metadata !== undefined && this._metadata.gsd !== undefined) {
      // No GSD models from URL, take from metadata
      if (this._metadata.gsdModel !== undefined) {
        this._gsdModels.push({
          urls: [this._metadata.gsdModel],
          type: GsdType.GENERAL
        });
      }
      if (this._metadata.gsd.coverage !== undefined) {
        this._gsdModels.push({
          urls: this._metadata.gsd.coverage,
          type: GsdType.COVERAGE
        });
      }
      if (this._metadata.gsd.texture !== undefined) {
        this._gsdModels.push({
          urls: this._metadata.gsd.texture,
          type: GsdType.TEXTURE
        });
      }
    }

    numGsdModels = this._gsdModels.length;
    if (numGsdModels > 0) {
      const gsdPromises = [];
      let anyGsdPointCloud = false;
      for (let i = 0; i < numGsdModels; ++i) {
        const gsdModelPaths = this._gsdModels[i].urls;
        for (let j = 0; j < gsdModelPaths.length; ++j) {
          const gsdModelPath = gsdModelPaths[j];
          if (!gsdModelPath.startsWith('http')) {
            gsdModelPaths[j] = this._modelDirectory + '/' + gsdModelPath;
          }
          if (gsdModelPath.endsWith('cloud.js') || gsdModelPath.endsWith('cloud.json')) {
            // Enable palettes if GSD point cloud (and not thermal since that would collide)
            if (!this._supportsRadiometric) {
              ShaderPaletteServiceActions.setPalettes(flirPalettes.palettes);
              ShaderPaletteServiceActions.setPaletteByName(this._palette, true, true);
            }

            this._modelIsPointCloud = true;
            anyGsdPointCloud = true;
          }
        }

        const gsdModel = new LoadedModel({
          paths: gsdModelPaths,
          nodeOptions: {
            enabled: false,
            lit: false,
            pickable: false,
            invisibleInImage: true,
            initialPosition: this._initialPosition,
            initialRotation: this._initialRotation,
            resetDepth: this._modelIsPointCloud
          },
          modelOptions: {
            flattenable: false,
            singleSided: false
          },
          gsd: true,
          pointSize: (this._pointSize !== undefined ? parseFloat(this._pointSize) : undefined),
          maxGsd: swea.util.getQueryParameters().maxgsd
        });

        this._gsdModels[i].model = gsdModel;
        gsdPromises.push(gsdModel.whenLoaded());
      }

      Promise.all(gsdPromises).then(() => {
        if (anyGsdPointCloud) {
          this.setState({
            hasGsdPointCloud: true
          });
        }

        for (let i = 0; i < this._gsdModels.length; ++i) {
          ViewerManager.instance().addModelToViewer(this._gsdModels[i].model.getId(), this._viewer.getId());
        }
        this._gsdModelsLoaded();
      });
    }
    else {
      this._gsdModelsLoaded();
    }
  }

  _gsdModelsLoaded() {
    this._progressScreen.progressCallback(1.0);

    // Tell portal we're done loading
    this._setPortalOverlayVisibilityFromState();
    this._setPortalLowerRightLogoVisibilityFromState();

    // Show instructions again
    InstructionServiceActions.setHidden(false);

    // Activate OpenSeadragon if metadata says so
    if (this._metadata.openseadragon && swea.util.getQueryParameters().openseadragon !== '0') {
      ImageViewerServiceActions.useDeepZoomViewer(true, this._metadata.dzia === true);
    }

    // Load mask manifest for mask visualization
    const maskBaseUrl = InspectionAdapter.getBaseUrl();
    if (this._metadata.visualizemasks && maskBaseUrl) {
      MaskServiceActions.loadClasses(maskBaseUrl);
    }

    // Set decimals from metadata if available and not overridden by URL
    if (swea.util.getQueryParameters().decimals === undefined && this._metadata.decimals !== undefined) {
      this.setState({
        measureAccuracy: (this._metadata.decimals === undefined ? 0.01 : 1.0 / Math.pow(10.0, parseFloat(this._metadata.decimals)))
      });
    }

    // Menu controlled from metadata and overridden from URL
    this._showMenuFromStart = (this._metadata.tools.menu === true);
    if (swea.util.getQueryParameters().menu === '1') {
      this._showMenuFromStart = true;
    }
    else if (swea.util.getQueryParameters().menu === '0') {
      this._showMenuFromStart = false;
    }
    this.setState({
      showMenu: this._showMenuFromStart,
      showControlsOutsideMenu: this._showMenuFromStart
    });
    if (this._baseModel !== undefined) {
      ViewerManager.instance().addModelToViewer(this._baseModel.getId(), this._viewer.getId());
    }
    this._viewer.home();

    if (this._metadata.thermal !== undefined && Object.keys(this._metadata.thermal).length > 0) {
      // New multi-texture thermal mode
      ShaderPaletteServiceActions.setMulti(this._metadata.thermal !== undefined && this._metadata.thermal.radiometricMulti === true);

      // Min/max
      ShaderPaletteServiceActions.setMinMax(
        this._metadata.thermal !== undefined && this._metadata.thermal.radiometricMin !== undefined ? this._metadata.thermal.radiometricMin : 0,
        this._metadata.thermal !== undefined && this._metadata.thermal.radiometricMax !== undefined ? this._metadata.thermal.radiometricMax : 65535,
      );
    }

    // Startup status
    if (swea.util.getQueryParameters().ir !== undefined) {
      this._startRadiometric = (swea.util.getQueryParameters().ir === '1');
    }
    else if (this._metadata.thermal !== undefined) {
      this._startRadiometric = (this._metadata.thermal.ir === true || this._metadata.thermal.pure === true);
    }
    this._previousRadiometric = this._startRadiometric;
    ShaderPaletteServiceActions.setRadiometric(this._startRadiometric);

    if (this._metadata.thermal !== undefined && Object.keys(this._metadata.thermal).length > 0) {
      // Palette (if not overriden in URL)
      if (this._metadata.thermal.palette !== undefined && !this._paletteFromUrl) {
        this._palette = this._metadata.thermal.palette;
      }
      ShaderPaletteServiceActions.setPaletteByName(this._palette, true, true);

      // Limits (if not overriden in URL)
      if (this._metadata.thermal.irlow !== undefined && !this._lowLimitFromUrl) {
        this._radiometricLimits[0] = this._metadata.thermal.irlow;
      }
      if (this._metadata.thermal.irhigh !== undefined && !this._highLimitFromUrl) {
        this._radiometricLimits[1] = this._metadata.thermal.irhigh;
      }
      if (!this._lowLimitImageFromUrl) {
        if (this._metadata.thermal.irlowimage !== undefined) {
          this._radiometricLimitsImage[0] = this._metadata.thermal.irlowimage;
        }
        else {
          this._radiometricLimitsImage[0] = this._radiometricLimits[0];
        }
      }
      if (!this._highLimitImageFromUrl) {
        if (this._metadata.thermal.irhighimage !== undefined) {
          this._radiometricLimitsImage[1] = this._metadata.thermal.irhighimage;
        }
        else {
          this._radiometricLimitsImage[1] = this._radiometricLimits[1];
        }
      }
      // Important to set image limits first and then model image, as we are in model now
      ShaderPaletteServiceActions.setPaletteLimits(this._radiometricLimitsImage[0], this._radiometricLimitsImage[1], false, true);
      ShaderPaletteServiceActions.setPaletteLimits(this._radiometricLimits[0], this._radiometricLimits[1], true, false);

      // Locks (if not overridden in URL)
      if (this._metadata.thermal.lockModelPalette !== undefined && !this._lockModelPaletteFromUrl) {
        this.setState({
          lockModelPalette: this._metadata.thermal.lockModelPalette
        });
      }
      if (this._metadata.thermal.lockImagePalette !== undefined && !this._lockImagePaletteFromUrl) {
        this.setState({
          lockImagePalette: this._metadata.thermal.lockImagePalette
        });
      }
      if (this._metadata.thermal.lockModelInterval !== undefined && !this._lockModelIntervalFromUrl) {
        this.setState({
          lockModelInterval: this._metadata.thermal.lockModelInterval
        });
      }
      if (this._metadata.thermal.lockImageInterval !== undefined && !this._lockImageIntervalFromUrl) {
        this.setState({
          lockImageInterval: this._metadata.thermal.lockImageInterval
        });
      }
    }

    // Retrieve toggle models path from URL
    const togglePath = swea.util.getQueryParameters().toggle;
    if (togglePath !== undefined) {
      ToggleModelsServiceActions.read(togglePath, this._viewer.getId());
    }

    // (classifications are not loaded until clicking the button)

    // Load file from storage if the load URL parameter was specified
    const loadPath = swea.util.getQueryParameters().load;
    if (loadPath !== undefined) {
      this.loadFromDisk(loadPath);
    }

    // Move to any initial viewpoint
    this._initialEye = (swea.util.getQueryParameters().eye !== undefined ? swea.util.getQueryParameters().eye.split(',').map(Number) : undefined);
    if (this._initialEye === undefined) {
      this._initialEye = (this._metadata.view ? this._metadata.view.eye : undefined);
      if (swea.util.getQueryParameters().cylinder === '1' && this._cylinderEye !== undefined) {
        this._initialEye = this._cylinderEye;
      }
    }
    this._initialCenter = (swea.util.getQueryParameters().center !== undefined ? swea.util.getQueryParameters().center.split(',').map(Number) : undefined);
    if (this._initialCenter === undefined) {
      this._initialCenter = (this._metadata.view ? this._metadata.view.center : undefined);
      if (swea.util.getQueryParameters().cylinder === '1' && this._cylinderTarget !== undefined) {
        this._initialCenter = this._cylinderTarget;
      }
    }
    if (this._initialEye !== undefined && this._initialCenter !== undefined && this._metadata.view.flyToTop !== true && this._metadata.view.top !== true) {
      this._viewer.getSceneViewer().setSimpleView(this._initialEye, this._initialCenter);
      this.setState({
        copiedPose: { eye: this._initialEye, center: this._initialCenter }
      });
    }

    // Initial cylinder view
    if (swea.util.getQueryParameters().cylinder === '1' && this._cylinderEye !== undefined && this._cylinderTarget !== undefined) {
      if (this._flyToInteraction !== undefined) {
        this._flyToInteraction.disable();
      }
      this._viewer.getSceneViewer().setCylinderManipulator(false).then(() => {
        this.setState({
          viewType: ViewType.CYLINDER
        });
      }).catch(() => {
        InstructionServiceActions.showInstruction('instructions.failed_cylinder');

        if (this._flyToInteraction !== undefined) {
          this._flyToInteraction.enable();
        }
      });
    }

    // Viewer limits
    let pitchUpLimit = swea.util.getQueryParameters().pitchUpLimit;
    let pitchDownLimit = swea.util.getQueryParameters().pitchDownLimit;
    let yawLeftLimit = swea.util.getQueryParameters().yawLeftLimit;
    let yawRightLimit = swea.util.getQueryParameters().yawRightLimit;
    let zoomOutLimit = swea.util.getQueryParameters().zoomOutLimit;
    let zoomInLimit = swea.util.getQueryParameters().zoomInLimit;

    // If cylinder view is available, relax pitch limit
    if (this._metadata.tools.cylinderview === true) {
      pitchDownLimit = -89.5;
    }

    if (this._metadata.view !== undefined) {
      pitchUpLimit = (pitchUpLimit !== undefined ? pitchUpLimit : this._metadata.view.pitchUpLimit);
      pitchDownLimit = (pitchDownLimit !== undefined ? pitchDownLimit : this._metadata.view.pitchDownLimit);
      yawLeftLimit = (yawLeftLimit !== undefined ? yawLeftLimit : this._metadata.view.yawLeftLimit);
      yawRightLimit = (yawRightLimit !== undefined ? yawRightLimit : this._metadata.view.yawRightLimit);
      zoomOutLimit = (zoomOutLimit !== undefined ? zoomOutLimit : this._metadata.view.zoomOutLimit);
      zoomInLimit = (zoomInLimit !== undefined ? zoomInLimit : this._metadata.view.zoomInLimit);
      if (pitchUpLimit !== undefined) {
        this._viewer.getSceneViewer().setPitchUpLimit(pitchUpLimit * Math.PI / 180.0);
      }
      if (pitchDownLimit !== undefined) {
        this._viewer.getSceneViewer().setPitchDownLimit(pitchDownLimit * Math.PI / 180.0);
      }
      if (yawLeftLimit !== undefined) {
        this._viewer.getSceneViewer().setYawLeftLimit(yawLeftLimit * Math.PI / 180.0);
      }
      if (yawRightLimit !== undefined) {
        this._viewer.getSceneViewer().setYawRightLimit(yawRightLimit * Math.PI / 180.0);
      }
      if (zoomOutLimit !== undefined) {
        this._viewer.getSceneViewer().setZoomOutLimit(zoomOutLimit);
      }
      if (zoomInLimit !== undefined) {
        this._viewer.getSceneViewer().setZoomInLimit(zoomInLimit);
      }
    }

    // Freeze pitch, rotation, pan and zoom
    if (swea.util.getQueryParameters().nopitch === '1') {
      this._viewer.getSceneViewer().forcePitch();
    }
    if (swea.util.getQueryParameters().norotation === '1') {
      this._viewer.getSceneViewer().freezeRotation();
    }
    if (swea.util.getQueryParameters().nopan === '1') {
      this._viewer.getSceneViewer().freezePan();
    }
    if (swea.util.getQueryParameters().nozoom === '1') {
      this._viewer.getSceneViewer().freezeZoom();
    }

    // Set initial auto-rotation
    if (swea.util.getQueryParameters().rpm !== undefined) {
      this._viewer.getSceneViewer().setAutoRotation(swea.util.getQueryParameters().rpm);
    }

    if (this._metadata.view.top) {
      this._viewer.getSceneViewer().detachSkyModel();
      this._viewer.getSceneViewer().forcePitch(Math.PI / 2.0);
      this._viewer.getSceneViewer().setOrthographic();
      this._viewer.getSceneViewer().home();
      this.setState({
        viewType: ViewType.TOP
      });

      if (this._metadata.view.clipNear !== undefined) {
        // Set initial orthographic near clip (0 - 100)
        this.updateClip([Math.min(Math.max(this._metadata.view.clipNear, 0), 100), 100]);
      }

      if (this._metadata.view.clipFar !== undefined) {
        // Set initial orthographic far clip (0 - 100)
        this.updateClip([this.state.clipFactors[0] * 100, Math.max(Math.min(this._metadata.view.clipFar, 100), this.state.clipFactors[0] * 100)]);
      }
    }

    // Download screenshot
    if (swea.util.getQueryParameters().screenshot === '1') {
      this._viewer.getSceneViewer().downloadScreenshot(false, swea.util.getQueryParameters().square === '1');
    }
    if (swea.util.getQueryParameters().alphascreenshot === '1') {
      this._viewer.getSceneViewer().downloadScreenshot(true, swea.util.getQueryParameters().square === '1');
    }

    // Navigate to a number of poses and take screenshots
    const testPosesUrl = swea.util.getQueryParameters().testPoses;
    if (testPosesUrl !== undefined) {
      HTTP.get(testPosesUrl).then((res) => {
        this._viewer.getSceneViewer().downloadPoseScreenshots(res.data.poses, swea.util.getUrlBasename(this._modelDirectory));
      }).catch(() => {
        console.error('Failed loading ' + swea.util.getQueryParameters().testPoses);
      });
    }

    // Show navigation info after some time if user hasn't found out how to pan by then
    setTimeout(() => {
      if (!this._viewer.getSceneViewer().getManipulator().hasPanned()) {
        InstructionServiceActions.showInstruction('instructions.orbit');
        setTimeout(() => {
          const state = InstructionService.instance().getState();
          if (state.isOpen && (state.text === swea.i18n.t('instructions.orbit') || state.text === swea.i18n.t('instructions.orbit_touch'))) {
            InstructionServiceActions.hideInstruction();
          }
        }, NAV_INFO_TIMEOUT * 1000);
      }
    }, BEFORE_NAV_INFO_TIMEOUT * 1000);

    if (this._metadata.view.flyToTop) {
      // Fly to orthographic top view after a short while
      setTimeout(() => {
        this.setTopView(false).then(() => {
          if (this._initialEye !== undefined && this._initialCenter !== undefined) {
            this._viewer.getSceneViewer().setSimpleView(this._initialEye, this._initialCenter);
          }

          if (this._metadata.view.clipNear !== undefined) {
            // Set initial orthographic near clip (0 - 100)
            this.updateClip([Math.min(Math.max(this._metadata.view.clipNear, 0), 100), 100]);
          }

          if (this._metadata.view.clipFar !== undefined) {
            // Set initial orthographic far clip (0 - 100)
            this.updateClip([this.state.clipFactors[0] * 100, Math.max(Math.min(this._metadata.view.clipFar, 100), this.state.clipFactors[0] * 100)]);
          }
        });
      }, FLY_TO_TOP_TIMEOUT * 1000);
    }

    const profileTextureSubloading = (swea.util.getQueryParameters().texprofile === '1');
    const profileGeometrySubloading = (swea.util.getQueryParameters().geomprofile === '1');
    if (profileTextureSubloading || profileGeometrySubloading) {
      const profiler = new Profiler(this._viewer.getSceneViewer(), this._modelPaths[0], this._initialEye, this._initialCenter, profileTextureSubloading, profileGeometrySubloading);
      // Measure pager ready time in static view
      //profiler.measureStaticPagerTime();
      // Start debug flying
      //profiler.fly();
      // Repeated and reloaded performance profiling of both static and flying
      profiler.repeatProfiler();
    }

    // Load any splat model asynchronously
    if (this._splatModelPath !== undefined && this._splatModelPath !== '') {
      if (!this._splatModelPath.startsWith('http')) {
        this._splatModelPath = this._modelDirectory + '/' + this._splatModelPath;
      }

      // NOTE: This seems to transform incorrectly on splat level, better to transform offline
      if (this._splatTransformPath !== undefined && this._splatTransformPath !== '') {
        if (!this._splatTransformPath.startsWith('http')) {
          this._splatTransformPath = this._modelDirectory + '/' + this._splatTransformPath;
        }
      }

      this._splatModel = new LoadedModel({
        paths: [this._splatModelPath],
        nodeOptions: {
          enabled: true,
          lit: false,
          pickable: false,
          invisibleInImage: true,
          initialPosition: this._initialPosition,
          initialRotation: this._initialRotation
        },
        modelOptions: {
          flattenable: false,
          singleSided: false
        },

        // NOTE: This seems to transform incorrectly on splat level, better to transform offline
        splatTransformUrl: this._splatTransformPath
      });
      ViewerManager.instance().addModelToViewer(this._splatModel.getId(), this._viewer.getId());
    }
  }

  home = () => {
    if (this._viewer.getSceneViewer().isFlying()) {
      return;
    }

    if (this._initialEye !== undefined && this._initialCenter !== undefined) {
      const prevCursor = this._viewer.getCursor();
      this._viewer.setCursor('wait');
      const disabledInteractionClasses = InteractionManager.instance().disableContinuousInteractions();
      this._viewer.getSceneViewer().flyToSimple(this._initialEye, this._initialCenter).finally(() => {
        this._viewer.setCursor(prevCursor);
        InteractionManager.instance().enableContinuousInteractions(disabledInteractionClasses);
      });
    }
    else {
      this._viewer.home();
    }
  }

  setFreeView = () => {
    if (this._viewer.getSceneViewer().isFlying()) {
      return;
    }

    if (this.state.viewType == ViewType.TOP || this.state.viewType == ViewType.SIDE || this.state.viewType == ViewType.CYLINDER) {
      InteractionManager.instance().stopInteraction(CustomPerpendicularViewInteraction);
      this.updateClip([0, 100]);
      this._viewer.setFreeView();
      InstructionServiceActions.showInstruction('instructions.orbit');
      this.setState({
        viewType: ViewType.FREE
      });
    }
  };

  setTopView = (resetClip = true) => {
    return new Promise((resolve, reject) => {
      if (this._viewer.getSceneViewer().isFlying()) {
        reject('Cannot set top view while flying.');
        return;
      }

      if (this.state.viewType !== ViewType.TOP) {
        InteractionManager.instance().stopInteraction(CustomPerpendicularViewInteraction);
        this._viewer.setTopView(true).then(() => {
          InstructionServiceActions.showInstruction('instructions.topview');
          this.setState({
            viewType: ViewType.TOP
          });
          if (resetClip) {
            this.updateClip([0, 100]);
          }
          resolve();
        }).catch((err) => {
          reject(err);
        });
      }

      //Toggle off the other slider if it is active and visible
      if(this.state.distanceSlider){
        this.toggleDistanceSlider();
      }
    });
  };

  toggleFreeTopView = () => {
    if (this._viewer.getSceneViewer().isFlying()) {
      return;
    }

    if (this.state.viewType === ViewType.FREE) {
      if (this.state.distanceSlider) {
        this.toggleDistanceSlider();
      }
      this.setTopView();
    }
    else {
      this.setFreeView();
    }
  };

  /**
   * Clip slider callback.
   * @param { number[] } values The slider value as one value in an array (not using dual).
   */
  updateClip = (values) => {
    const clipFactors = [values[0] / 100.0, values[1] / 100.0];
    if (clipFactors[0] === 0.0 && clipFactors[1] === 1.0) {
      this._viewer.getSceneViewer().setOrthographicClipFactors(undefined);
    }
    else {
      this._viewer.getSceneViewer().setOrthographicClipFactors(clipFactors);
    }
    this.state.clipFactors = clipFactors; // So that clip factors are immediately updated after this
    this.setState({
      clipFactors: clipFactors
    });
  };

  /**
   * Distance slider callback.
   * @param { number[] } values The slider value as one value in an array (not using dual).
   */
  updateDistance = (values) => {
    this._viewer.getSceneViewer().updateNearFarValues(values);
    this.setState({
      distanceValues: values
    });
  };


  setSideView = () => {
    if (this._viewer.getSceneViewer().isFlying()) {
      return;
    }

    InteractionManager.instance().startInteraction(CustomPerpendicularViewInteraction, this._viewer.getCanvas(), this._viewer.getId());
    this.setState({
      viewType: ViewType.SIDE
    });
    this.updateClip([0, 100]);
  };

  toggleCylinderView = () => {
    if (this._animatingCylinderView) {
      return;
    }

    const sceneViewer = this._viewer.getSceneViewer();
    if (sceneViewer.isFlying()) {
      return;
    }

    if (this.state.viewType === ViewType.CYLINDER) {
      sceneViewer.setOrbitManipulator();
      this.setState({
        viewType: ViewType.FREE
      });

      if (this._flyToInteraction !== undefined) {
        this._flyToInteraction.enable();
      }
    }
    else {
      InstructionServiceActions.hideInstruction();

      if (this._flyToInteraction !== undefined) {
        this._flyToInteraction.disable();
      }

      sceneViewer.setCylinderManipulator(true).then(() => {
        this.setState({
          viewType: ViewType.CYLINDER
        });
      }).catch(() => {
        InstructionServiceActions.showInstruction('instructions.failed_cylinder');

        if (this._flyToInteraction !== undefined) {
          this._flyToInteraction.enable();
        }
      });
    }
  };

  _turnCylinderView(direction) {
    if (this._animatingCylinderView) {
      return;
    }

    const sceneViewer = this._viewer.getSceneViewer();
    if (sceneViewer.isFlying()) {
      return;
    }

    this._animatingCylinderView = true;
    sceneViewer.turnCylinderView(direction).finally(() => {
      this._animatingCylinderView = false;
    });
  }

  turnCylinderLeft = () => {
    this._turnCylinderView(-1);
  };

  turnCylinderRight = () => {
    this._turnCylinderView(1);
  };

  /**
   * Shows the classifcation / models report.
   */
  startClassificationReport = () => {
    this.setState({ showClassificationReport: true });
    this.state.showClassificationReport = true; // So that _setPortalOverlayVisibilityFromState reads new state
    this._setPortalOverlayVisibilityFromState();
  };

  /**
   * Closes the classification / models report.
   */
  closeClassificationReport = () => {
    this.setState({ showClassificationReport: false });
    this.state.showClassificationReport = false; // So that _setPortalOverlayVisibilityFromState reads new state
    this._setPortalOverlayVisibilityFromState();
  };

  /**
   * Shows the annotation / measurement report.
   */
  startAnnotationReport = () => {
    this.setState({ showAnnotationReport: true, showLogo: false });
    this.state.showAnnotationReport = true; // So that _setPortalOverlayVisibilityFromState reads new state
    this.state.showLogo = false;
    this._setPortalOverlayVisibilityFromState();
    this._setPortalUpperLeftLogoVisibility(false);
  };

  /**
   * Closes the classification / measurement report.
   */
  closeAnnotationReport = () => {
    this.setState({ showAnnotationReport: false, showLogo: true });
    this.state.showAnnotationReport = false; // So that _setPortalOverlayVisibilityFromState reads new state
    this.state.showLogo = true;
    this._setPortalOverlayVisibilityFromState();
    this._setPortalUpperLeftLogoVisibility(true);
  };

  startTextAreaInteraction = () => {
    InteractionManager.instance().stopAllInteractions();
    InteractionManager.instance().startInteraction(CustomTextAreaInteraction, this._viewer.getCanvas(), this._viewer.getId());
  };

  /**
   * Injects auto-set section fields into annotation fields when section volumes are enabled.
   * Marks all annotation fields as eligible for auto-fill from section properties.
   * Also adds a dedicated section name field if none exists.
   * @private
   */
  _injectSectionField() {
    if (this._metadata.tools.sectionvolumes === undefined && this._metadata.sections === undefined) {
      return;
    }
    if (this._annotationFields === undefined) {
      this._annotationFields = {};
    }
    // Inject section name field if no field already has _isSectionNameField
    let hasSectionNameField = false;
    for (const name in this._annotationFields) {
      if (this._annotationFields[name]._isSectionNameField) {
        hasSectionNameField = true;
        break;
      }
    }
    if (!hasSectionNameField) {
      this._annotationFields[i18n.t('tooltip.section_name')] = {
        type: 'STRING',
        autoSetFromSection: true,
        _isSectionNameField: true
      };
    }
    // Mark all annotation fields as auto-settable from section properties
    for (const name in this._annotationFields) {
      this._annotationFields[name].autoSetFromSection = true;
    }
    // Store field definitions on AnnotationService so SectionVolumeExtruder can read them
    AnnotationService.instance().setAutoSectionFields(this._annotationFields);
  }

  /**
   * Recreates section volume models from the .swea save file metadata.
   * This is called after a save file has been loaded because section commands are stripped
   * from .swea files and persisted as metadata instead.
   * @private
   */
  _recreateSectionsFromSaveFileMetadata() {
    const savedSections = EditorStateService.instance().getMetaData('sections');
    if (!savedSections || savedSections.length === 0) {
      return;
    }
    // Only recreate if no section volumes already exist (e.g. from project metadata)
    const existingModels = ModelManager.instance().getModels();
    for (const key in existingModels) {
      if (existingModels[key] instanceof VolumeModel && existingModels[key].isSection()) {
        return; // Sections already loaded from metadata.json — skip
      }
    }
    if (this._viewer && this._handle) {
      ModelManager.instance().createSectionsFromMetadata(savedSections, this._viewer.getId(), this._handle.getId());
    }
  }

  /**
   * Waits for a load operation to fully complete, then prompts for section override.
   * Polls isLoading() because the load pipeline uses async dispatches, internal setTimeout
   * and does not emit change events reliably during the loading process.
   * @private
   */
  _waitForLoadThenPromptSectionOverride() {
    let attempts = 0;
    const maxAttempts = 120; // 12 seconds max wait
    const poll = () => {
      attempts++;
      if (EditorStateService.instance().isLoading() && attempts < maxAttempts) {
        setTimeout(poll, 100);
      } else if (attempts < maxAttempts) {
        // Loading is done — wait a bit for model construction to complete
        setTimeout(() => {
          // Recreate section volumes from .swea file metadata if present
          this._recreateSectionsFromSaveFileMetadata();
          this._promptSectionOverrideAfterLoad();
        }, 200);
      }
    };
    // Wait for loading to actually start (it starts asynchronously after dispatch)
    setTimeout(poll, 300);
  }

  /**
   * After loading a save file, checks if annotations were loaded and sections exist.
   * If so, asks the user whether to override annotation fields with section data.
   * @private
   */
  _promptSectionOverrideAfterLoad() {
    // Only prompt if sections are available (from metadata or section volumes)
    const models = ModelManager.instance().getModels();
    let hasSectionVolumes = false;
    let hasAnnotations = false;
    for (const key in models) {
      const m = models[key];
      if (m instanceof VolumeModel && m.isSection && m.isSection()) {
        hasSectionVolumes = true;
      }
      if (m instanceof AnnotationModel) {
        hasAnnotations = true;
      }
      if (hasSectionVolumes && hasAnnotations) {
        break;
      }
    }
    // Also consider legacy sections from metadata
    if (!hasSectionVolumes && this._metadata.sections && this._metadata.sections.length > 0) {
      hasSectionVolumes = true;
    }
    if (!hasSectionVolumes || !hasAnnotations) {
      return;
    }

    // Prompt user
    const dialogListener = DialogService.instance().addChangeListener(() => {
      if (!DialogService.instance().getState().isOpen) {
        DialogService.instance().removeChangeListener(dialogListener);
        if (DialogService.instance().getState().yes) {
          // Show a non-dismissable loading dialog while processing
          DialogServiceActions.open({
            title: i18n.t('components.section_override_dialog.title'),
            text: i18n.t('components.section_override_dialog.loading'),
            alignment: DialogService.AlignmentType.CENTER,
            small: true,
            yesNo: false
          });
          // Run the override async to let the loading dialog render first
          setTimeout(() => {
            AnnotationService.instance().overrideAnnotationsWithSectionData(() => {
              DialogServiceActions.close();
            });
          }, 100);
        }
      }
    });

    DialogServiceActions.open({
      title: i18n.t('components.section_override_dialog.title'),
      text: i18n.t('components.section_override_dialog.text'),
      alignment: DialogService.AlignmentType.CENTER,
      small: true,
      yesNo: true,
      yesTooltip: i18n.t('components.section_override_dialog.yes'),
      noTooltip: i18n.t('components.section_override_dialog.no')
    });
  }

  startTextLineInteraction = () => {
    InteractionManager.instance().stopAllInteractions();
    InteractionManager.instance().startInteraction(CustomTextLineInteraction, this._viewer.getCanvas(), this._viewer.getId());
  };

  /**
   * Starts a new temporary annotation interaction if no action is underway.
   */
  startAnnotationInteraction = () => {
    InteractionManager.instance().stopAllInteractions();
    InteractionManager.instance().startInteraction(
      CustomCreateAnnotationInteraction,
      this._viewer.getCanvas(),
      this._viewer.getId(),
      {
        nodeOptions: {
          pickable: true,
          transformable: false
        },
        modelOptions: {
          deletable: true,
          selectable: true
        },
        implicitSelect: true,
        imagePath: 'img/annotation_marker_white.png',
        selectedImagePath: 'img/annotation_marker_open_white.png',
        deselectedImagePath: 'img/annotation_marker_pin_white.png',
        activeWidth: 52,
        narrowActiveWidth: 34,
        width: 128,
        height: 64,
        narrowWidth: 85,
        narrowHeight: 40,
        color: [0.25, 0.25, 0.25],
        anchorPoint: [15, 58],
        narrowAnchorPoint: [10, 36],
        offset: [0.4, -3],
        narrowOffset: [0.4, -2.5],
        showShortenedText: true,
        shortenedTextFont: 'Inter Tight',
        shortenedTextCharacterSize: 17.5,
        narrowShortenedTextCharacterSize: 14,
        shortenedTextColor: [1, 1, 1],
        fields: this._annotationFields
      }
    );
  };

  startBulldoze = () => {
    InstructionServiceActions.showInstruction('instructions.add_bulldoze');
    ModelManager.instance().enableFlatteningPolygonModels();
    ContextMenuStateServiceActions.openContextMenu(
      globals.LOWER_CONTEXT_MENU,
      globals.SELECTED_BULLDOZER
    );
  };

  stopBulldoze = () => {
    InstructionServiceActions.hideInstruction();
    ModelManager.instance().disableFlatteningPolygonModels();
    ContextMenuStateServiceActions.closeContextMenu(
      globals.LOWER_CONTEXT_MENU
    );
    this.stopAll();
  };

  startBulldozeInteraction = () => {
    InteractionManager.instance().stopAllInteractions();
    InteractionManager.instance().startInteraction(CustomBulldozeInteraction, this._viewer.getCanvas(), this._viewer.getId());
  };

  startInspectInteraction = () => {
    if (this.state.filter) {
      this.toggleFilterFavorites();
    }
    InteractionManager.instance().stopAllInteractions();

    InteractionManager.instance().startInteraction(CustomBestCamerasInteraction, this._viewer.getCanvas(), this._viewer.getId(), {
      imageSelectionInteraction: this._imageSelectInteraction,
      smart: this._metadata.tools.smartinspect,
      smartInspectImages: this._smartInspectImages,
      sameFolder: false,
      isectOnly: false,
      reopen: this._metadata.versions === undefined,
      showDownload: this._metadata.tools.downloadimage !== false,
      showOrthogonalGsd: (swea.util.getQueryParameters().debug === '1' || swea.util.getQueryParameters().debuggui === '1'),
      orthogonalGsdTitle: swea.i18n.t('components.image_viewer.ortho_gsd_title'),
      forceOverlayViewer: (this._metadata.tools.compass === true || this._metadata.tools.altitude === true)
    });
  };

  /**
   * Stops the inspect interaction.
   */
  stopInspectInteraction = () => {
    InteractionManager.instance().stopInteraction(CustomBestCamerasInteraction);
  };

  /**
   * Starts a new temporary measure interaction if no action is underway.
   */
  startMeasureInteraction = () => {
    InteractionManager.instance().stopAllInteractions();
    const interaction = InteractionManager.instance().startInteraction(CustomMeasureInteraction, this._viewer.getCanvas(), this._viewer.getId(), {
      measureAccuracy: this.state.measureAccuracy,
      restart: this._metadata.tools.restart_measure,
      postRefinement: this._metadata.tools.refine_measure,
      areaEdgeLenghts: this._metadata.tools.area_edge_lengths,
      polygonColor: (this._metadata.color !== undefined ? this._metadata.color.measureAreaColor : undefined),
      lineColor: (this._metadata.color !== undefined ? this._metadata.color.measureLineColor : undefined),
      snapToOtherModel: MeasureService.instance().isSnapToOtherModelEnabled()
    });

    // Listen for snap-to-other-model toggle from the MeasureContextMenu checkbox
    this._measureSnapListener = MeasureService.instance().addChangeListener(() => {
      const enabled = MeasureService.instance().isSnapToOtherModelEnabled();
      if (interaction && !interaction.isTerminated()) {
        interaction.setSnapToOtherModel(enabled);
      }
    });
  };

  /**
   * Stops the current measure interaction.
   */
  stopMeasureInteraction = () => {
    if (this._measureSnapListener !== undefined) {
      MeasureService.instance().removeChangeListener(this._measureSnapListener);
      this._measureSnapListener = undefined;
    }
    InteractionManager.instance().stopInteraction(CustomMeasureInteraction);
  };

  /**
   * Set comparison image URL when versions service changes.
   * @private
   */
  _onVersionsServiceChange = () => {
    const state = VersionsService.instance().getState();
    this.setState({
      comparisonImageUrl: state.comparisonImageUrl,
      comparisonMaskUrl: state.comparisonMaskUrl,
      comparisonVersionName: state.comparisonVersionName,
      currentVersionName: state.currentVersionName,
      comparisonOpacity: state.comparisonOpacity
    });
  };

  /**
   * Cancel refinement question dialog callback.
   * @private
   */
  _onCancelRefineDialogChange = (resolve) => {
    if (!DialogService.instance().getState().isOpen) {
      resolve(DialogService.instance().getState().yes);
      DialogService.instance().removeChangeListener(this._closeRefinementDialogListener);
      this._closeRefinementDialogListener = undefined;
      this.stopMeasureInteraction();
    }
  };

  /**
   * Ask about canceling refinement before closing measurement menu.
   */
  askStopMeasurement = () => {
    if (MeasureService.instance().isRefining()) {
      return new Promise((resolve) => {
        DialogServiceActions.open(
          swea.i18n.t('components.close_refinement_dialog.title'),
          swea.i18n.t('components.close_refinement_dialog.text'),
          DialogService.AlignmentType.CENTER,
          true, true,
          swea.i18n.t('components.close_refinement_dialog.yes'),
          swea.i18n.t('components.close_refinement_dialog.no')
        );
        this._closeRefinementDialogListener = DialogService.instance().addChangeListener(this._onCancelRefineDialogChange.bind(this, resolve));
      });
    }
    else {
      this.stopMeasureInteraction();
      return Promise.resolve(true);
    }
  }

  startSolidAreaInteraction = () => {
    this.setState({ sectionVolumeToolActive: false });
    InteractionManager.instance().stopAllInteractions();
    InteractionManager.instance().startInteraction(CustomAreaInteraction, this._viewer.getCanvas(), this._viewer.getId(), {
      polygonColor: [0.752941, 0.752941, 0.752941],
      transparency: 0.0,
      lit: true,
      extrudable: this._metadata.tools.extrude === true,
      handleTemplateId: this._handle.getId(),
      nodeOptions: {
        pickable: true
      }
    });
  };

  startSectionVolumeInteraction = () => {
    this.setState({ sectionVolumeToolActive: true });
    InteractionManager.instance().stopAllInteractions();

    // Pass base model bounds so the interaction can create an invisible floor plane at minZ
    let baseBoundsMin, baseBoundsMax;
    if (this._baseModel) {
      try {
        baseBoundsMin = this._baseModel.getBoundingBoxMin(true);
        baseBoundsMax = this._baseModel.getBoundingBoxMax(true);
      }
      catch (err) { err; }
    }

    InteractionManager.instance().startInteraction(CustomSectionVolumeInteraction, this._viewer.getCanvas(), this._viewer.getId(), {
      polygonColor: [0.95, 0.6, 0.2],
      transparency: 0.1,
      isSection: true,
      lit: true,
      extrudable: true,
      pickPlanes: true,
      handleTemplateId: this._handle.getId(),
      baseBoundsMin: baseBoundsMin,
      baseBoundsMax: baseBoundsMax,
      nodeOptions: {
        pickable: true
      }
    });
  };

  toggleSectionVolumes = () => {
    const newValue = !this.state.sectionVolumesVisible;
    ModelManager.instance().setSectionVolumesVisible(newValue);
    this.setState({ sectionVolumesVisible: newValue });
  };

  exportSectionVolumes = () => {
    const sections = ModelManager.instance().exportSectionsAsMetadata();
    if (sections.length === 0) {
      DialogServiceActions.open({
        title: i18n.t('tooltip.export_sections'),
        text: i18n.t('instructions.no_sections_to_export'),
        alignment: DialogService.AlignmentType.CENTER,
        small: true,
        yesNo: false
      });
      return;
    }
    const json = JSON.stringify(sections, null, 2);
    this._copyToClipboard(json);
    DialogServiceActions.open({
      title: i18n.t('tooltip.export_sections'),
      text: i18n.t('instructions.sections_exported'),
      alignment: DialogService.AlignmentType.CENTER,
      small: true,
      yesNo: false
    });
  };

  onFavoriteChange = () => {
    this.setState({ filter: FavoriteService.instance().getState().filterFavorites });
  };

  /**
   * Sets portal overlay visibility via postMessage if we are connected to the Spotscale portal.
   * @param { boolean } visible True to show overlay.
   * @private
   */
  _setPortalOverlayVisibility(visible) {
    const serverUrl = Globals.config.cloudServer;
    if (serverUrl !== undefined && serverUrl !== '') {
      parent.postMessage({
        id: this._communicationId,
        command: 'showOverlay',
        value: visible
      }, '*');
    }
  }

  /**
   * Sets portal lower-right logo visibility via postMessage if we are connected to the Spotscale portal.
   * @param { boolean } visible True to show lower-right logo.
   * @private
   */
  _setPortalLowerRightLogoVisibility(visible) {
    const serverUrl = Globals.config.cloudServer;
    if (serverUrl !== undefined && serverUrl !== '') {
      parent.postMessage({
        id: this._communicationId,
        command: 'showLowerRightLogo',
        value: visible
      }, '*');
    }
  }

  /**
   * Sets portal upper-left logo visibility via postMessage if we are connected to the Spotscale portal.
   * @param { boolean } visible True to show the logo.
   * @private
   */
  _setPortalUpperLeftLogoVisibility(visible) {
    const serverUrl = Globals.config.cloudServer;
    if (serverUrl !== undefined && serverUrl !== '') {
      parent.postMessage({
        id: this._communicationId,
        command: 'showLogo',
        value: visible
      }, '*');
    }
  }

  /**
   * Sets portal overlay visibility depending on current state.
   * @private
   */
  _setPortalOverlayVisibilityFromState() {
    const hideOverlay = (
      this.state.catalogOpen ||
      this.state.imageOpen ||
      this.state.topRightDialogOpen ||
      this.state.showClassificationReport ||
      this.state.showAnnotationReport ||
      this.state.splitScreenUrl !== undefined
    );
    this._setPortalOverlayVisibility(!hideOverlay);
  }

  /**
   * Sets portal lower-right logo visibility depending on current state.
   * @private
   */
  _setPortalLowerRightLogoVisibilityFromState() {
    const hideLogo = (this.state.textureLabels || this.state.showSwitchAnnotations || this.state.comparingVersions);
    this._setPortalLowerRightLogoVisibility(!hideLogo);
  }

  /**
   * Disables menu items during image catalog.
   * @private
   */
  _onImageCatalogChange = () => {
    const catalogOpen = ImageCatalogueService.instance().getState().isOpen || ModelCatalogueService.instance().getState().isOpen;
    // Set directly to make _setPortalLowerRightLogoVisibilityFromState work below
    this.state.showSwitchAnnotations = (ModelManager.instance().getSelectedModel() instanceof AnnotationModel && !catalogOpen && !this.state.imageOpen);
    this.setState({
      catalogOpen: catalogOpen,
      showSwitchAnnotations: this.state.showSwitchAnnotations
    });
    this.state.catalogOpen = catalogOpen; // So that _setPortalOverlayVisibilityFromState reads new state
    this._setPortalOverlayVisibilityFromState();
    this._setPortalLowerRightLogoVisibilityFromState();
  };

  /**
   * Disables menu items during model catalog.
   * @private
   */
  _onModelCatalogChange = () => {
    const catalogOpen = ImageCatalogueService.instance().getState().isOpen || ModelCatalogueService.instance().getState().isOpen;
    // Set directly to make _setPortalLowerRightLogoVisibilityFromState work below
    this.state.showSwitchAnnotations = (ModelManager.instance().getSelectedModel() instanceof AnnotationModel && !catalogOpen && !this.state.imageOpen);
    this.setState({
      catalogOpen: catalogOpen,
      showSwitchAnnotations: this.state.showSwitchAnnotations
    });
    this.state.catalogOpen = catalogOpen; // So that _setPortalOverlayVisibilityFromState reads new state
    this._setPortalOverlayVisibilityFromState();
    this._setPortalLowerRightLogoVisibilityFromState();
  };

  /**
   * Opens the model catalogue.
   */
  openCatalogue = () => {
    ContextMenuStateServiceActions.openContextMenu(
      globals.LOWER_CONTEXT_MENU,
      globals.CATALOGUE_ACTIVATED
    );

    if (this._cataloguePath) {
      ModelCatalogueServiceActions.read(this._cataloguePath, this._viewer.getId(), CustomPlaceModelInteraction, CustomLoadModelCommand, SpriteModelCommand, globals.LOWER_CONTEXT_MENU);
    }
    else {
      ModelCatalogueServiceActions.open(this._modelCatalogue, globals.LOWER_CONTEXT_MENU);
    }

    InstructionServiceActions.showInstruction('instructions.choose_model');
  };

  /**
   * Closes the model catalogue and opens the model placing context menu if a model was selected
   */
  closeCatalogue = () => {
    ModelCatalogueServiceActions.close();
    const modelObject = ModelCatalogueService.instance().getState().currentModel;
    if (modelObject !== undefined) {
      this.setState({
        modelImgPath: modelObject.thumb,
        modelName: modelObject.name,
        modelComment: modelObject.comment
      });

      ContextMenuStateServiceActions.openContextMenu(
        globals.LOWER_CONTEXT_MENU,
        globals.MODEL_ACTIVATED
      );

      InstructionServiceActions.showInstruction('instructions.click_to_place_model');
    }
    else {
      InstructionServiceActions.hideInstruction();
    }
  };

  stopPlaceModelInteraction = () => {
    InteractionManager.instance().stopInteraction(CustomPlaceModelInteraction);
  };

  stopAll = () => {
    InteractionManager.instance().stopAllInteractions();
  };

  loadFromDisk = (path) => {
    // Listen to and display any load warning
    const warningListener = EditorStateService.instance().addChangeListener(() => {
      const warning = EditorStateService.instance().getState().warning;
      if (warning !== undefined && warning !== '') {
        DialogServiceActions.open(
          swea.i18n.t('components.editor_warning_dialog.title'),
          warning,
          DialogService.AlignmentType.CENTER,
          true
        );
        EditorStateServiceActions.resetWarning();
      }
      EditorStateService.instance().removeChangeListener(warningListener);
    });

    // Load
    EditorStateServiceActions.load(path);

    // After loading completes, check if annotations should be overridden with section data
    this._waitForLoadThenPromptSectionOverride();

    // Remove any warn-before-leave-warning and add the empty event again to avoid expensive back-forwards cache
    window.removeEventListener('beforeunload', this._warnBeforeLeave);
    window.addEventListener('beforeunload', this._emptyBeforeUnload);
  };

  saveToDisk = () => {
    EditorStateServiceActions.save();

    // Remove any warn-before-leave-warning and add the empty event again to avoid expensive back-forwards cache
    window.removeEventListener('beforeunload', this._warnBeforeLeave);
    window.addEventListener('beforeunload', this._emptyBeforeUnload);
  };

  loadFromCloud = () => {
    // Listen to and display any load warning
    const warningListener = EditorStateService.instance().addChangeListener(() => {
      const warning = EditorStateService.instance().getState().warning;
      if (warning !== undefined && warning !== '') {
        DialogServiceActions.open(
          swea.i18n.t('components.editor_warning_dialog.title'),
          warning,
          DialogService.AlignmentType.CENTER,
          true
        );
        EditorStateServiceActions.resetWarning();
      }
      EditorStateService.instance().removeChangeListener(warningListener);
    });

    // Load
    EditorStateServiceActions.loadFromCloud();

    // After loading completes, check if annotations should be overridden with section data
    this._waitForLoadThenPromptSectionOverride();

    // Add or renew timeout to warn when idle too long
    if (this._idleTimeout !== undefined) {
      clearTimeout(this._idleTimeout);
    }
    this._idleTimeout = setTimeout(this._warnIdle, IDLE_TIMEOUT * 1000);

    // Remove any warn-before-leave-warning and add the empty event again to avoid expensive back-forwards cache
    window.removeEventListener('beforeunload', this._warnBeforeLeave);
    window.addEventListener('beforeunload', this._emptyBeforeUnload);

    // Listen to edits after loading
    if (this._metadata.tools.loadsave === true) {
      // Add edit listener (to enable/disable leave-warning)
      this._loadingWorkspace = true;
      EditorStateService.instance().addChangeListener(this._onEdited);

      // Report cloud save open since we are editors
      EditorStateServiceActions.setCloudSaveReportActive(true);
    }
    else {
      // Avoid reporting cloud save open if we don't have load/save
      EditorStateServiceActions.setCloudSaveReportActive(false);
    }
  };

  saveToCloud = () => {
    if (this.state.cloudSave !== undefined) {
      EditorStateServiceActions.saveToCloud();

      // Remove any warn-before-leave-warning and add the empty event again to avoid expensive back-forwards cache
      window.removeEventListener('beforeunload', this._warnBeforeLeave);
      window.addEventListener('beforeunload', this._emptyBeforeUnload);
    }
  };

  toggleFilterFavorites = () => {
    FavoriteServiceActions.toggleFilterFavorites();
  };

  _stateChanged = () => {
    this.setState({ viewState: ViewStateManager.instance().getState() });
  };

  toggle3D = () => {
    if (ViewStateManager.instance().getState() === ViewStateManager.ViewStates.STATE_3D) {
      this._imageSelectInteraction.open();
    }
    else if (ViewStateManager.instance().getState() === ViewStateManager.ViewStates.STATE_2D) {
      this._imageSelectInteraction.close();
    }
  };

  cloudSaveChangeHandler = () => {
    const cloudSave = EditorStateService.instance().getCurrentCloudSave();
    this.setState({ cloudSave: cloudSave });
  };

  /**
   * Empty event function called before leaving page, to avoid the expensive back-forwards cache.
   * private
   */
  _emptyBeforeUnload = () => {
  };

  /**
   * Empty event function called when unloading page, to avoid the expensive back-forwards cache.
   * private
   */
  _emptyOnUnload = () => {
  };

  /**
   * Event for warning before leaving page.
   * @param { Event } evt The beforeunload event.
   * @private
   */
  _warnBeforeLeave = (evt) => {
    evt.preventDefault();
    evt.returnValue = '';
  };

  /**
   * Warns about being idle for a long while.
   * @private
   */
  _warnIdle = () => {
    InstructionServiceActions.showInstruction(i18n.t('components.idlewarning.text1') + ' ' + Math.round(IDLE_TIMEOUT / 60.0) + ' ' + i18n.t('components.idlewarning.text2'));
    this._idleTimeout = undefined;
  }

  /**
   * Called when edited, adds before-leave-warning.
   * @private
   */
  _onEdited = () => {
    if (this._loadingWorkspace) {
      EditorStateService.instance().whenLoaded().then(() => {
        // TODO: Do something when workspace has loaded, e.g. close a new progress bar
      });
      this._loadingWorkspace = false;
      return;
    }

    if (swea.util.getQueryParameters().project !== undefined) {
      // Add or renew timeout to warn when idle too long
      if (this._idleTimeout !== undefined) {
        clearTimeout(this._idleTimeout);
      }
      this._idleTimeout = setTimeout(this._warnIdle, IDLE_TIMEOUT * 1000);
    }

    // Warn if trying to leave page without saving (but not if just a selection)
    const pastCommands = EditorStateService.instance().getState().past;
    if (pastCommands.length > 0) {
      const lastCommand = pastCommands[pastCommands.length - 1];
      if (lastCommand !== undefined && !(lastCommand instanceof SelectCommand)) {
        window.removeEventListener('beforeunload', this._emptyBeforeUnload);
        window.addEventListener('beforeunload', this._warnBeforeLeave);
      }
    }
  };

  openToggleModels = () => {
    ContextMenuStateServiceActions.openContextMenu(
      globals.LOWER_CONTEXT_MENU,
      globals.TOGGLE_OPEN
    );
  };

  openClassification = () => {
    // Open context menu
    ContextMenuStateServiceActions.openContextMenu(
      globals.LOWER_CONTEXT_MENU,
      globals.CLASSIFICATION_OPEN
    );

    if (ToggleModelsService.instance().isEmpty()) {
      // Retrieve classification toggle models from path in URL and open them
      let classificationTogglePath = swea.util.getQueryParameters().classification;
      if (classificationTogglePath === undefined) {
        classificationTogglePath = this._metadata.classification;
      }
      if (classificationTogglePath !== undefined) {
        ToggleModelsServiceActions.read(classificationTogglePath, this._viewer.getId());

        // TEMP: Something like this if we want to activate classification thumbs?
        //       Complete with checking if any of the classifcations in json file have enableCustomThumb set.
        /*
        ToggleModelsService.instance().whenLoaded().then(() => {
          this._viewer.createClassificationThumbs();
        });
        */
      }
    }
  }

  _toggleInternalLinks() {
    const hideInternalLinks = (this.state.splitScreenUrl !== undefined || (ImageViewerService.instance().getState().isOpen && this._hideAnnotationInternalLinksInImage === true));
    AnnotationServiceActions.setInternalLinksVisible(!hideInternalLinks);
  }

  /**
   * Updates the radiometric mode shader palette service changes.
   * @private
   */
  _onShaderPaletteStateChange = () => {
    const newRadiometricState = ShaderPaletteService.instance().getRadiometric();
    if (this.state.radiometric !== newRadiometricState) {
      this.setState({ radiometric: newRadiometricState });

      // Close eye-dropper or palette controls if toggling to visual
      if (!newRadiometricState) {
        const currentMenuContext = ContextMenuStateService.instance().getCurrentMenuContext(globals.LOWER_CONTEXT_MENU);
        if (currentMenuContext === globals.EYE_DROPPER_ACTIVATED || currentMenuContext === globals.PALETTE_CONTROL_ACTIVATED) {
          ContextMenuStateServiceActions.closeContextMenu(globals.LOWER_CONTEXT_MENU);
        }
      }
    }
  };

  /**
   * Revert to radiometric/visual mode as it was before going to image view (since textures haven't changed from image view).
   * Or make sure we redraw and disable vis/ir button when opening image if not synced.
   * @private
   */
  _onImageViewerChange = () => {
    const newState = ImageViewerService.instance().getState();
    if (this.state.imageOpen && !newState.isOpen) {
      if (this.state.lockModelPalette || this.state.lockImagePalette || this.state.lockModelInterval || this.state.lockImageInterval) {
        // Thermal palette interval is locked in model or image view, close context menu in case it's the palette controls
        ContextMenuStateServiceActions.closeContextMenu(
          globals.LOWER_CONTEXT_MENU
        );
      }

      // Close mask context menu and deactivate mask overlay when leaving image view
      if (this.state.maskActive) {
        const currentMenuContext = ContextMenuStateService.instance().getCurrentMenuContext(globals.LOWER_CONTEXT_MENU);
        if (currentMenuContext === globals.MASK_CLASSES_ACTIVATED) {
          ContextMenuStateServiceActions.closeContextMenu(globals.LOWER_CONTEXT_MENU);
        }
        MaskServiceActions.deactivate();
      }

      if (this._previousRadiometric !== this.state.radiometric) {
        // Radiometric/visual mode was changed in image view but no textures were changed, now change back
        this.setState({
          radiometric: this._previousRadiometric
        });
        ShaderPaletteServiceActions.setRadiometric(this._previousRadiometric);
      }
    }

    // Set directly to make _setPortalLowerRightLogoVisibilityFromState work below
    this.state.showSwitchAnnotations = (ModelManager.instance().getSelectedModel() instanceof AnnotationModel && !newState.isOpen && !this.state.catalogOpen);
    this.setState({
      imageOpen: newState.isOpen,
      showSwitchAnnotations: this.state.showSwitchAnnotations
    });
    this.state.imageOpen = newState.isOpen; // So that _setPortalOverlayVisibilityFromState reads new state
    this._setPortalOverlayVisibilityFromState();
    this._setPortalLowerRightLogoVisibilityFromState();
    this._toggleInternalLinks();
  };

  _goToModel(url) {
    let newHref = url;
    if (
      DialogService.instance().getRememberedReply(swea.i18n.t('components.sub_model_dialog.title')) === true ||
      DialogService.instance().getRememberedReply(swea.i18n.t('components.main_model_dialog.title')) === true
    ) {
      // Add remembered flag to URL
      const urlParts = url.split('?');
      if (urlParts.length > 1) { // Should always be true
        newHref = urlParts[0] + '?rememberGotoModelReply=1&' + urlParts[1];
      }
    }
    window.location.href = newHref;
  }

  /**
   * Go to sub- or main model, or tell portal to hide or show top icons for top- and right-adjusted dialogs.
   * @private
   */
  _onDialogChange = () => {
    const newState = DialogService.instance().getState();
    if (this.state.gotoModelUrl !== undefined && !newState.isOpen) {
      // There is a model link waiting
      if (newState.yes) {
        // User replied yes, possibly add remember parameter and go there
        this._goToModel(this.state.gotoModelUrl);
      }
      else {
        // Reset model link
        this.setState({
          gotoModelUrl: undefined
        });
      }
    }
    else {
      const topRightDialogOpen = newState.isOpen && !newState.small && (newState.alignment === DialogService.AlignmentType.TOP || newState.alignment === DialogService.AlignmentType.RIGHT);
      this.setState({
        dialogOpen: newState.isOpen,
        topRightDialogOpen: topRightDialogOpen,
        helpOpen: (this.state.helpOpen && !newState.isOpen ? false : this.state.helpOpen)
      });
      this.state.topRightDialogOpen = topRightDialogOpen; // So that _setPortalOverlayVisibilityFromState reads new state
      this._setPortalOverlayVisibilityFromState();
    }
  };


  /**
   * Hide label filter control if other context menu is active.
   * @private
   */
  _onContextMenuChange = () => {
    const contextMenuTaken = (ContextMenuStateService.instance().getCurrentMenuContext(globals.LOWER_CONTEXT_MENU) !== undefined);
    if (contextMenuTaken !== this.state.contextMenuTaken) {
      this.setState({
        contextMenuTaken: contextMenuTaken
      });
    }

    // Reset comparing versions when the versions context menu is closed, and restore logo
    if (!contextMenuTaken && this.state.comparingVersions) {
      this.state.comparingVersions = false;
      this.setState({
        comparingVersions: false
      });
      this._setPortalLowerRightLogoVisibilityFromState();
    }
  };


  /**
   * Switches to radiometric textures.
   * @private
   */
  _switchToRadiometricTextures() {
    const prevCursor = this._viewer.getCursor();
    this._viewer.setCursor('wait');
    InstructionServiceActions.showInstruction('instructions.switch_to_radiometric');
    if (ShaderPaletteService.instance().getMulti()) {
      ShaderPaletteServiceActions.setRadiometric(true);
      this._viewer.setCursor(prevCursor);
      InstructionServiceActions.hideInstruction();
    }
    else {
      ModelManager.instance().changeTextures('', 'thermal_', 'jpg', 'png').then(() => {
        ShaderPaletteServiceActions.setRadiometric(true);
        this._viewer.setCursor(prevCursor);
        InstructionServiceActions.hideInstruction();
      });
    }
  }

  /**
   * Switches to visual textures.
   * @private
   */
  _switchToVisualTextures() {
    const prevCursor = this._viewer.getCursor();
    this._viewer.setCursor('wait');
    InstructionServiceActions.showInstruction('instructions.switch_to_visual');
    if (ShaderPaletteService.instance().getMulti()) {
      ShaderPaletteServiceActions.setRadiometric(false);
      this._viewer.setCursor(prevCursor);
      InstructionServiceActions.hideInstruction();
    }
    else {
      ModelManager.instance().changeTextures('thermal_', '', 'png', 'jpg').then(() => {
        ShaderPaletteServiceActions.setRadiometric(false);
        this._viewer.setCursor(prevCursor);
        InstructionServiceActions.hideInstruction();
      });
    }
  }

  undo = (evt) => {
    if (evt.ctrlKey) {
      EditorStateServiceActions.undo();
    }
  };

  redo = (evt) => {
    if (evt.ctrlKey) {
      EditorStateServiceActions.redo();
    }
  };

  /**
   * Toggles texture labels.
   */
  toggleTextureLabels = (evt) => {
    if (evt !== undefined && (evt.shiftKey || evt.ctrlKey)) {
      return;
    }

    //Make sure labels can not be visualized while toggling distance is active
    if (this.state.distanceSlider) {
      this.toggleDistanceSlider();
    }

    // Set this.state.textureLabels directly to make _setPortalLowerRightLogoVisibilityFromState work
    this.state.textureLabels = !this.state.textureLabels;
    ModelManager.instance().setTextureLabels(this.state.textureLabels);
    if (this.state.textureLabels) {
      const currentFilter = TextureLabelAdapter.getFilter();
      if (currentFilter.classIndices === undefined && this.state.reducedLabelClasses !== undefined) {
        const classIndices = [];
        for (const classIndex in this.state.reducedLabelClasses) {
          if (parseInt(classIndex) > 0) {
            classIndices.push(parseInt(classIndex));
          }
        }
        if (classIndices.length > 0) {
          currentFilter.classIndices = classIndices;
        }
      }
      TextureLabelAdapter.updateTextureLabels();
    }
    this.setState({
      textureLabels: this.state.textureLabels
    });
    this._setPortalLowerRightLogoVisibilityFromState();

    // Enable or disable any picked texture label line models
    ModelManager.instance().setPickedLabelModelsEnabled(this.state.textureLabels);

    // Toggle label eye-dropper interaction
    if (this._textureLabelEyeDropperInteraction !== undefined) {
      if (this.state.textureLabels) {
        this._textureLabelEyeDropperInteraction.enable();
      }
      else {
        this._textureLabelEyeDropperInteraction.disable();
      }
    }
  };

  /**
   * Toggles visual/radiometric view.
   */
  toggleRadiometric = () => {
    if (this._metadata.thermal === undefined || Object.keys(this._metadata.thermal).length === 0 || this._metadata.thermal.pure) {
      return;
    }

    const nonSyncedImageView = (this.state.imageOpen && (!ImageViewerService.instance().getRadiometricSynced() || ImageViewerService.instance().getCurrentCounterpartImageIndex() == -1));
    if (nonSyncedImageView) {
      // When toggling visual/radiometric from non-synced image view (there's no corresponding visual/radiometric image to switch to), go out to 3D instead
      if (this._imageSelectInteraction !== undefined) {
        this._imageSelectInteraction.setReopen(false);
      }
      ImageViewerServiceActions.close();
      ImageCatalogueServiceActions.close();
    }

    if (this.state.radiometric) {
      this.setState({
        radiometric: false,
        visualizedCameraThumbUrl: undefined,
        visualizedCameraControl: false
      });
      // Avoid switching textures from image view, but remember this as previous radiometric mode
      if (!this.state.imageOpen || nonSyncedImageView) {
        this._previousRadiometric = false;
        this._switchToVisualTextures();
      }
      else {
        ShaderPaletteServiceActions.setRadiometric(false);
      }

      if (this.state.visualizeCameras) {
        // Show only visual cameras
        this._viewer.getSceneViewer().visualizeCameraMatrices(
          undefined,
          undefined,
          this.state.visualizeCameraLines,
          undefined,
          undefined,
          false,
          this.state.visualizedCamerasScale
        );
      }

      if (this._cameraInteraction !== undefined) {
        // Let camera intersection know that we only want visual cameras
        this._cameraInteraction.setRadiometric(false);
      }
    }
    else {
      this.setState({
        radiometric: true,
        visualizedCameraThumbUrl: undefined,
        visualizedCameraControl: false
      });
      // Avoid switching textures from image view, but remember this as previous radiometric mode
      if (!this.state.imageOpen || nonSyncedImageView) {
        this._previousRadiometric = true;
        this._switchToRadiometricTextures();
      }
      else {
        ShaderPaletteServiceActions.setRadiometric(true);
      }

      if (this.state.visualizeCameras) {
        // Show only thermal cameras
        this._viewer.getSceneViewer().visualizeCameraMatrices(
          undefined,
          undefined,
          this.state.visualizeCameraLines,
          undefined,
          undefined,
          true,
          this.state.visualizedCamerasScale
        );
      }

      if (this._cameraInteraction !== undefined) {
        // Let camera intersection know that we only want radiometric cameras
        this._cameraInteraction.setRadiometric(true);
      }
    }
  };

  /**
   * Opens the palette controls.
   */
  openPaletteControls = () => {
    ContextMenuStateServiceActions.openContextMenu(
      globals.LOWER_CONTEXT_MENU,
      globals.PALETTE_CONTROL_ACTIVATED
    );
  }

  startEyeDropperInteraction = (delta) => {
    InteractionManager.instance().stopAllInteractions();
    InteractionManager.instance().startInteraction(CustomEyeDropperInteraction, this._viewer.getCanvas(), this._viewer.getId(), {
      demo: this._metadata.tools.thermaldemo,
      delta: delta,
      enableRectangle: ImageViewerService.instance().getState().isOpen && !delta,
      imageSelectionInteraction: this._imageSelectInteraction,
      showDownload: this._metadata.tools.downloadimage !== false,
      forceOverlayViewer: (this._metadata.tools.compass === true || this._metadata.tools.altitude === true)
    });
  };

  stopEyeDropperInteraction = () => {
    InteractionManager.instance().stopInteraction(CustomEyeDropperInteraction);
    DialogServiceActions.close();
  };

  reportPickedLabels = (labelImages) => {
    const images = [];
    const bboxes = [];
    const globalIds = [];
    for (let i = 0; i < labelImages.length; ++i) {
      const labelImage = labelImages[i];
      images.push(labelImage.camera.name);
      const ll = labelImage.imageCorners[1];
      const ur = labelImage.imageCorners[3];
      const width = labelImage.camera.size[1];
      const height = labelImage.camera.size[0];
      bboxes.push([
        Math.round(ll[0] * width),
        Math.round(ll[1] * height),
        Math.round(ur[0] * width),
        Math.round(ur[1] * height)
      ]);
      for (let j = 0; j < labelImage.labels.length; ++j) {
        const globalId = labelImage.labels[j].globalId;
        if (globalIds.indexOf(globalId) === -1) {
          globalIds.push(globalId);
        }
      }
    }
    parent.postMessage({
      id: this._communicationId,
      command: 'selectImages',
      images: images,
      bboxes: bboxes,
      globalids: globalIds
    }, '*');
  };

  toggleUnits = () => {
    const newImperial = !this.state.imperial;
    UnitsAdapter.read(newImperial ? 'imperial' : 'metric');
    this.setState({
      imperial: newImperial
    });
  };

  toggleDistanceSlider = () => {
    const newDistanceSliderState = !this.state.distanceSlider;
    if (!newDistanceSliderState) {
      this._viewer.getSceneViewer().resetUpdateNearFarValue();  
    }else{
      this.setState({
        distanceValues: DEFAULT_DISTANCE_SLIDER_VALUES
      })
    }
    this.setState({
      distanceSlider: newDistanceSliderState
    });
  };

  _copyLinkToClipboard = () => {
    // First try parent link provided on URL, if in iframe
    // (can't reach parent due to cross-site scripting even if just different sub-domains)
    let link = swea.util.getQueryParameters().link;
    if (link === undefined) {
      link = location.href;
    }

    const tempTextArea = document.createElement('textarea');
    tempTextArea.value = link;
    tempTextArea.textContent = link;
    document.body.appendChild(tempTextArea);
    tempTextArea.select();
    document.execCommand('copy');
    document.body.removeChild(tempTextArea);
  }

  shareToClipboard = () => {
    this._copyLinkToClipboard();
    InstructionServiceActions.showInstruction('instructions.shared_to_clipboard');
  };

  toggleShadows = () => {
    const sceneViewer = this._viewer.getSceneViewer();
    const shadowColor = sceneViewer.getShadowColor();
    if (sceneViewer.areShadowsEnabled()) {
      if (swea.util.areVectorsEqual(shadowColor, [0, 0, 0])) {
        sceneViewer.setShadowColor([1, 0, 1]);
      }
      else {
        const loadedModels = ModelManager.instance().getByType(LoadedModel);
        for (let i = 0; i < loadedModels.length; ++i) {
          const loadedModel = loadedModels[i];
          if (this._shadowModelsPreLitStates[loadedModel.getPaths()[0]] === false && loadedModel.isFakeLit()) {
            loadedModel.disableLighting();
          }
        }
        sceneViewer.disableShadows();
      }
    }
    else {
      const loadedModels = ModelManager.instance().getByType(LoadedModel);
      for (let i = 0; i < loadedModels.length; ++i) {
        const loadedModel = loadedModels[i];
        this._shadowModelsPreLitStates[loadedModel.getPaths()[0]] = loadedModel.isLit();
        loadedModel.enableLighting();
      }
      sceneViewer.enableShadows();
      sceneViewer.setShadowColor([0, 0, 0]);
    }
  };

  toggleLanguageMenu = () => {
    this.setState({
      showLanguageMenu: !this.state.showLanguageMenu
    });
  };

  changeLanguage = (lang) => {
    swea.i18n.changeLanguage(lang, () => {
      this.setState({
        lang: lang,
        showLanguageMenu: false
      });
    });
    ContextMenuStateServiceActions.closeContextMenu(
      globals.LOWER_CONTEXT_MENU
    );
    InstructionServiceActions.hideInstruction();
    this._loadHelp().then(() => {
      if (this.state.helpOpen) {
        DialogServiceActions.close().then(() => {
          this.help();
        });
      }
    });
  };

  toggleDebugMenu = () => {
    InteractionManager.instance().stopAllInteractions();
    this.setState({
      showDebugMenu: !this.state.showDebugMenu
    });
  };

  help = () => {
    if (this.state.helpOpen) {
      DialogServiceActions.close();
    }
    else {
      DialogServiceActions.open({
        title: i18n.t('help.title'),
        text: this._helpText,
        linkFunction: this._thirdPartyLicenseText !== undefined ? this._helpLinkClicked : undefined,
        alignment: DialogService.AlignmentType.CENTER,
        scrollable: true,
        html: true,
        selectable: true
      });
    }
    this.setState({
      helpOpen: !this.state.helpOpen
    })
  };

  _helpLinkClicked = (url) => {
    if (url === 'thirdpartylicenses') {
      DialogServiceActions.close().then(() => {
        DialogServiceActions.open({
          title: i18n.t('help.thirdparty'),
          text: this._thirdPartyLicenseText,
          alignment: DialogService.AlignmentType.CENTER,
          scrollable: true,
          html: true,
          selectable: true
        });
        this.setState({
          helpOpen: false
        });
      });
    } else if (url === 'downloadintertightfont') {
      const fontUrl = 'https://fonts.google.com/specimen/Inter+Tight'
      window.open(fontUrl, '_blank', 'noopener,noreferrer');
    }
  };

  toggleDepthColor = () => {
    const depthColored = !this.state.depthColored;
    if (this._baseModel !== undefined) {
      if (depthColored) {
        InteractionManager.instance().stopAllInteractions();
        InteractionManager.instance().startInteraction(CustomDepthInteraction, this._viewer.getCanvas(), this._viewer.getId(), {
          callback: () => {
            // Toggle textures on if off
            if (!this.state.textured) {
              this.toggleTexture();
            }

            this._baseModel.setDepthColored(true);
            ShaderPaletteServiceActions.setShaded(true);
          }
        });
      }
      else {
        this._baseModel.setDepthColored(false);
        ShaderPaletteServiceActions.setShaded(false);
      }
    }
    this.setState({
      depthColored: depthColored
    });
  };

  toggleTexture = (evt) => {
    if (evt !== undefined && (evt.shiftKey || evt.ctrlKey)) {
      return;
    }
    const textured = !this.state.textured;
    if (this._baseModel !== undefined) {
      if (textured) {
        this._baseModel.enableTextures();
        if (this._headlamp === undefined) {
          this._baseModel.disableLighting();
        }
      }
      else {
        this._baseModel.disableTextures();
        if (this._headlamp === undefined) {
          this._baseModel.enableLighting();
          this._baseModel.disableLighting(swea.util.HELPER_LIGHT_NUMBER);
        }
      }
    }
    this.setState({
      textured: textured
    });
  };

  startTimeControls = () => {
    ContextMenuStateServiceActions.openContextMenu(
      globals.LOWER_CONTEXT_MENU,
      globals.TIME_CONTROLS_ACTIVATED
    );
  }

  saveImage = () => {
    this._viewer.saveScreenshot();
  };

  moreImages = () => {
    // Do max 3x3 implicit inspects, in priority order (highest LAST)
    const canvas = this._viewer.getCanvas();
    const screenCoords = [
      [canvas.offsetLeft + 3 * canvas.width / 4, canvas.offsetTop + 3 * canvas.height / 4], // bottom right
      [canvas.offsetLeft + canvas.width / 4, canvas.offsetTop + 3 * canvas.height / 4],     // bottom left
      [canvas.offsetLeft + 3 * canvas.width / 4, canvas.offsetTop + canvas.height / 4],     // top right
      [canvas.offsetLeft + canvas.width / 4, canvas.offsetTop + canvas.height / 4],         // top left
      [canvas.offsetLeft + canvas.width / 2, canvas.offsetTop + 3 * canvas.height / 4],     // bottom center
      [canvas.offsetLeft + canvas.width / 2, canvas.offsetTop + canvas.height / 4],         // top center
      [canvas.offsetLeft + 3 * canvas.width / 4, canvas.offsetTop + canvas.height / 2],     // right
      [canvas.offsetLeft + canvas.width / 4, canvas.offsetTop + canvas.height / 2],         // left
      [canvas.offsetLeft + canvas.width / 2, canvas.offsetTop + canvas.height / 2]          // center
    ];
    InspectionAdapter.inspectMultiple(screenCoords, this._viewer.getSceneViewer()).then((data) => {
      ImageViewerServiceActions.close();
      this._imageSelectInteraction.setSmart(true, this._smartInspectImages);
      this._imageSelectInteraction.open(data);
    }).catch(() => {
      InstructionServiceActions.showInstruction('instructions.nomoreimages');
    });
  };

  _switchAnnotation(dir) {
    const annotationModel = ModelManager.instance().getSelectedModel();
    if (!(annotationModel instanceof AnnotationModel)) {
      return;
    }
    const annotationModels = ModelManager.instance().getByType(AnnotationModel);
    if (annotationModels.length < 2) {
      return;
    }

    // Sort by numbers
    annotationModels.sort((a1, a2) => {
      return parseInt(a1.getText()) - parseInt(a2.getText());
    });

    // Find new index
    const currIndex = annotationModels.indexOf(annotationModel);
    let newIndex = currIndex + dir;
    if (newIndex >= annotationModels.length) {
      newIndex = 0;
    }
    else if (newIndex < 0) {
      newIndex = annotationModels.length - 1;
    }

    // Select new annotation
    const newAnnotationModel = annotationModels[newIndex];
    const selectCommand = new SelectCommand({ nodeId: newAnnotationModel.getId(), viewerId: this._viewer.getId() });
    EditorStateServiceActions.addCommand(selectCommand);

    // Fly to new annotation
    const sceneViewer = this._viewer.getSceneViewer();
    const center = newAnnotationModel.getTranslation();
    let normal = newAnnotationModel.getPickedNormal();
    normal = swea.util.getNormalized([normal[0], normal[1], Math.max(normal[2], SWITCH_ANNOTATION_MIN_HEIGHT_FACTOR)]);
    if (normal === undefined) {
      // Just to be safe
      const currentEye = [0, 0, 0];
      const currentCenter = [0, 0, 0];
      const currentUp = [0, 0, 0];
      sceneViewer.getView(currentEye, currentCenter, currentUp);
      normal = swea.util.getNormalized(swea.util.subVectors(currentEye, currentCenter));
    }
    const eye = swea.util.addVectors(center, swea.util.multScalar(normal, SWITCH_ANNOTATION_DISTANCE));
    sceneViewer.flyToSimple(eye, center);
  }

  prevAnnotation = () => {
    this._switchAnnotation(-1);
  };

  nextAnnotation = () => {
    this._switchAnnotation(1);
  };

  showWorkspaceInfo = () => {
    if (this.state.workspaceInfoUrl === undefined) {
      return;
    }
    this.setState({
      splitScreenUrl: this.state.workspaceInfoUrl
    });
    this.state.splitScreenUrl = this.state.workspaceInfoUrl; // So that _setPortalOverlayVisibilityFromState reads new state
    this._setPortalOverlayVisibilityFromState();
  };

  /**
   * Toggle the version dropdown open/closed.
   * @private
   */
  _toggleVersionDropdown = () => {
    this.setState((prev) => ({ versionDropdownOpen: !prev.versionDropdownOpen }));
  };

  /**
   * Close the version dropdown if clicking outside of it.
   * @private
   */
  _handleVersionDropdownClickOutside = (e) => {
    if (this._versionDropdownRef && !this._versionDropdownRef.contains(e.target)) {
      this.setState({ versionDropdownOpen: false });
    }
  };

  /**
   * Select a version from the dropdown.
   * @param { number } version The version number (1 = regular).
   * @private
   */
  _selectVersionFromDropdown = (version) => {
    const currentVersion = VersionsService.instance().getState().version;
    this.setState({ versionDropdownOpen: false });
    if (this._changingVersionFromDropdown || version === currentVersion) {
      return;
    }
    this._changingVersionFromDropdown = true;

    // Clear any picked label selection before switching version
    ModelManager.instance().removePickedLabelModels();
    TextureLabelServiceActions.setSelectedAttributes([]);
    TextureLabelAdapter.resetGlobalIdFilter();
    TextureLabelServiceActions.setGlobalIdFilterActive(false);

    VersionsService.instance().whenVersionHasChanged().finally(() => {
      const viewerId = 0;
      const promises = [];
      const imageViewerOpen = ImageViewerService.instance().getState().isOpen;
      const imageCatalogOpen = ImageCatalogueService.instance().getState().isOpen;
      if (imageViewerOpen) {
        promises.push(ImageViewerServiceActions.close());
      }
      if (imageCatalogOpen) {
        promises.push(ImageCatalogueServiceActions.close());
      }
      Promise.all(promises).then(() => {
        VersionsServiceActions.setVersion(version, false, viewerId, undefined, () => {
          this._changingVersionFromDropdown = false;
        });
      });
    });
  };

  startVersions = () => {
    // Clear any picked label selection before entering versions mode
    ModelManager.instance().removePickedLabelModels();
    TextureLabelServiceActions.setSelectedAttributes([]);
    TextureLabelAdapter.resetGlobalIdFilter();
    TextureLabelServiceActions.setGlobalIdFilterActive(false);

    this.state.comparingVersions = false;
    this.setState({
      comparingVersions: false
    });
    this._setPortalLowerRightLogoVisibilityFromState();
    ContextMenuStateServiceActions.openContextMenu(
      globals.LOWER_CONTEXT_MENU,
      globals.VERSIONS_ACTIVATED
    );
  };

  startVersionComparison = () => {
    // Clear any picked label selection before entering compare mode
    ModelManager.instance().removePickedLabelModels();
    TextureLabelServiceActions.setSelectedAttributes([]);
    TextureLabelAdapter.resetGlobalIdFilter();
    TextureLabelServiceActions.setGlobalIdFilterActive(false);

    this.state.comparingVersions = true;
    this.setState({
      comparingVersions: true
    });
    this._setPortalLowerRightLogoVisibilityFromState();
    ContextMenuStateServiceActions.openContextMenu(
      globals.LOWER_CONTEXT_MENU,
      globals.VERSIONS_ACTIVATED
    );
  };

  toggleLights = () => {
    this.setState({
      lit: !this.state.lit
    });

    if (this._baseModel !== undefined) {
      if (this.state.lit) {
        this._baseModel.disableLighting();
      }
      else {
        this._baseModel.enableLighting();
      }
    }
  };

  toggleCameras = (evt) => {
    if (evt !== undefined) {
      if (evt.ctrlKey) {
        return;
      }
      else if (evt.shiftKey) {
        this.selectCamerasByRectangle();
        return;
      }
    }

    InteractionManager.instance().stopInteraction(CustomResolutionInteraction);
    InteractionManager.instance().stopInteraction(InspectVisualizedCamerasInteraction);

    const sceneViewer = this._viewer.getSceneViewer();
    if (sceneViewer.areCamerasVisualized()) {
      sceneViewer.removeCameraVisualization();
      this.setState({
        visualizeCameras: false,
        visualizedCamerasInspected: false,
        visualizedCameraThumbUrl: undefined,
        visualizedCameraControl: false,
        visualizedCamerasScaleDialogActive: false,
      });
    }
    else {
      sceneViewer.visualizeCameraMatrices(
        undefined,
        undefined,
        this.state.visualizeCameraLines,
        undefined,
        undefined,
        this._metadata.tools.thermal !== undefined && this._metadata.thermal.pure !== true ? this.state.radiometric : undefined,
        this.state.visualizedCamerasScale
      );
      this.setState({
        visualizeCameras: true,
        visualizedCamerasInspected: false,
        visualizedCameraThumbUrl: undefined,
        visualizedCameraControl: false,
        visualizedCamerasScaleDialogActive: true
      });
    }
  };

  toggleCameraLines = () => {
    InteractionManager.instance().stopInteraction(CustomResolutionInteraction);
    InteractionManager.instance().stopInteraction(InspectVisualizedCamerasInteraction);

    const visualizeCameraLines = !this.state.visualizeCameraLines;

    const sceneViewer = this._viewer.getSceneViewer();
    sceneViewer.removeCameraVisualization();
    sceneViewer.visualizeCameraMatrices(
      undefined,
      undefined,
      visualizeCameraLines,
      undefined,
      undefined,
      this._metadata.tools.thermal !== undefined && this._metadata.thermal.pure !== true ? this.state.radiometric : undefined,
      this.state.visualizedCamerasScale
    );

    if (this._cameraInteraction !== undefined) {
      this._cameraInteraction.setLines(visualizeCameraLines);
    }

    this.setState({
      visualizeCameraLines: visualizeCameraLines
    });
  };

  startVisualizedCameraInspection = () => {
    InteractionManager.instance().stopAllInteractions();
    InteractionManager.instance().startInteraction(InspectVisualizedCamerasInteraction, this._viewer.getCanvas(), this._viewer.getId(), {
      radiometric: this._metadata.thermal !== undefined && Object.keys(this._metadata.thermal).length > 0 ? this.state.radiometric : undefined,
      customScale: this.state.visualizedCamerasScale,
      callback: () => {
        this.setState({
          visualizedCamerasInspected: true,
          visualizedCameraThumbUrl: undefined,
          visualizedCameraControl: false
        });
      }
    });
  };

  disableVisualizedCameraInspection = () => {
    InteractionManager.instance().stopInteraction(InspectVisualizedCamerasInteraction);
    this._viewer.getSceneViewer().visualizeCameraMatrices(
      undefined,
      undefined,
      this.state.visualizeCameraLines,
      undefined,
      undefined,
      this._metadata.tools.thermal !== undefined && this._metadata.thermal.pure !== true ? this.state.radiometric : undefined,
      this.state.visualizedCamerasScale
    );
    this.setState({
      visualizedCamerasInspected: false,
      visualizedCameraThumbUrl: undefined,
      visualizedCameraControl: false
    });
  };

  _camerasPickedWithRectangle = (cameraIndices) => {
    if (cameraIndices.length === 0) {
      return;
    }

    let clipboardString = '';
    for (let i = 0; i < cameraIndices.length; ++i) {
      const camera = InspectionAdapter.getCameraByIndex(cameraIndices[i]);
      clipboardString += camera.name + '\n';
    }
    this._copyToClipboard(clipboardString);
    InstructionServiceActions.showInstruction('instructions.cameras_selected_by_rectangle');
  };

  selectCamerasByRectangle = () => {
    InteractionManager.instance().stopAllInteractions();
    InteractionManager.instance().startInteraction(CustomCameraRectangleInteraction, this._viewer.getCanvas(), this._viewer.getId(), {
      callback: this._camerasPickedWithRectangle,
      lines: this.state.visualizeCameraLines,
      customScale: this.state.visualizedCamerasScale,
      radiometric: this.state.radiometric
    });
  };

  _cameraExpanded = () => {
    this._imageSelectInteraction.setReopen(false);
  }

  toggleAnnotations = (evt) => {
    if (evt !== undefined && (evt.shiftKey || evt.ctrlKey)) {
      return;
    }

    const annotationsToggled = !this.state.annotationsToggled;
    ModelManager.instance().setAnnotationVisibility(annotationsToggled);

    this.setState({
      annotationsToggled: annotationsToggled
    });
  };

  toggleAnnotationFilterPanel = () => {
    this.setState({
        showAnnotationFilterPanel: !this.state.showAnnotationFilterPanel
    });
  };

  handleAnnotationFilterChange = (filter) => {
    ModelManager.instance().setAnnotationVisibility(true, filter);
    this.setState({
        annotationFilter: filter,
        annotationsToggled: true
    });
  };

  downloadCsv = () => {
    const showCreator = (this._metadata.tools.annotationcreator === true);
    const showTimestamps = (this._metadata.tools.annotationtimestamps === true);
    const depthProfilesActive = (this._metadata.tools.depthprofile === true || this._metadata.tools.cylinderprofile === true);
    AnnotationServiceActions.downloadCsv(showCreator, depthProfilesActive, showTimestamps);
  };

  /**
   * Measurement toggle function.
   */
  toggleMeasurements = (evt) => {
    if (evt !== undefined && (evt.shiftKey || evt.ctrlKey)) {
      return;
    }

    const measurementsToggled = !this.state.measurementsToggled;
    ModelManager.instance().setMeasurementVisibility(measurementsToggled);

    this.setState({
      measurementsToggled: measurementsToggled
    });
  };

  _copyToClipboard(str) {
    const fallbackCopy = () => {
      const textArea = document.createElement('textarea');
      textArea.value = str;
      textArea.style.position = 'fixed';
      textArea.style.left = '-9999px';
      textArea.style.top = '0';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        const successful = document.execCommand('copy');
        if (successful) {
          console.info('Copied using fallback.');
        } else {
          console.warn('Fallback copy failed.');
        }
      } catch (err) {
        console.error('Unable to copy to clipboard', err);
      }
      document.body.removeChild(textArea);
    };

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(str).then(() => {
        console.info('Copied to clipboard.');
      }).catch((err) => {
        console.warn('Clipboard API failed, trying fallback...', err);
        fallbackCopy();
      });
    } else {
      fallbackCopy();
    }
  }

  copyOrPastePose = (evt) => {
    if (evt.ctrlKey) {
      return;
    }

    if (evt.shiftKey) {
      this.copyPose();
    }
    else {
      this.pastePose();
    }
  };

  _disableGlobalIds(globalIds) {
    // Set disabled global IDs
    TextureLabelAdapter.setDisabledGlobalIds(globalIds);

    // Delete spatial filter and reset limits and global ID filter
    const filter = TextureLabelAdapter.getFilter();
    if ('nearCorners' in filter) {
      delete filter.nearCorners;
    }
    if ('farCorners' in filter) {
      delete filter.farCorners;
    }
    if ('minMaxValues' in filter) {
      delete filter.minMaxValues;
    }
    TextureLabelAdapter.resetGlobalIdFilter();

    // Reset filter flags, attributes and filters
    TextureLabelServiceActions.setSpatiallySelected(false);
    TextureLabelServiceActions.setGlobalIdFilterActive(false);
    TextureLabelServiceActions.setSelectedAttributes([]);

    // Remove any picked label visualization
    ModelManager.instance().removePickedLabelModels();

    // Close any Pick Labels context menu
    const currentMenuContext = ContextMenuStateService.instance().getCurrentMenuContext(globals.LOWER_CONTEXT_MENU);
    if (currentMenuContext === globals.TEXTURE_LABEL_EYE_DROPPER_ACTIVATED) {
      ContextMenuStateServiceActions.closeContextMenu(globals.LOWER_CONTEXT_MENU);
    }

    if (this.state.textureLabels) {
      // Toggle labels off and on again to update filter control
      this.toggleTextureLabels();
      setTimeout(() => {
        this.toggleTextureLabels();
      }, 500);
    }
  }

  storeDisabledLabels = (evt) => {
    if (evt !== undefined && (!evt.shiftKey || evt.ctrlKey)) {
      return;
    }

    // Get current filter
    const filter = TextureLabelAdapter.getFilter();
    if (filter.globalIds !== undefined && filter.globalIds.length > 0 && filter.globalIds.length < TextureLabelAdapter.getGisFilteredGlobalIds().length) {
      // There are global IDs filtered in, store those as disabled
      for (let i = 0; i < filter.globalIds.length; ++i) {
        const globalId = filter.globalIds[i];
        if (this._storedGlobalIds.indexOf(globalId) === -1) {
          this._storedGlobalIds.push(globalId);
        }
      }

      // Disable features now
      this._disableGlobalIds(this._storedGlobalIds);
    }
  };

  saveDisabledLabels = () => {
    HTTP.downloadTextData('disabled_features.json', JSON.stringify({ globalids: this._storedGlobalIds }));
  };

  loadDisabledLabels = () => {
    // Create temporary input tag for loading file
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = '.json';
    input.onchange = () => {
      const reader = new FileReader();
      reader.readAsText(input.files[0]);
      reader.addEventListener('load', () => {
        const json = JSON.parse(reader.result);
        if (json.globalids !== undefined && json.globalids.length > 0) {
          this._disableGlobalIds(json.globalids);
        }
      }, false);
    };

    // Pretend to click on input button
    input.click();
  };

  copyPose = () => {
    InteractionManager.instance().stopInteraction(CustomResolutionInteraction);
    InteractionManager.instance().stopInteraction(InspectVisualizedCamerasInteraction);

    const eye = [0, 0, 0];
    const center = [0, 0, 0];
    const up = [0, 0, 0];
    this._viewer.getSceneViewer().getSimpleView(eye, center);
    if (swea.util.getVectorLength2(eye) === 0.0 && swea.util.getVectorLength2(center) === 0.0) {
      this._viewer.getSceneViewer().getView(eye, center, up);
    }

    console.info('&eye=' + eye[0] + ',' + eye[1] + ',' + eye[2] + '&center=' + center[0] + ',' + center[1] + ',' + center[2]);
    console.info('"view": {\n  "eye": [' + eye[0] + ', ' + eye[1] + ', ' + eye[2] + '],\n  "center": [' + center[0] + ', ' + center[1] + ', ' + center[2] + ']\n}');

    const clipboardString = '&eye=' + eye.join(',') + '&center=' + center.join(',');
    
    this._copyToClipboard(clipboardString);

    this.setState({
      copiedPose: { eye, center }
    });

    DialogServiceActions.open(
      swea.i18n.t('components.copy_pose_dialog.title'),
      swea.i18n.t('components.copy_pose_dialog.text'),
      DialogService.AlignmentType.CENTER,
      true, false, undefined, undefined, false, undefined, undefined, false, true
    );
  };

  pastePose = () => {
    InteractionManager.instance().stopInteraction(CustomResolutionInteraction);
    InteractionManager.instance().stopInteraction(InspectVisualizedCamerasInteraction);

    const applyView = (eye, center) => {
      if (eye && center && eye.length === 3 && center.length === 3) {
        this._viewer.getSceneViewer().setSimpleView(eye, center);
        console.info('View pasted successfully.');
        return true;
      }
      return false;
    };

    const fallbackToInternal = () => {
       if (this.state.copiedPose !== undefined) {
          console.info('Using internal stored view as fallback.');
          this._viewer.getSceneViewer().setSimpleView(this.state.copiedPose.eye, this.state.copiedPose.center);
       } else {
          console.warn('No view found in clipboard or stored internally.');
       }
    };

    if (navigator.clipboard && navigator.clipboard.readText) {
      navigator.clipboard.readText().then((text) => {
        let success = false;

        if (text && (text.includes('eye=') || text.includes('&eye='))) {
          const extractCoords = (str, key) => {
            const regex = new RegExp(`[?&]${key}=([^&\\n]+)`);
            const match = str.match(regex);
            if (!match && str.startsWith(`${key}=`)) {
               const val = str.split('&')[0].split('=')[1];
               return val ? val.split(',').map(Number) : null;
            }
            return match ? match[1].split(',').map(Number) : null;
          };

          const queryStr = text.startsWith('&') ? text : '&' + text;
          const eye = extractCoords(queryStr, 'eye');
          const center = extractCoords(queryStr, 'center');
          
          success = applyView(eye, center);
        }

        if (!success) {
          fallbackToInternal();
        }

      }).catch((err) => {
        console.warn('Could not read clipboard. Using internal state fallback.', err);
        fallbackToInternal();
      });
    } 
    else {
      fallbackToInternal();
    }
  };

  copyThermal = (evt) => {
    if (evt !== undefined && (evt.shiftKey || evt.ctrlKey)) {
      return;
    }

    InteractionManager.instance().stopInteraction(CustomResolutionInteraction);
    InteractionManager.instance().stopInteraction(InspectVisualizedCamerasInteraction);

    const paletteName = ShaderPaletteService.instance().getPaletteName();
    const modelLimits = ShaderPaletteService.instance().getState().modelPaletteLimits;
    const imageLimits = ShaderPaletteService.instance().getState().imagePaletteLimits;

    let clipboardString = '"palette": "' + paletteName + '",\n'
    clipboardString += '"irlow": ' + modelLimits[0] + ',\n';
    clipboardString += '"irhigh": ' + modelLimits[1] + ',\n';
    clipboardString += '"irlowimage": ' + imageLimits[0] + ',\n';
    clipboardString += '"irhighimage": ' + imageLimits[1] + '\n';
    this._copyToClipboard(clipboardString);

    this.setState({
      copiedThermal: { paletteName, modelLimits, imageLimits }
    });

    DialogServiceActions.open(
      swea.i18n.t('components.copy_thermal_dialog.title'),
      swea.i18n.t('components.copy_thermal_dialog.text'),
      DialogService.AlignmentType.CENTER,
      true, false, undefined, undefined, false, undefined, undefined, false, true
    );
  };

  pasteThermal = () => {
    InteractionManager.instance().stopInteraction(CustomResolutionInteraction);
    InteractionManager.instance().stopInteraction(InspectVisualizedCamerasInteraction);

    if (this.state.copiedThermal === undefined) {
      return;
    }

    ShaderPaletteServiceActions.setPaletteByName(this.state.copiedThermal.paletteName, true, true);

    // Order-dependent to set current limits (model or image) last
    if (this.state.imageOpen) {
      ShaderPaletteServiceActions.setPaletteLimits(this.state.copiedThermal.modelLimits[0], this.state.copiedThermal.modelLimits[1], true, false);
      ShaderPaletteServiceActions.setPaletteLimits(this.state.copiedThermal.imageLimits[0], this.state.copiedThermal.imageLimits[1], false, true);
    }
    else {
      ShaderPaletteServiceActions.setPaletteLimits(this.state.copiedThermal.imageLimits[0], this.state.copiedThermal.imageLimits[1], false, true);
      ShaderPaletteServiceActions.setPaletteLimits(this.state.copiedThermal.modelLimits[0], this.state.copiedThermal.modelLimits[1], true, false);
    }
  };

  toggleGsd = (type, evt) => {
    if (evt !== undefined && (evt.shiftKey || evt.ctrlKey)) {
      return;
    }

    InteractionManager.instance().stopInteraction(CustomResolutionInteraction);
    InteractionManager.instance().stopInteraction(InspectVisualizedCamerasInteraction);

    if (this._gsdModels.length === 0) {
      return;
    }

    for (let i = 0; i < this._gsdModels.length; ++i) {
      const gsdModel = this._gsdModels[i];
      if (gsdModel.type === type) {
        if (gsdModel.model.isEnabled()) {
          gsdModel.model.disable();
        }
        else {
          gsdModel.model.enable();
        }
      }
      else {
        gsdModel.model.disable();
      }
    }

    this.state.gsdToggledPerType[type] = !this.state.gsdToggledPerType[type];
    this.setState({
      gsdToggledPerType: this.state.gsdToggledPerType
    });

    // Reset and close shader palette menu (forces resetting limits next time)
    if (ContextMenuStateService.instance().getCurrentMenuContext(globals.LOWER_CONTEXT_MENU) === globals.PALETTE_CONTROL_ACTIVATED) {
      ContextMenuStateServiceActions.closeContextMenu(globals.LOWER_CONTEXT_MENU);
    }
    ShaderPaletteServiceActions.setPaletteLimits(0.0, 1.0);
  };

  startResolutionInteraction = () => {
    InteractionManager.instance().stopAllInteractions();
    InteractionManager.instance().startInteraction(CustomResolutionInteraction, this._viewer.getCanvas(), this._viewer.getId());
  };

  stopResolutionInteraction = () => {
    InteractionManager.instance().stopInteraction(CustomResolutionInteraction);
  };

  startSpecifyTransformInteraction = () => {
    ContextMenuStateServiceActions.openContextMenu(
      globals.LOWER_CONTEXT_MENU,
      globals.SPECIFY_TRANSFORM_ACTIVATED
    );
  };

  toggleModel = (evt) => {
    if (evt !== undefined && evt.ctrlKey) {
      return;
    }

    const togglingBase = (evt == undefined || !evt.shiftKey);
    const togglingSplat = (evt !== undefined && evt.shiftKey);

    const modelInvisible = (togglingBase ? !this.state.modelInvisible : this.state.modelInvisible);
    const splatInvisible = (togglingSplat ? !this.state.splatInvisible : this.state.splatInvisible);

    if (togglingBase) {
      InteractionManager.instance().stopInteraction(CustomResolutionInteraction);
      InteractionManager.instance().stopInteraction(InspectVisualizedCamerasInteraction);
    }

    const loadedModels = ModelManager.instance().getByType(LoadedModel);
    for (let i = 0; i < loadedModels.length; ++i) {
      const loadedModel = loadedModels[i];
      const base = (loadedModel.getNodeMask() & traversalMasks.BASE_MODEL_MASK);
      const splat = loadedModel.isSplat();

      if (base && togglingBase) {
        if (modelInvisible) {
          loadedModel.disable();
        }
        else {
          loadedModel.enable();
        }
      }
      else if (splat && togglingSplat) {
        if (splatInvisible) {
          loadedModel.disable();
        }
        else {
          loadedModel.enable();
        }
      }
    }

    if (togglingBase) {
      // With texture labels, base model is not invisible in image, so do like this instead
      ModelManager.instance().setTextureLabelsOnlyActive(modelInvisible);
    }

    this.setState({
      modelInvisible: modelInvisible,
      splatInvisible: splatInvisible
    });
  };

  toggleModelInImage = (evt) => {
    if (evt !== undefined && (evt.shiftKey || evt.ctrlKey)) {
      return;
    }

    InteractionManager.instance().stopInteraction(CustomResolutionInteraction);
    InteractionManager.instance().stopInteraction(InspectVisualizedCamerasInteraction);

    const invisibleInImage = !this.state.invisibleInImage;

    let numImageVisibilityModels = this._imageVisibilityModels.length;
    if (this._imageVisibilityModels.length === 0) {
      const models = ModelManager.instance().getByType(Model);
      for (let i = 0; i < models.length; ++i) {
        const model = models[i];
        if (!(model instanceof SkyModel) && model.getInvisibleInImage()) {
          this._imageVisibilityModels.push(model);
        }
      }
      numImageVisibilityModels = this._imageVisibilityModels.length;
    }

    for (let i = 0; i < numImageVisibilityModels; ++i) {
      this._imageVisibilityModels[i].setInvisibleInImage(!this._imageVisibilityModels[i].getInvisibleInImage());
    }

    // With texture labels, base model is not invisible in image, so do like this instead
    ModelManager.instance().setTextureLabelsOnlyActive(invisibleInImage);

    this.setState({
      invisibleInImage: invisibleInImage
    });
  };

  toggleClassificationBacksides = (evt) => {
    if (evt !== undefined && (evt.shiftKey || evt.ctrlKey)) {
      return;
    }

    InteractionManager.instance().stopInteraction(CustomResolutionInteraction);
    InteractionManager.instance().stopInteraction(InspectVisualizedCamerasInteraction);

    const classificationBacksides = !this.state.classificationBacksides;
    const classificationGroupModels = ModelManager.instance().getByType(ClassificationGroupModel);
    for (let i = 0; i < classificationGroupModels.length; ++i) {
      classificationGroupModels[i].setSingleSided(!classificationBacksides);
    }

    this.setState({
      classificationBacksides: classificationBacksides
    });
  }

  toggleModelAboveSplat = (evt) => {
    if (this._baseModel === undefined || (evt !== undefined && (evt.shiftKey || evt.ctrlKey))) {
      return;
    }
    this._baseModel.toggleDepthOnly();
  };

  toggleSplat = (evt) => {
    if (this._splatModel === undefined || (evt !== undefined && (evt.shiftKey || evt.ctrlKey))) {
      return;
    }

    if (this._splatModel.isEnabled()) {
      // Disable splat model
      this._splatModel.disable();

      // Disable other models from being rendered above splat
      const models = ModelManager.instance().getByType(Model);
      for (let i = 0; i < models.length; ++i) {
        const model = models[i];
        if (!model.isSplat()) {
          model.toggleAboveSplat();
        }
      }

      // Set white or URL-defined background
      this.setState({
        backgroundColor: (swea.util.getQueryParameters().background == undefined ? 'ffffff' : swea.util.getQueryParameters().background)
      });

      // Enable sky
      if (this._skyModel !== undefined) {
        this._skyModel.enable();
      }
    }
    else {
      // Enable splat model
      this._splatModel.enable();

      // Render other models above splat
      const models = ModelManager.instance().getByType(Model);
      for (let i = 0; i < models.length; ++i) {
        const model = models[i];
        if (!model.isSplat()) {
          model.toggleAboveSplat();
        }
      }

      // Disable sky
      if (this._skyModel !== undefined) {
        this._skyModel.disable();
      }
    }
  };

  _backFromSubModel = () => {
    this.setState({
      gotoModelUrl: this._backUrl
    });

    if (DialogService.instance().getRememberedReply(swea.i18n.t('components.main_model_dialog.title')) === true) {
      this._goToModel(this._backUrl);
    }
    else {
      DialogServiceActions.open({
        title: swea.i18n.t('components.main_model_dialog.title'),
        text: swea.i18n.t('components.main_model_dialog.text'),
        alignment: DialogService.AlignmentType.CENTER,
        small: true,
        yesNo: true,
        yesTooltip: swea.i18n.t('components.main_model_dialog.yes'),
        noTooltip: swea.i18n.t('components.main_model_dialog.no'),
        rememberCheckbox: true,
        rememberLabel: swea.i18n.t('components.main_model_dialog.remember')
      });
    }
  };

  startElevationInteraction = () => {
    InteractionManager.instance().stopAllInteractions();
    InteractionManager.instance().startInteraction(ElevationInteraction, this._viewer._canvas, this._viewer.getId(), {
      geographicOffset: this._metadata.offset
    });
  };


  updateSensitivity = (evt) => {
    if (evt !== undefined) {
      const sceneViewer = this._viewer.getSceneViewer();
      const manipulator = sceneViewer.getManipulator();

      if (manipulator instanceof OrbitManipulator) {
        if (evt.keyCode === eventCodes.PAGE_DOWN) {
          manipulator.decreaseFactors();
          InstructionServiceActions.setHidden(false);
          InstructionServiceActions.showInstruction(swea.i18n.t('instructions.decreasesensitivity'), 1);
        } else if (evt.keyCode === eventCodes.PAGE_UP) {
          manipulator.increaseFactors();
          InstructionServiceActions.setHidden(false);
          InstructionServiceActions.showInstruction(swea.i18n.t('instructions.increasesensitivity'), 1);
        } else if (evt.keyCode === eventCodes.HOME) {
          manipulator.resetFactors();
          InstructionServiceActions.setHidden(false);
          InstructionServiceActions.showInstruction(swea.i18n.t('instructions.resetsensitivity'), 1);
        }
      }
    }
  };

  toggleImageSmoothing = () => {
    ImageViewerServiceActions.toggleImageSmoothing();
  };

  /**
   * Converts a linear slider position (0..1) to a logarithmic camera scale value.
   * @param { number } position Slider position in [0, 1].
   * @param { number } min Minimum scale value.
   * @param { number } max Maximum scale value.
   * @returns { number } The logarithmically mapped scale value.
   */
  _logSliderToScale(position, min, max) {
    const logMin = Math.log(min);
    const logMax = Math.log(max);
    return Math.exp(logMin + position * (logMax - logMin));
  }

  /**
   * Converts a camera scale value to a linear slider position (0..1).
   * @param { number } value The scale value.
   * @param { number } min Minimum scale value.
   * @param { number } max Maximum scale value.
   * @returns { number } Linear value in [0, 1].
   */
  _scaleToLogSlider(value, min, max) {
    const logMin = Math.log(min);
    const logMax = Math.log(max);
    return (Math.log(value) - logMin) / (logMax - logMin);
  }

  handleCameraScaleChange = (newScaleFromInput) => {
    const newScale = parseFloat(newScaleFromInput);

    if (!isNaN(newScale) && newScale > 0) {
      this.setState({ visualizedCamerasScale: newScale }, () => {
        if (this._cameraScaleInput) {
          this._cameraScaleInput.setValue(this.state.visualizedCamerasScale.toFixed(2));
        }

        if (this._cameraInteraction) {
          this._cameraInteraction.setCustomScale(newScale);
        }

        const sceneViewer = this._viewer.getSceneViewer();

        if (sceneViewer && sceneViewer.areCamerasVisualized()) {
          sceneViewer.removeCameraVisualization();
          sceneViewer.visualizeCameraMatrices(
            undefined,
            undefined,
            this.state.visualizeCameraLines,
            undefined,
            undefined,
            this._metadata.tools.thermal !== undefined && this._metadata.thermal.pure !== true ? this.state.radiometric : undefined,
            this.state.visualizedCamerasScale
          );
        }
      });
    }
  };
  
  _aiReport = (reportData) => {
    const serverUrl = Globals.config.cloudServer;
    if (serverUrl !== undefined && serverUrl !== '') {
      parent.postMessage({
        id: this._communicationId,
        command: 'aiReport',
        value: reportData
      }, '*');
    }
  };
  
  UNSAFE_componentWillReceiveProps(newProps) {
    this.setState(newProps);
  }
  
  toggleVisualizeMask = () => {
      const maskState = MaskService.instance().getState();
      if (maskState.availableClasses.length === 0) {
        return;
      }

      // Check if already open — toggle off
      const currentMenuContext = ContextMenuStateService.instance().getCurrentMenuContext(globals.LOWER_CONTEXT_MENU);
      if (currentMenuContext === globals.MASK_CLASSES_ACTIVATED) {
        ContextMenuStateServiceActions.closeContextMenu(globals.LOWER_CONTEXT_MENU);
        MaskServiceActions.deactivate();
        return;
      }

      ContextMenuStateServiceActions.openContextMenu(
        globals.LOWER_CONTEXT_MENU,
        globals.MASK_CLASSES_ACTIVATED
      );
  };

  _onMaskChange = () => {
    const maskState = MaskService.instance().getState();
    this.setState({
      maskAvailableClasses: maskState.availableClasses,
      maskActiveClass: maskState.activeClass,
      maskActive: maskState.isActive
    });
  };


  /**
   * Render the component.
   */
  render() {
    let loadButton, saveButton, inspectButton, measureButton, freeViewButton, topViewButton, sideViewButton, topFreeButton;
    let cylinderViewButton, turnCylinderViewLeftButton, turnCylinderViewRightButton;
    let clipSlider, distanceSlider, homeButton;
    let catalogButton, drawAreaButton, drawLineButton, solidAreaButton, sectionVolumeButton, annotationButton, distanceButton, bulldozeButton, extruder, sectionVolumeExtruder;
    let toggle3dButton, filterButton, switchAnnotationsSpan, versionsButton, versionComparisonButton;
    let thermalButton, paletteButton, eyedropperButton, eyedropperDeltaButton;
    let textureLabelsButton, labelFilterControl;
    let classificationButton, classificationReportButton, classificationReport, workspaceInfoButton;
    let annotationReportButton, annotationReport, unitButton, saveImageButton;
    let toggleModelsButton, shareButton, timeButton, toggleMeasurementsButton, toggleLightsButton;
    let camerasButton, inspectCamerasButton, toggleAnnotationsButton, depthColorButton, toggleTextureButton, filterAnnotationsButton;
    let downloadCsvButton, toggleSectionVolumesButton, exportSectionsButton;
    let toggleSweaModelButton;
    let visualizeMaskButton;

    // Find GSD min/max and which types are active
    let gsdMinMax = undefined;
    const gsdTypesActive = [];
    let anyGsdModelsEnabled = false;
    for (let i = 0; i < this._gsdModels.length; ++i) {
      const gsdModel = this._gsdModels[i];
      if (gsdTypesActive.indexOf(gsdModel.type) === -1) {
        gsdTypesActive.push(gsdModel.type);
      }
      if (gsdModel.model !== undefined && gsdModel.model.isEnabled()) {
        anyGsdModelsEnabled = true;
        if (gsdMinMax === undefined) {
          gsdMinMax = gsdModel.model.getGsdMinMax();
        }
        else {
          const localMinMax = gsdModel.model.getGsdMinMax();
          gsdMinMax = [
            Math.min(gsdMinMax[0], localMinMax[0]),
            Math.min(gsdMinMax[1], localMinMax[1])
          ];
        }
      }
    }

    const versions = VersionsService.instance().getState().versions;

    if (this.state.showMenu && this._metadata.tools.menu !== undefined) {
      // Share to clipboard
      if (this._metadata.tools.share !== undefined) {
        shareButton = (
          <MenuItem afterUndoRedo
            small
            onClick={this.shareToClipboard} img={'img/copy_link.svg'}
            tooltip={this._metadata.tools.share === false ? 'tooltip.full_demo' : 'tooltip.share'}
            disabled={this._metadata.tools.share === false}
          />
        );
      }

      // Home
      if (this._metadata.tools.home !== undefined && this.state.viewType === ViewType.FREE) {
        homeButton = (
          <MenuItem beforeUndoRedo
            small
            onClick={this.home} img={'img/home.svg'}
            tooltip={this._metadata.tools.home === false ? 'tooltip.full_demo' : 'tooltip.home'}
            disabled={this.state.catalogOpen || this.state.imageOpen || this._metadata.tools.home === false}
          />
        );
      }

      // Toggle 2D/3D
      if (this._metadata.tools.toggle3d !== undefined) {
        toggle3dButton = (
          <MenuItem beforeUndoRedo
            small
            onClick={this.toggle3D} img={this.state.viewState === ViewStateManager.ViewStates.STATE_3D ? 'img/2d.svg' : 'img/3d.svg'}
            tooltip={this._metadata.tools.toggle3d === false ? 'tooltip.full_demo' : (this.state.viewState === ViewStateManager.ViewStates.STATE_3D ? 'tooltip.photoview' : 'tooltip.3Dview')}
            disabled={this._metadata.tools.toggle3d === false}
          />
        );
      }

      // Filter
      if (this._metadata.tools.filter !== undefined) {
        filterButton = (
          <MenuItem beforeUndoRedo
            small
            onClick={this.toggleFilterFavorites} img={this.state.filter ? 'img/star_empty.svg' : 'img/star.svg'}
            tooltip={this._metadata.tools.filter === false ? 'tooltip.full_demo' : (this.state.filter ? 'tooltip.filter_remove' : 'tooltip.filter')}
            disabled={!this.state.catalogOpen || this._metadata.tools.filter === false}
          />
        );
      }

      // Metric/imperial
      if (this._metadata.tools.units !== undefined) {
        unitButton = (
          <MenuItem beforeUndoRedo
            small
            onClick={this.toggleUnits} img={'img/units.svg'}
            tooltip={this._metadata.tools.units === false ? 'tooltip.full_demo' : 'tooltip.units'}
            disabled={this._metadata.tools.units === false}
          />
        );
      }

      // Load/save
      if (this._metadata.tools.loadsave !== undefined) {
        if (this.state.cloudSave === undefined) {
          if (swea.util.getQueryParameters().project === undefined) {
            loadButton = (
              <MenuItem
                onClick={this.loadFromDisk}
                img={'img/open.svg'}
                small={true}
                tooltip={this._metadata.tools.loadsave === false ? 'tooltip.full_demo' : 'tooltip.open'}
                disabled={this.state.catalogOpen || this._metadata.tools.loadsave === false}
              />
            );
            saveButton = (
              <MenuItem
                onClick={this.saveToDisk}
                img={'img/download.svg'}
                small={true}
                tooltip={this._metadata.tools.loadsave === false ? 'tooltip.full_demo' : 'tooltip.save'}
                disabled={this.state.catalogOpen || this._metadata.tools.loadsave === false}
              />
            );
          }
        }
        else {
          loadButton = (
            <MenuItem
              onClick={this.loadFromCloud}
              img={'img/download_from_cloud.svg'}
              small={true}
              tooltip={this._metadata.tools.loadsave === false ? 'tooltip.full_demo' : 'tooltip.open'}
              disabled={this.state.catalogOpen || this._metadata.tools.loadsave === false}
            />
          );
          saveButton = (
            <MenuItem
              onClick={this.saveToCloud}
              img={'img/upload_to_cloud.svg'}
              small={true}
              tooltip={this._metadata.tools.loadsave === false ? 'tooltip.full_demo' : 'tooltip.save'}
              disabled={this.state.catalogOpen || this._metadata.tools.loadsave === false}
            />
          );
        }
      }

      // View
      if (this._metadata.tools.ortho !== undefined) {
        freeViewButton = (
          <MenuItem
            beforeUndoRedo
            small
            onClick={this.setFreeView} img={'img/free.svg'}
            tooltip={this._metadata.tools.ortho === false ? 'tooltip.full_demo' : 'tooltip.freeview'}
            disabled={this.state.viewType === ViewType.FREE || this.state.imageOpen || this.state.catalogOpen || this._metadata.tools.ortho === false}
          />
        );
        topViewButton = (
          <MenuItem
            beforeUndoRedo
            small
            onClick={this.setTopView} img={'img/top.svg'}
            tooltip={this._metadata.tools.ortho === false ? 'tooltip.full_demo' : 'tooltip.topview'}
            disabled={this.state.viewType === ViewType.TOP || this.state.imageOpen || this.state.catalogOpen || this._metadata.tools.ortho === false}
          />
        );
        sideViewButton = (
          <MenuItem
            beforeUndoRedo
            small
            onClick={this.setSideView} img={'img/side.svg'}
            tooltip={this._metadata.tools.ortho === false ? 'tooltip.full_demo' : 'tooltip.sideview'}
            disabled={this.state.viewType !== ViewType.FREE || this.state.imageOpen || this.state.catalogOpen || this._metadata.tools.ortho === false}
          />
        );
      }

      // Cylinder view
      if (this._metadata.tools.cylinderview === true && this._metadata.view.cylinderdiameter !== undefined) {
        let disabled = (this.state.imageOpen || this.state.catalogOpen);
        cylinderViewButton = (
          <MenuItem
            beforeUndoRedo
            small
            onClick={this.toggleCylinderView} img={'img/cylinder.svg'}
            tooltip={'tooltip.cylinderview'}
            disabled={disabled}
            className={disabled ? s.disabledButton : (this.state.viewType == ViewType.CYLINDER ? s.activeButton : undefined)}
          />
        );

        disabled = (this.state.imageOpen || this.state.catalogOpen || this.state.viewType !== ViewType.CYLINDER);
        turnCylinderViewLeftButton = (
          <MenuItem
            beforeUndoRedo
            small
            onClick={this.turnCylinderLeft} img={'img/cylinder_left.svg'}
            tooltip={'tooltip.cylinderviewleft'}
            disabled={disabled}
          />
        );
        turnCylinderViewRightButton = (
          <MenuItem
            beforeUndoRedo
            small
            onClick={this.turnCylinderRight} img={'img/cylinder_right.svg'}
            tooltip={'tooltip.cylinderviewright'}
            disabled={disabled}
          />
        );
      }

      // Free/top toggle
      if (this._metadata.tools.free_top_toggle !== undefined) {
        topFreeButton = (
          <MenuItem
            beforeUndoRedo
            small
            onClick={this.toggleFreeTopView} img={this.state.viewType === ViewType.TOP ? 'img/free.svg' : 'img/top.svg'}
            tooltip={this._metadata.tools.free_top_toggle === false ? 'tooltip.full_demo' : (this.state.viewType === ViewType.TOP ? 'tooltip.freeview' : 'tooltip.topview')}
            disabled={this.state.imageOpen || this.state.catalogOpen || this._metadata.tools.free_top_toggle === false}
          />
        );
      }

      // Clip slider
      if (!BrowserInfo.isMobile() && !this.state.textureLabels && (this._metadata.tools.ortho === true || this._metadata.tools.free_top_toggle === true)) {
        if (this.state.viewType == ViewType.TOP || this.state.viewType == ViewType.SIDE) {
          clipSlider = (
            <span>
              <span className={s.clipSliderLabel}>{i18n.t('components.clip.title')}:</span>
              <span className={s.clipSlider}>
                <Slider
                  dual={true}
                  callback={this.updateClip}
                  values={[Math.round(100 * this.state.clipFactors[0]), Math.round(100 * this.state.clipFactors[1])]}
                />
              </span>
            </span>
          );
        }
      }

      
      // DistanceSlider - Same styling as clipslider
      if (!BrowserInfo.isMobile() && !this.state.textureLabels && this.state.distanceSlider && this.state.viewType != ViewType.SIDE &&
                this.state.viewType != ViewType.TOP) {
        distanceSlider = (
          <span>
            <span className={s.clipSliderLabel}>{i18n.t('components.nearclip.title')}</span>
            <span className={s.clipSlider}>
              <Slider
                dual={false}
                domain={[0.1, 10]}
                callback={this.updateDistance}
                values={[this.state.distanceValues[0]]}
              />
            </span>
          </span>
        );
      }


      // Inspect
      if (this._metadata.tools.inspect !== undefined) {
        inspectButton = (
          <MenuItem
            onClick={this.startInspectInteraction}
            img={'img/inspect.svg'}
            tooltip={this._metadata.tools.inspect === false ? 'tooltip.full_demo' : 'tooltip.inspect'}
            disabled={this.state.catalogOpen || this.state.imageOpen || this._metadata.tools.inspect === false}
          />
        );
      }

      // Measure
      if (this._metadata.tools.measure !== undefined) {
        measureButton = (
          <MenuItem
            onClick={this.startMeasureInteraction}
            img={'img/distance.svg'}
            tooltip={this._metadata.tools.measure === false ? 'tooltip.full_demo' : 'tooltip.measure'}
            disabled={this.state.catalogOpen || this._metadata.tools.measure === false || (BrowserInfo.isMobile() && this.state.imageOpen)}
          />
        );
      }


      // Annotate
      if (this._metadata.tools.annotate !== undefined) {
        annotationButton = (
          <MenuItem
            onClick={this.startAnnotationInteraction}
            img={'img/annotation.svg'}
            tooltip={this._metadata.tools.annotate === false ? 'tooltip.full_demo' : 'tooltip.annotate'}
            disabled={this.state.catalogOpen || this._metadata.tools.annotate === false || (BrowserInfo.isMobile() && this.state.imageOpen)}
          />
        );
      }

      // Toggle distance slider button
      if((this._metadata.tools.distance_slider === true && swea.util.getQueryParameters().nearclipslider !== '0' )|| swea.util.getQueryParameters().nearclipslider === '1'){
        distanceButton = (
          <MenuItem beforeUndoRedo
            small
            onClick={this.toggleDistanceSlider}
            img={this.state.distanceSlider ? 'img/view_clip_off.svg' : 'img/view_clip.svg'}
            tooltip={'tooltip.toggle_clip'}
            disabled={
              (this.state.textureLabels ||
                this.state.viewType == ViewType.SIDE ||
                this.state.viewType == ViewType.TOP)
            }
          />
        );
      }
      

      // Areas
      if (this._metadata.tools.areas !== undefined) {
        drawAreaButton = (
          <MenuItem
            onClick={this.startTextAreaInteraction}
            img={'img/area.svg'}
            tooltip={this._metadata.tools.areas === false ? 'tooltip.full_demo' : 'tooltip.draw_area'}
            disabled={this.state.catalogOpen || this._metadata.tools.areas === false || (BrowserInfo.isMobile() && this.state.imageOpen)}
          />
        );
      }

      // Lines
      if (this._metadata.tools.lines !== undefined) {
        drawLineButton = (
          <MenuItem
            onClick={this.startTextLineInteraction}
            img={'img/line.svg'}
            tooltip={this._metadata.tools.lines === false ? 'tooltip.full_demo' : 'tooltip.draw_line'}
            disabled={this.state.catalogOpen || this._metadata.tools.lines === false || (BrowserInfo.isMobile() && this.state.imageOpen)}
          />
        );
      }

      // Solid area
      if (this._metadata.tools.solid !== undefined) {
        solidAreaButton = (
          <MenuItem
            onClick={this.startSolidAreaInteraction}
            img={'img/solid_area.svg'}
            tooltip={this._metadata.tools.solid === false ? 'tooltip.full_demo' : 'tooltip.draw_solid_area'}
            disabled={this.state.catalogOpen || this._metadata.tools.solid === false || (BrowserInfo.isMobile() && this.state.imageOpen)}
          />
        );
      }

      // Section volume (only show draw button and extruder when sectionvolumes is explicitly true)
      if (this._metadata.tools.sectionvolumes === true) {
        sectionVolumeButton = (
          <MenuItem
            onClick={this.startSectionVolumeInteraction}
            img={'img/section_volume.svg'}
            tooltip={'tooltip.draw_section_volume'}
            disabled={this.state.catalogOpen || (BrowserInfo.isMobile() && this.state.imageOpen)}
          />
        );
        sectionVolumeExtruder = (
          <SectionVolumeExtruder />
        );
      } else if (this._metadata.tools.sectionvolumes !== undefined || this._metadata.sections !== undefined) {
        // When sectionvolumes is false but sections exist in metadata, still provide the extruder
        // so that selecting existing metadata sections shows their info (read-only behavior)
        sectionVolumeExtruder = (
          <SectionVolumeExtruder />
        );
      }

      // Bulldoze
      if (this._metadata.tools.bulldoze !== undefined) {
        bulldozeButton = (
          <MenuItem
            onClick={this.startBulldoze}
            img={'img/bulldoze.svg'}
            tooltip={this._metadata.tools.bulldoze === false ? 'tooltip.full_demo' : 'tooltip.bulldoze'}
            disabled={this.state.catalogOpen || this.state.imageOpen || this._metadata.tools.bulldoze === false || this.state.viewState === ViewStateManager.ViewStates.STATE_2D}
          />
        );
      }

      // Model catalog
      if (this._metadata.tools.catalog !== undefined) {
        catalogButton = (
          <MenuItem
            onClick={this.openCatalogue}
            img={'img/folder.svg'}
            tooltip={this._metadata.tools.catalog === false ? 'tooltip.full_demo' : 'tooltip.models'}
            disabled={this.state.catalogOpen || this._metadata.tools.catalog === false || (BrowserInfo.isMobile() && this.state.imageOpen)}
          />
        );
      }

      // Extrude
      if (this._metadata.tools.extrude !== undefined) {
        extruder = (
          <Extruder disabled={this.state.catalogOpen || this._metadata.tools.extrude === false} />
        );
      }

      // Toggle models
      if (this._metadata.tools.togglemodels !== undefined) {
        toggleModelsButton = (
          <MenuItem
            onClick={this.openToggleModels}
            img={'img/toggle.svg'}
            tooltip={this._metadata.tools.togglemodels === false ? 'tooltip.full_demo' : 'tooltip.toggle'}
            disabled={this.state.catalogOpen || this._metadata.tools.togglemodels === false || (BrowserInfo.isMobile() && this.state.imageOpen)}
          />
        );
      }

      // Thermal
      if (this._metadata.tools.thermal !== undefined && Object.keys(this._metadata.thermal).length > 0) {
        if (this._metadata.thermal !== undefined && this._metadata.thermal.pure !== true) {
          thermalButton = (
            <MenuItem
              beforeUndoRedo
              small
              onClick={this.toggleRadiometric}
              img={this.state.radiometric ? 'img/vis.svg' : 'img/ir.svg'}
              tooltip={this._metadata.tools.thermal === false ? 'tooltip.full_demo' : (this.state.radiometric ? 'tooltip.vis_view' : 'tooltip.radiometric_view')}
              disabled={this._metadata.tools.thermal === false || anyGsdModelsEnabled}
            />
          );
        }

        // Thermal eye-dropper in image viewer not on mobile (if not debug flag)
        if (!(BrowserInfo.isMobile() && this.state.imageOpen) || swea.util.getQueryParameters().debuggui === '1' || swea.util.getQueryParameters().debug === '1') {
          // Regular thermal eye-dropper
          if (this._metadata.tools.eyedropper !== undefined || (this._metadata.tools.eyedropper2d !== undefined && this.state.imageOpen)) {
            eyedropperButton = (
              <MenuItem
                onClick={this.startEyeDropperInteraction}
                img={'img/eyedropper.svg'}
                tooltip={this._metadata.tools.eyedropper === false ? 'tooltip.full_demo' : 'tooltip.eyedropper'}
                disabled={!this.state.radiometric || this.state.catalogOpen || this._metadata.tools.thermal === false || this._metadata.tools.eyedropper === false}
              />
            );
          }

          // Delta thermal eye-dropper
          if (this._metadata.tools.eyedropperdelta !== undefined) {
            eyedropperDeltaButton = (
              <MenuItem
                onClick={this.startEyeDropperInteraction.bind(this, true)}
                img={'img/eyedropper_delta.svg'}
                tooltip={this._metadata.tools.eyedropperdelta === false ? 'tooltip.full_demo' : 'tooltip.eyedropper_delta'}
                disabled={!this.state.radiometric || this.state.catalogOpen || this._metadata.tools.thermal === false || this._metadata.tools.eyedropperdelta === false}
              />
            );
          }
        }
      }

      if ((this.state.hasGsdPointCloud && anyGsdModelsEnabled && swea.util.getQueryParameters().debuggui === '1') ||
        (this._metadata.tools.thermal !== undefined &&
          (!(this.state.lockModelInterval && this.state.lockModelPalette) || ImageViewerService.instance().getState().isOpen) &&
          (!(this.state.lockImageInterval && this.state.lockImagePalette) || !ImageViewerService.instance().getState().isOpen)
        )) {
        paletteButton = (
          <MenuItem
            onClick={this.openPaletteControls}
            img={'img/palette_controls.svg'}
            tooltip={this._metadata.tools.thermal === false && !this.state.hasGsdPointCloud ? 'tooltip.full_demo' : 'tooltip.palette_controls'}
            disabled={
              (!this.state.radiometric && !this.state.hasGsdPointCloud) ||
              this.state.catalogOpen ||
              (this._metadata.tools.thermal === false && !this.state.hasGsdPointCloud)
            }
          />
        );
      }


      // Texture labels
      if (this._metadata.texturelabels !== undefined && this._metadata.texturelabels.enabled && this._metadata.tools.texturelabels && (!BrowserInfo.isMobile() || swea.util.getQueryParameters().debuggui === '1' || swea.util.getQueryParameters().debug === '1')) {
        textureLabelsButton = (
          <MenuItem
            beforeUndoRedo
            small
            onClick={this.toggleTextureLabels}
            img={this.state.textureLabels ? 'img/labels_off.svg' : 'img/label.svg'}
            tooltip={'tooltip.texture_labels'}
            disabled={this.state.catalogOpen}
          />
        );

        if (this.state.textureLabels && !this.state.contextMenuTaken && !this.state.visualizedCameraControl) {
          labelFilterControl = (
            <LabelFilterControl
              classes={this.state.reducedLabelClasses}
              filterDefs={this.state.filterDefs}
              showStats={this._metadata.tools.texturelabelstats && this._metadata.texturelabels.gisurl !== undefined && swea.util.getQueryParameters().nogis !== '1'}
              statsShortTitle={swea.i18n.t('components.labelfiltercontrol.stats_short_title')}
              statsLongTitle={swea.i18n.t('components.labelfiltercontrol.stats_long_title')}
              showLayerDialog={this._metadata.texturelabels.hidelayerdialog !== true}
              enableRectangleSelection={this._metadata.tools.texturelabelrectangle && this._metadata.texturelabels.gisurl !== undefined && swea.util.getQueryParameters().nogis !== '1'}
              rectangleInteractionClass={CustomTextureLabelRectangleInteraction}
              viewer={this._viewer}
            />
          );
        }
      }

      // Toggle texture/light
      if ((this._metadata.tools.toggletexture === true || swea.util.getQueryParameters().toggletexture === '1') && swea.util.getQueryParameters().textured !== '0') {
        toggleTextureButton = (
          <MenuItem
            small
            beforeUndoRedo
            onClick={this.toggleTexture}
            img={'img/texture.svg'}
            alt={'Texture'}
            tooltip="tooltip.toggletexture"
          />
        );
      }

      // Annotation report
      if (!BrowserInfo.isMobile() && this._metadata.tools.annotationreport !== undefined) {
        annotationReportButton = (
          <MenuItem
            onClick={this.startAnnotationReport}
            img={'img/report.svg'}
            tooltip={this._metadata.tools.annotationreport === false ? 'tooltip.full_demo' : 'tooltip.report'}
            disabled={this._metadata.tools.annotationreport === false}
          />
        );
      }
      if (this._metadata.tools.annotationreport === true) {
        annotationReport = (this.state.showAnnotationReport ? (
          <div>
            <span
              unselectable="on"
              className={`${s.closeReportButton} ${s.unselectable}`}
              onClick={this.closeAnnotationReport}>
              <img
                unselectable="on"
                className={`${s.closeImage} ${s.unselectable}`}
                src="img/cross.svg" />
            </span>
            <AnnotationReport
              title={swea.i18n.t('components.annotationreport.title')}
              projectLabel={swea.i18n.t('components.annotationreport.projectLabel')}
              companyLabel={swea.i18n.t('components.annotationreport.companyLabel')}
              inspectionDateLabel={swea.i18n.t('components.annotationreport.inspectionDateLabel')}
              reportDateLabel={swea.i18n.t('components.annotationreport.reportDateLabel')}
              projectPlaceHolder={swea.i18n.t('components.annotationreport.projectPlaceHolder')}
              companyPlaceHolder={swea.i18n.t('components.annotationreport.companyPlaceHolder')}
              annotationSumTitle={swea.i18n.t('components.annotationreport.annotationSumTitle')}
              measurementSumTitle={swea.i18n.t('components.annotationreport.measurementSumTitle')}
              boolYes={swea.i18n.t('components.annotationreport.boolYes')}
              boolNo={swea.i18n.t('components.annotationreport.boolNo')}
              creatorLabel={swea.i18n.t('components.annotation.creator')}
              viewer={this._viewer}
              includeMeasurements={this._metadata.tools.measurementreport === true}
              overviewEye={this._initialEye}
              overviewCenter={this._initialCenter}
              showCreator={this._metadata.tools.annotationcreator === true}
              showTimestamps={this._metadata.tools.annotationtimestamps === true}
              depthProfileLabel={swea.i18n.t('components.depth_profile.label')}
              cylinderProfileLabel={swea.i18n.t('components.cylinder_profile.label')}
              logo="img/spotscale_logo_RGB_black.svg"
              aiReportCallback={swea.util.getQueryParameters().ai === '1' ? this._aiReport : undefined}
            />
          </div>
        ) : undefined);
      }

      // Classification
      if (this._metadata.tools.classification !== undefined) {
        classificationButton = (swea.util.getQueryParameters().classification !== undefined || this._metadata.classification !== undefined ? (
          <MenuItem
            onClick={this.openClassification}
            img={'img/label.svg'}
            alt={'Classification'}
            tooltip={this._metadata.tools.classification === false ? 'tooltip.full_demo' : 'tooltip.toggle_classification'}
            disabled={this.state.catalogOpen || this._metadata.tools.classification === false || (BrowserInfo.isMobile() && this.state.imageOpen)}
          />
        ) : undefined);

        // Classification report
        if (!BrowserInfo.isMobile() && this._metadata.tools.classificationreport !== undefined) {
          classificationReportButton = (
            <MenuItem
              onClick={this.startClassificationReport}
              img={'img/report.svg'}
              tooltip={this._metadata.tools.classificationreport === false ? 'tooltip.full_demo' : 'tooltip.report'}
              disabled={this._metadata.tools.classificationreport === false}
            />
          );
        }
        if (this._metadata.tools.classificationreport === true) {
          classificationReport = (this.state.showClassificationReport ? (
            <div>
              <span
                unselectable="on"
                className={`${s.closeReportButton} ${s.unselectable}`}
                onClick={this.closeClassificationReport}>
                <img
                  unselectable="on"
                  className={`${s.closeImage} ${s.unselectable}`}
                  src="img/cross.svg" />
              </span>
              <Report
                title={swea.i18n.t('components.classificationreport.title')}
                projectLabel={swea.i18n.t('components.classificationreport.projectLabel')}
                companyLabel={swea.i18n.t('components.classificationreport.companyLabel')}
                inspectionDateLabel={swea.i18n.t('components.classificationreport.inspectionDateLabel')}
                reportDateLabel={swea.i18n.t('components.classificationreport.reportDateLabel')}
                projectPlaceHolder={swea.i18n.t('components.classificationreport.projectPlaceHolder')}
                companyPlaceHolder={swea.i18n.t('components.classificationreport.companyPlaceHolder')}
                typeLabel={swea.i18n.t('components.classificationreport.typeLabel')}
                countLabel={swea.i18n.t('components.classificationreport.countLabel')}
                areaLabel={swea.i18n.t('components.classificationreport.areaLabel')}
                classificationsLabel={swea.i18n.t('components.classificationreport.classificationsLabel')}
                viewer={this._viewer}
                overviewEye={this._initialEye}
                overviewCenter={this._initialCenter}
                logo="img/spotscale_logo_RGB_black.svg"
              />
            </div>
          ) : undefined);
        }
      }

      // Depth color
      if ((this._metadata.tools.depthcolor === true || swea.util.getQueryParameters().depthcolor === '1') && swea.util.getQueryParameters().textured !== '0') {
        depthColorButton = (
          <MenuItem onClick={this.toggleDepthColor} img={'img/depth.svg'} alt={'Depth'} tooltip="tooltip.depth" />
        );
      }

      // Time
      if (this._timeControl) {
        timeButton = (
          <MenuItem onClick={this.startTimeControls} img={'img/time.svg'} alt={'Time'} tooltip="tooltip.time" />
        );
      }

      // Save image
      if (this._metadata.tools.saveimage !== undefined) {
        saveImageButton = (
          <MenuItem
            onClick={this.saveImage}
            img={'img/screenshot.svg'}
            tooltip={this._metadata.tools.saveimage === false ? 'tooltip.full_demo' : 'tooltip.save_image'}
            disabled={this.state.catalogOpen || this._metadata.tools.saveimage === false}
          />
        );
      }

      // Show/hide all measurements
      if (this._metadata.tools.togglemeasurements === true) {
        toggleMeasurementsButton = (
          <MenuItem
            beforeUndoRedo
            small
            onClick={this.toggleMeasurements}
            img={this.state.measurementsToggled ? 'img/distance_off.svg' : 'img/distance.svg'}
            tooltip={this.state.measurementsToggled ? 'tooltip.disablemeasurements' : 'tooltip.enablemeasurements'}
          />
        );
      }

      if (this._metadata.tools.toggleannotations === true) {
        toggleAnnotationsButton = (
          <MenuItem
            beforeUndoRedo
            small
            onClick={this.toggleAnnotations}
            img={this.state.annotationsToggled ? 'img/annotations_off.svg' : 'img/annotation.svg'}
            tooltip={this.state.annotationsToggled ? 'tooltip.disableannotations' : 'tooltip.enableannotations'}
          />
        );
      }

      if (this._metadata.tools.filterannotations === true) {
        filterAnnotationsButton = (
            <MenuItem
              beforeUndoRedo
              small
              onClick={this.toggleAnnotationFilterPanel}
              img={'img/filter.svg'}
              tooltip={'tooltip.filterannotations'}
            />
        );
      }

      if (this._metadata.tools.sectionvolumes === true) {
        toggleSectionVolumesButton = (
          <MenuItem
            beforeUndoRedo
            small
            onClick={this.toggleSectionVolumes}
            img={this.state.sectionVolumesVisible ? 'img/section_volume_off.svg' : 'img/section_volume.svg'}
            tooltip={this.state.sectionVolumesVisible ? 'tooltip.hide_section_volumes' : 'tooltip.show_section_volumes'}
            active={this.state.sectionVolumesVisible}
          />
        );
        exportSectionsButton = (
          <MenuItem
            beforeUndoRedo
            small
            onClick={this.exportSectionVolumes}
            img={'img/export_clipboard.svg'}
            tooltip={'tooltip.export_sections'}
          />
        );
      }

      if (this._metadata.tools.downloadcsv === true) {
        downloadCsvButton = (
          <MenuItem
            beforeUndoRedo
            small
            onClick={this.downloadCsv}
            img={'img/download_csv.svg'}
            tooltip={'tooltip.downloadcsv'}
          />
        );
      }

      if (this._metadata.tools.togglesweamodel === true || swea.util.getQueryParameters().toggleSweaModel === '1') {
        toggleSweaModelButton = (
         <MenuItem
            afterUndoRedo
            small
            onClick={this.toggleModel}
            img={this.state.modelInvisible ? 'img/switch_model.svg' : 'img/switch_model_off.svg'}
            tooltip={this.state.modelInvisible ? 'tooltip.showmodel' : 'tooltip.hidemodel'}
          />
        );
      }

      // Visualize mask button - only visible with debuggui enabled and if there are masks to visualize
      if (swea.util.getQueryParameters().debuggui === '1' && this.state.imageOpen && this.state.maskAvailableClasses.length > 0) {
        visualizeMaskButton = (
          <MenuItem
            afterUndoRedo
            small
            active={this.state.maskActive}
            onClick={this.toggleVisualizeMask}
            img={'img/mask.svg'}
            tooltip="tooltip.visualizemask"
          />
        );
      }

      // Visualize mask button - only visible with debuggui enabled and if there are masks to visualize
      if (swea.util.getQueryParameters().debuggui === '1' && this.state.imageOpen && this.state.maskAvailableClasses.length > 0) {
        visualizeMaskButton = (
          <MenuItem
            afterUndoRedo
            small
            active={this.state.maskActive}
            onClick={this.toggleVisualizeMask}
            img={'img/mask.svg'}
            tooltip="tooltip.visualizemask"
          />
        );
      }

      // Visualize mask button - only visible with debuggui enabled and if there are masks to visualize
      if (swea.util.getQueryParameters().debuggui === '1' && this.state.imageOpen && this.state.maskAvailableClasses.length > 0) {
        visualizeMaskButton = (
          <MenuItem
            afterUndoRedo
            small
            active={this.state.maskActive}
            onClick={this.toggleVisualizeMask}
            img={'img/mask.svg'}
            tooltip="tooltip.visualizemask"
          />
        );
      }

      if (versions !== undefined && versions.length > 0) {
        if (this._metadata.tools.versions) {
          versionsButton = (
            <MenuItem onClick={this.startVersions} img={'img/versions.svg'} tooltip="tooltip.versions" />
          );
        }

        if (this._metadata.tools.compare) {
          versionComparisonButton = (
            <MenuItem onClick={this.startVersionComparison} img={'img/version_comparison.svg'} tooltip="tooltip.version_comparison" />
          );
        }
      }
    }

    if (this.state.showSwitchAnnotations) {
      switchAnnotationsSpan = (
        <span className={this.state.splitScreenUrl !== undefined ? s.switchAnnotationsSpanSplitScreen : s.switchAnnotationsSpan} >
          <MenuItem
            small
            onClick={this.prevAnnotation}
            img={'img/left_arrow.svg'}
            tooltip={'tooltip.prevAnnotation'}
          />
          <MenuItem
            small
            onClick={this.nextAnnotation}
            img={'img/right_arrow.svg'}
            tooltip={'tooltip.nextAnnotation'}
          />
        </span>
      );
    }

    if (this._metadata.tools.togglelights) {
      toggleLightsButton = (
        <MenuItem afterUndoRedo
          small
          onClick={this.toggleLights} img={'img/lightbulb.svg'}
          tooltip={'tooltip.togglelights'}
        />
      );
    }

    const shadowButton = this._shadow ? (
      <MenuItem afterUndoRedo
        small
        onClick={this.toggleShadows} img={'img/shadows.svg'}
        tooltip={'tooltip.shadows'}
      />
    ) : undefined;

    const solidColorPicker = BrowserInfo.isMobile() ? undefined : (
      <ColorPicker
        palette={SOLID_COLOR_PALETTE}
      />
    );

    const sectionColorPicker = BrowserInfo.isMobile() ? undefined : (
      <ColorPicker
        palette={SECTION_COLOR_PALETTE}
      />
    );

    const colorPicker = BrowserInfo.isMobile() ? undefined : (
      <ColorPicker />
    );

    const version = BrowserInfo.isMobile() ? undefined : (
      <Version toggleKey={eventCodes.V} />
    );

    const langIconDiv = (swea.util.getQueryParameters().showlang && this.state.showMenu ? (
      <div className={s.rightIconDiv}>
        <MenuItem onClick={this.toggleLanguageMenu} img={'img/globe.svg'} alt={'Language'} small={true} tooltip="tooltip.language" />
      </div>
    ) : undefined);

    let languageMenu = undefined;
    if (this.state.showLanguageMenu) {
      const languageIcons = [];
      for (let i = 0; i < LANGUAGES.length; ++i) {
        languageIcons.push(
          <MenuItem
            key={i}
            onClick={this.changeLanguage.bind(this, LANGUAGES[i])}
            alt={LANGUAGES[i].toUpperCase()}
            small={true}
            labelUnderlined={LANGUAGES[i] === this.state.lang}
          />
        );
      }

      languageMenu = (
        <div className={s.languageMenu}>
          {languageIcons}
        </div>
      );
    }

    const helpIconDiv = (this.state.showMenu && this.state.helpLoaded && this._helpText !== undefined ? (
      <div className={s.rightIconDiv}>
        <MenuItem onClick={this.help} img={'img/help.svg'} alt={'Help'} small={true} tooltip="tooltip.help" />
      </div>
    ) : undefined);

    let logo = this._logo;
    if (logo === undefined && !this._noLogo) {
      logo = 'img/spotscale_logo_RGB_black.svg';
    }

    let loadLogo = this._progressLogo;
    if (this._noLogo) {
      loadLogo = 'img/logo-empty.svg';
    }
    else if (loadLogo === undefined) {
      loadLogo = 'img/spotscale_logo_RGB_black.svg';
    }

    let splitScreenDiv = undefined;
    if (this.state.splitScreenUrl !== undefined) {
      splitScreenDiv = (
        <div className={s.splitScreenDiv}>
          <iframe
            className={s.splitScreenIframe}
            scrolling="auto"
            sandbox="allow-same-origin allow-scripts allow-modals allow-downloads allow-popups"
            src={this.state.splitScreenUrl}>
          </iframe>
          <span
            unselectable="on"
            className={`${s.closeSplitscreenButton} ${s.unselectable}`}
            onClick={this._exitSplitScreen}>
            <img
              unselectable="on"
              className={`${s.closeImage} ${s.unselectable}`}
              src="img/cross.svg" />
          </span>
        </div>
      );
    }

    let cameraControl = undefined;
    if (this.state.visualizedCameraControl) {
      cameraControl = (
        <CameraControl
          cameraThumbUrl={this.state.visualizedCameraThumbUrl}
          cameraName={this.state.visualizedCameraName}
          ordered={this.state.visualizeCameraLines}
          cameraInteraction={this._cameraInteraction}
          expandCallback={this._cameraExpanded}
          showDownload={this._metadata.tools.downloadimage !== false}
          showOrthogonalGsd={(swea.util.getQueryParameters().debug === '1' || swea.util.getQueryParameters().debuggui === '1')}
        />
      );
    }

    if (this._metadata.tools.workspaceinfo === true && this.state.workspaceInfoUrl !== undefined) {
      workspaceInfoButton = (
        <MenuItem
          onClick={this.showWorkspaceInfo}
          img={'img/report.svg'}
          tooltip="tooltip.info"
        />
      );
    }

    let moreImagesButton = undefined;
    if (this._metadata.tools.smartinspect && ImageViewerService.instance().getState().isOpen) {
      moreImagesButton = (<MenuItem onClick={this.moreImages} img={'img/stacked.svg'} alt={'More images'} tooltip="tooltip.moreimages" />);
    }

    if (this._visualizeCameras) {
      camerasButton = (<MenuItem afterUndoRedo small onClick={this.toggleCameras} img={this.state.visualizeCameras ? 'img/camera_invisible.svg' : 'img/camera.svg'} tooltip="tooltip.togglecameras"/>);
      if (this.state.visualizeCameras) {
        inspectCamerasButton = (
          <MenuItem
            small
            afterUndoRedo
            onClick={this.state.visualizedCamerasInspected ? this.disableVisualizedCameraInspection : this.startVisualizedCameraInspection}
            img={this.state.visualizedCamerasInspected ? 'img/reset_inspect_cameras.svg' : 'img/inspect_cameras.svg'}
            tooltip={this.state.visualizedCamerasInspected ? 'tooltip.resetinspectcameras' : 'tooltip.inspectcameras'}
          />
        );
      }
    }

    let annotationFilterPanel = undefined;
    if (this.state.showAnnotationFilterPanel) {
      annotationFilterPanel = (
        <AnnotationFilterPanel
          onClose={this.toggleAnnotationFilterPanel}
          filter={this.state.annotationFilter}
          onChange={this.handleAnnotationFilterChange}
          sectionVolumesReadOnly={this._metadata.tools.sectionvolumes !== true}
        />
      );
    }

    let lowerRightLogo = undefined;
    if (this._logo2 !== undefined) {
      lowerRightLogo = (
        <img unselectable="on" className={s.lowerRightLogo} src={this._logo2} />
      );
    }

    // Debug icons
    let debugIconDiv = undefined;
    let debugMenu = undefined;
    if (swea.util.getQueryParameters().debuggui === '1') {
      debugIconDiv = (
        <div className={s.rightIconDiv}>
          <MenuItem
            afterUndoRedo
            small
            onClick={this.toggleDebugMenu}
            img={'img/debug.svg'}
            tooltip="tooltip.debug"
          />
        </div>
      );

      if (this.state.showDebugMenu) {
        const toggleGsdButton = (gsdTypesActive.indexOf(GsdType.GENERAL) > -1 ?
          <MenuItem
            afterUndoRedo
            small
            onClick={this.toggleGsd.bind(this, GsdType.GENERAL)}
            img={'img/resolution.svg'}
            tooltip="tooltip.togglegsd"
            disabled={this.state.radiometric}
          />
          : undefined);

        const toggleCoverageGsdButton = (gsdTypesActive.indexOf(GsdType.COVERAGE) > -1 ?
          <MenuItem
            afterUndoRedo
            small
            onClick={this.toggleGsd.bind(this, GsdType.COVERAGE)}
            img={'img/camera_resolution.svg'}
            tooltip="tooltip.togglecoveragegsd"
            disabled={this.state.radiometric}
          />
          : undefined);

        const toggleTextureGsdButton = (gsdTypesActive.indexOf(GsdType.TEXTURE) > -1 ?
          <MenuItem
            afterUndoRedo
            small
            onClick={this.toggleGsd.bind(this, GsdType.TEXTURE)}
            img={'img/texture_resolution.svg'}
            tooltip="tooltip.toggletexturegsd"
            disabled={this.state.radiometric}
          />
          : undefined);

        const copyThermalButton = (this._metadata.tools.thermal !== undefined ?
          <MenuItem
            afterUndoRedo
            small
            onClick={this.copyThermal}
            img={'img/copy_thermal.svg'}
            tooltip="tooltip.copythermal"
            disabled={!this.state.radiometric}
          />
          : undefined);
        const pasteThermalButton = (this._metadata.tools.thermal !== undefined ?
          <MenuItem
            afterUndoRedo
            small
            onClick={this.pasteThermal}
            img={'img/paste_thermal.svg'}
            tooltip="tooltip.pastethermal"
            disabled={!this.state.radiometric || this.state.copiedThermal === undefined}
          />
          : undefined);

        const storeDisabledLabelsButton = (this._textureLabelsEnabled ?
          <MenuItem
            afterUndoRedo
            small
            onClick={this.storeDisabledLabels}
            img={'img/store_label_filter.svg'}
            tooltip="tooltip.storedisabledlabels"
          />
          : undefined);
        const saveDisabledLabelsButton = (this._textureLabelsEnabled ?
          <MenuItem
            afterUndoRedo
            small
            onClick={this.saveDisabledLabels}
            img={'img/save_label_filter.svg'}
            tooltip="tooltip.savedisabledlabels"
          />
          : undefined);
        const loadDisabledLabelsButton = (this._textureLabelsEnabled ?
          <MenuItem
            afterUndoRedo
            small
            onClick={this.loadDisabledLabels}
            img={'img/load_label_filter.svg'}
            tooltip="tooltip.loaddisabledlabels"
          />
          : undefined);

        debugMenu = (
          <div className={s.debugMenu}>
            {visualizeMaskButton}
            <MenuItem
              afterUndoRedo
              small
              onClick={this.toggleCameras}
              img={this.state.visualizeCameras ? 'img/camera_invisible.svg' : 'img/camera.svg'}
              tooltip="tooltip.togglecameras"
            />
            <MenuItem
              afterUndoRedo
              small
              onClick={this.toggleCameraLines}
              img={this.state.visualizeCameraLines ? 'img/camera_lines_invisible.svg' : 'img/camera_lines.svg'}
              tooltip="tooltip.togglecameralines"
            />
            <MenuItem
              afterUndoRedo
              small
              onClick={this.state.visualizedCamerasInspected ? this.disableVisualizedCameraInspection : this.startVisualizedCameraInspection}
              img={this.state.visualizedCamerasInspected ? 'img/reset_inspect_cameras.svg' : 'img/inspect_cameras.svg'}
              tooltip={this.state.visualizedCamerasInspected ? 'tooltip.resetinspectcameras' : 'tooltip.inspectcameras'}
              disabled={!this.state.visualizeCameras}
            />
            <MenuItem
              afterUndoRedo
              small
              onClick={this.selectCamerasByRectangle}
              img={'img/camera_rectangle.svg'}
              tooltip="tooltip.selectcameras"
              disabled={!this.state.visualizeCameras}
            />
            <MenuItem
              afterUndoRedo
              small
              onClick={this.toggleModel}
              img={this.state.modelInvisible ? 'img/switch_model.svg' : 'img/switch_model_off.svg'}
              tooltip={this.state.modelInvisible ? 'tooltip.showmodel' : 'tooltip.hidemodel'}
            />
            <MenuItem
              afterUndoRedo
              small
              onClick={this.toggleModelInImage}
              img={'img/switch_model_in_image.svg'}
              tooltip="tooltip.togglemodelinimage"
            />
            <MenuItem
              afterUndoRedo
              small
              onClick={this.toggleClassificationBacksides}
              img={'img/backside.svg'}
              tooltip="tooltip.togglebackside"
            />
            <MenuItem
              afterUndoRedo
              small
              onClick={this.copyPose}
              img={'img/copy_pose.svg'}
              tooltip="tooltip.copypose"
            />
            <MenuItem
              afterUndoRedo
              small
              onClick={this.pastePose}
              img={'img/paste_pose.svg'}
              tooltip="tooltip.pastepose"
              disabled={this.state.copiedPose === undefined}
            />
            {copyThermalButton}
            {pasteThermalButton}
            {toggleGsdButton}
            {toggleCoverageGsdButton}
            {toggleTextureGsdButton}
            <MenuItem
              afterUndoRedo
              small
              onClick={this.startResolutionInteraction}
              img={'img/eyedropper_resolution.svg'}
              tooltip="tooltip.pickresolution"
            />
            <MenuItem
              afterUndoRedo
              small
              onClick={this.startSpecifyTransformInteraction}
              img={'img/matrix.svg'}
              tooltip="tooltip.specify_transform"
            />
            {storeDisabledLabelsButton}
            {saveDisabledLabelsButton}
            {loadDisabledLabelsButton}
            <MenuItem
              afterUndoRedo
              small
              onClick={this.toggleImageSmoothing}
              img={'img/imagesmoothing.svg'}
              tooltip="tooltip.toggleimagesmoothing"
            />
          </div>
        );
      }
    }

    let compass = undefined;
    if (this._metadata.tools.compass === true) {
      compass = (
        <div className={s.rightIconDiv}>
          <Compass
            onRef={(instance) => {
              this._compass = instance;
              if (this._viewer !== undefined) {
                this._compass.initialize(this._viewer.getSceneViewer());
              }
            }}
          />
        </div>
      );
    }

    let axesIndicator = undefined;
    if (this._metadata.tools.axes === true) {
      axesIndicator = (
        <div className={s.axesFloatDiv}>
          <AxesIndicator
            onRef={(instance) => {
              this._axesIndicator = instance;
              if (this._viewer !== undefined && instance !== undefined) {
                this._axesIndicator.initialize(this._viewer.getSceneViewer());
              }
            }}
          />
        </div>
      );
    }

    let altitude = undefined;
    if (this._metadata.tools.altitude === true) {
      altitude = (
        <div className={s.rightIconDiv}>
          <Altitude
            onRef={(instance) => {
              this._altitude = instance;
              if (this._viewer !== undefined) {
                this._altitude.initialize(this._viewer.getSceneViewer());
              }
            }}
            offset={this._metadata.offset !== undefined ? this._metadata.offset[2] : 0.0}
          />
        </div>
      );
    }

    let subModelBackButton = undefined;
    if (this._backUrl !== undefined) {
      subModelBackButton = (
        <div className={s.subModelBack}>
          <MenuItem onClick={this._backFromSubModel} img={'img/round_back.svg'} tooltip={i18n.t('tooltip.backfromsub')} />
        </div>
      );
    }

    let elevationButton = undefined;
    if (this._metadata.tools.elevation === true) {
      elevationButton = (
        <MenuItem onClick={this.startElevationInteraction} img={'img/elevation.svg'} tooltip='tooltip.elevation' />
      );
    }

    let imageSlider = undefined;
    if (this.state.comparisonImageUrl !== undefined) {
      imageSlider = (
        <ImageSlider
          leftImageUrl={this.state.comparisonImageUrl}
          leftName={this.state.comparisonVersionName}
          rightName={this.state.currentVersionName}
        />
      );
    }

    let versionNameLabel = undefined;
    if (this.state.comparisonImageUrl === undefined && this.state.showControlsOutsideMenu) {
      // Show version name under logo when not in comparison slider and model has loaded
      const versionsState = VersionsService.instance().getState();
      let activeVersionName = this.state.currentVersionName || '';
      if (activeVersionName === '' && versionsState.regularVersion && versionsState.regularVersion.name) {
        activeVersionName = versionsState.regularVersion.name;
      }
      if (activeVersionName !== '' && versionsState.versions !== undefined && versionsState.versions.length > 0) {
        // Build list of all versions for dropdown, sorted newest first if dates are available
        let dropdownItems = [];
        const regularName = versionsState.regularVersion && versionsState.regularVersion.name
          ? swea.util.removeHtmlTags(versionsState.regularVersion.name) : '';
        dropdownItems.push({ version: 1, name: regularName || '1' });
        for (let vi = 0; vi < versionsState.versions.length; ++vi) {
          const vName = versionsState.versions[vi].name
            ? swea.util.removeHtmlTags(versionsState.versions[vi].name) : '';
          dropdownItems.push({ version: vi + 2, name: vName || String(vi + 2) });
        }
        // Try to sort newest first using date-sorted versions
        try {
          const versionDates = versionsState.versionDates;
          const regularDate = versionsState.regularDate;
          const allHaveDates = regularDate !== undefined && regularDate !== null
            && versionDates !== undefined
            && Object.keys(versionDates).length === versionsState.versions.length;
          if (allHaveDates) {
            const sorted = VersionsService.instance().getDateSortedVersions();
            dropdownItems = [];
            for (let si = sorted.length - 1; si >= 0; --si) {
              const item = sorted[si];
              let itemName = item.name ? swea.util.removeHtmlTags(item.name) : '';
              if (itemName === '' && item.version === 1) {
                itemName = regularName;
              }
              dropdownItems.push({ version: item.version, name: itemName || String(item.version) });
            }
          }
        } catch (e) {
          // Keep unsorted fallback
        }

        versionNameLabel = (
          <div className={s.versionNameLabel} ref={(el) => { this._versionDropdownRef = el; }}>
            <div className={s.versionDropdownTrigger} onClick={this._toggleVersionDropdown}>
              <span>{swea.i18n.t('components.showing_model') + ': ' + swea.util.removeHtmlTags(activeVersionName)}</span>
              <span className={`${s.versionChevron} ${this.state.versionDropdownOpen ? s.versionChevronOpen : ''}`}>&#9662;</span>
            </div>
            {this.state.versionDropdownOpen && (
              <div className={s.versionDropdown}>
                {dropdownItems.map((item) => (
                  <div
                    key={item.version}
                    className={`${s.versionDropdownItem} ${item.version === versionsState.version ? s.versionDropdownItemActive : ''}`}
                    onClick={() => this._selectVersionFromDropdown(item.version)}
                  >
                    {item.name}
                  </div>
                ))}
              </div>
            )}
          </div>
        );
      }
    }

    let cameraScaleDialog = undefined;
    if (this.state.visualizedCamerasScaleDialogActive) {
      const scaleMin = 0.1;
      const scaleMax = 10;
      const clampedScale = Math.max(scaleMin, Math.min(scaleMax, this.state.visualizedCamerasScale));
      const logSliderValue = this._scaleToLogSlider(clampedScale, scaleMin, scaleMax);

      cameraScaleDialog = (
        <div className={s.cameraScaleDialog}>
          <span className={s.cameraScaleContainer}>
            <span className={s.cameraScaleText}>
              {swea.i18n.t('components.camera_scale.text')}
            </span>
            <ContextInput
              onRef={(instance) => { this._cameraScaleInput = instance; }}
              width='3.5em'
              placeholder={this.state.visualizedCamerasScale.toFixed(2)}
              okCallback={this.handleCameraScaleChange}
              okButton={false}
              cancelButton={false}
              unfocusAsOk={true}
            />
            <span className={s.sliderWrapper}>
              <Slider
                dual={false}
                domain={[0, 1]}
                values={[logSliderValue]}
                callback={(sliderValues) => {
                  const realScale = this._logSliderToScale(sliderValues[0], scaleMin, scaleMax);
                  this.handleCameraScaleChange(realScale);
                }}
              />
            </span>
          </span>
        </div>
      );
    }

    const usesSplat = (swea.util.getQueryParameters().splat !== undefined && swea.util.getQueryParameters().splat !== '');

    // NOTE: The onRef in ProgressScreen below is needed to reach progressCallback
    //       from this class as a child wrapped by withStyles.
    return (
      <span>
        <div className={`${this.state.splitScreenUrl !== undefined ? s.splitScreen : null}`}>
          <div className={`${s.overlay} ${this._overlayUrl === undefined ? s.hidden : null}`} ref={(instance) => { this._overlayDiv = instance; }} ></div>
          <ProgressScreen
            className={this.state.fullProgressLogo ? s.logoProgress : s.progress}
            logoImagePath={loadLogo}
            logoImagePath2={this._progressLogo2}
            text={this.state.showProgressText ? swea.i18n.t('components.progress.model') : ''}
            progressBarWidth='100%'
            progressColor='#3d342e'
            progressBackgroundColor='#ccc'
            totalFactor={this._currentProgressFactor}
            totalOffset={this._currentProgressOffset}
            onRef={ref => { this._progressScreen = ref; }}
            full={this.state.fullProgressLogo}
          />
          {classificationReport}
          {annotationReport}
          {imageSlider}
          {
            this.state.comparisonMaskUrl !== undefined && this.state.comparisonImageUrl !== undefined ? (
              <img
                className={s.comparisonMaskOverlay}
                src={this.state.comparisonImageUrl}
                style={{
                  opacity: this.state.comparisonOpacity,
                  WebkitMaskImage: 'url(' + this.state.comparisonMaskUrl + ')',
                  maskImage: 'url(' + this.state.comparisonMaskUrl + ')',
                  WebkitMaskSize: '100% 100%',
                  maskSize: '100% 100%'
                }}
              />
            ) : undefined
          }
          {versionNameLabel}
          <Viewer
            onRef={(instance) => { this._viewer = instance; }}
            maxWidth={this._maxWidth}
            className={s.spotscaleFullViewer}
            enableGlobalHeadlight={false}
            logoImagePath={logo}
            showLogo={this.state.showLogo}
            lowerElevationLimit={this.state.lowerElevationLimit}
            interactions={this.state.interactions}
            backgroundColor={this.state.backgroundColor ? ('#' + this.state.backgroundColor) : '#ffffff'}
            shadows={this._shadow && this._startShadow}
            softShadows={this._shadow}
            shadowStrength={0.4}
            fov={this._fov}
            shadowTextureSize={swea.util.getQueryParameters().shadowAtlas === '0' ? 4096 : 128}
            shadowAtlasSize={swea.util.getQueryParameters().shadowAtlas === '0' ? undefined : 4096}
            shadowColorBlend={swea.util.getQueryParameters().shadowColorBlend === '1'}
            collisionDelta={this._metadata.collisionDelta}
            webgl2={usesSplat || swea.util.getQueryParameters().webgl2 === '1'}
            alpha={usesSplat}
            nearFarRatio={usesSplat ? 0.001 : undefined}
            subloadTextures={swea.util.getQueryParameters().texsubload === '1'}
            subloadGeometry={swea.util.getQueryParameters().geomsubload === '1'}
            dragView={swea.util.getQueryParameters().drag === '1' || (this._metadata.tools.cylinderview === true && this._metadata.view.cylinderdiameter !== undefined)}
          />
          <div className={s.menuDiv}>
            <Menu className={`${s.customMenu} ${this._editEnabled === false || !this.state.showMenu ? s.hidden : null}`} showUndoRedo={this._metadata.tools.undo_redo_delete && !this.state.catalogOpen}>
              <ContextMenu menuName={globals.LOWER_CONTEXT_MENU}>
                <ContextMenuCondition
                  closeFunction={this.stopBulldoze}
                  when={[globals.SELECTED_BULLDOZER]}>
                  <MenuItem onClick={this.startBulldozeInteraction} img={'img/add.svg'} tooltip="tooltip.add" />
                </ContextMenuCondition>
                <ContextMenuCondition
                  closeFunction={this.stopMeasureInteraction}
                  when={[globals.MEASURE_ACTIVATED]}>
                  <MeasureContextMenu
                    lengthLabel={swea.i18n.t('components.measure_context_menu.measured_length')}
                    areaLabel={swea.i18n.t('components.measure_context_menu.measured_area')}
                    componentsLabel={swea.i18n.t('components.measure_context_menu.components')}
                    angleLabel={swea.i18n.t('components.measure_context_menu.angle')}
                    segmentLengthsLabel={swea.i18n.t('components.measure_context_menu.segment_lengths')}
                    accuracy={this.state.measureAccuracy}
                    showRefine={this._metadata.tools.refine_measure}
                    selectedClassificationAreaLabelPrefix={swea.i18n.t('components.measure_context_menu.selected_class_area')}
                    totalClassificationAreaLabelPrefix={swea.i18n.t('components.measure_context_menu.total_class_area')}
                    totalSelectedClassificationPlusMeasuredAreaLabel={swea.i18n.t('components.measure_context_menu.total_selected_class_plus_measured_area')}
                    snapLabel={swea.i18n.t('components.measure_context_menu.snap_label')}
                    dashedLabel={swea.i18n.t('components.measure_context_menu.dashed')}
                    extrudeLabel={swea.i18n.t('components.measure_context_menu.extrude')}
                    extrusionDepthLabel={swea.i18n.t('components.measure_context_menu.extrusion_depth')}
                    extrusionAngleLabel={swea.i18n.t('components.measure_context_menu.extrusion_angle')}
                    extrusionOpacityLabel={swea.i18n.t('components.measure_context_menu.extrusion_opacity')}
                    showExtrude={this._metadata.tools.extrudemeasurements === true || swea.util.getQueryParameters().extrudemeasurements === '1'}
                  />
                  {unitButton}
                </ContextMenuCondition>
                <ContextMenuCondition
                  closeFunction={this.closeCatalogue}
                  when={[globals.CATALOGUE_ACTIVATED]}>
                </ContextMenuCondition>
                <ContextMenuCondition
                  closeFunction={this.closeBimCatalogue}
                  when={[globals.BIM_CATALOGUE_ACTIVATED]}>
                </ContextMenuCondition>
                <ContextMenuCondition
                  closeFunction={this.stopPlaceModelInteraction}
                  when={[globals.MODEL_ACTIVATED]}>
                  <ModelContextMenu thumb={this.state.modelImgPath} name={this.state.modelName} comment={this.state.modelComment} />
                </ContextMenuCondition>
                <ContextMenuCondition
                  when={[globals.SELECTED_AREA]}>
                  {this.state.sectionVolumeToolActive ? sectionVolumeExtruder : extruder}
                  {this.state.sectionVolumeToolActive ? sectionColorPicker : solidColorPicker}
                </ContextMenuCondition>
                <ContextMenuCondition
                  when={[globals.SELECTED_VOLUME]}>
                  {solidColorPicker}
                  {extruder}
                </ContextMenuCondition>
                <ContextMenuCondition
                  when={[globals.SELECTED_SECTION_VOLUME]}>
                  {sectionVolumeExtruder}
                  {sectionColorPicker}
                </ContextMenuCondition>
                <ContextMenuCondition
                  when={ [ globals.CLASSIFICATION_OPEN ] }>
                  <ToggleModelsContextMenu
                    classification={swea.util.getQueryParameters().classification !== undefined || this._metadata.classification !== undefined}
                  />
                </ContextMenuCondition>
                <ContextMenuCondition
                  when={[globals.TOGGLE_OPEN]}>
                  <ToggleModelsContextMenu />
                </ContextMenuCondition>
                <ContextMenuCondition
                  when={[globals.SELECTED_ANNOTATION]}>
                  <span className={`${this._metadata.tools.annotate !== true ? s.hidden : null}`}>
                    <AnnotationContextMenu
                      creatorLabel={swea.i18n.t('components.annotation.creator')}
                      showCreator={this._metadata.tools.annotationcreator === true}
                      showTimestamps={this._metadata.tools.annotationtimestamps === true}
                      depthProfileInteractionClass={this._metadata.tools.depthprofile === true || this._metadata.tools.cylinderprofile === true ? CustomDepthProfileInteraction : undefined}
                      cylinderProfile={this._metadata.tools.cylinderprofile}
                      handleTemplateId={this._handle.getId()}
                      viewer={this._viewer}
                      depthProfileLabel={swea.i18n.t('components.depth_profile.label')}
                      depthProfileXLabel={swea.i18n.t('components.depth_profile.x_label')}
                      depthProfileYLabel={swea.i18n.t('components.depth_profile.y_label')}
                      removeDepthProfileQuestionTitle={swea.i18n.t('components.depth_profile.remove_title')}
                      removeDepthProfileQuestion={swea.i18n.t('components.depth_profile.remove')}
                      removeDepthProfileYes={swea.i18n.t('components.depth_profile.yes')}
                      removeDepthProfileNo={swea.i18n.t('components.depth_profile.no')}
                      cylinderProfileLabel={swea.i18n.t('components.cylinder_profile.label')}
                      cylinderProfileXLabel={swea.i18n.t('components.cylinder_profile.x_label')}
                      cylinderProfileYLabel={swea.i18n.t('components.cylinder_profile.y_label')}
                      cylinderDiameterLabel={swea.i18n.t('components.cylinder_profile.diameter_label')}
                      cylinderSliceWidthLabel={swea.i18n.t('components.cylinder_profile.slice_width_label')}
                      quarterCylinderLabel={swea.i18n.t('components.cylinder_profile.quarter_label')}
                      removeCylinderProfileQuestionTitle={swea.i18n.t('components.cylinder_profile.remove_title')}
                      removeCylinderProfileQuestion={swea.i18n.t('components.cylinder_profile.remove')}
                      removeCylinderProfileYes={swea.i18n.t('components.cylinder_profile.yes')}
                      removeCylinderProfileNo={swea.i18n.t('components.cylinder_profile.no')}
                      isLockedLabel={swea.i18n.t('components.annotation.isLocked')}
                    />
                    {this._annotationFieldsControlColor ? undefined : colorPicker}
                  </span>
                </ContextMenuCondition>
                <ContextMenuCondition
                  when={[globals.SELECTED_TEXT_AREA, globals.SELECTED_TEXT_LINE]}>
                  {colorPicker}
                  <TextEditor />
                </ContextMenuCondition>
                <ContextMenuCondition
                  when={[globals.PALETTE_CONTROL_ACTIVATED]}>
                  <ShaderPaletteContextMenu
                    paletteLabel={i18n.t('components.palettecontrol.palette')}
                    lockModelPalette={!anyGsdModelsEnabled && this.state.lockModelPalette}
                    lockImagePalette={!anyGsdModelsEnabled && this.state.lockImagePalette}
                    lockModelInterval={!anyGsdModelsEnabled && this.state.lockModelInterval}
                    lockImageInterval={!anyGsdModelsEnabled && this.state.lockImageInterval}
                    copyThermalCallback={!anyGsdModelsEnabled && swea.util.getQueryParameters().debuggui === '1' ? this.copyThermal : undefined}
                    showThreshold={this._metadata.thermal !== undefined && !anyGsdModelsEnabled && Object.keys(this._metadata.thermal).length > 0}
                    thresholdLabel={i18n.t('components.palettecontrol.threshold')}
                    presentThresholdTemperature={!anyGsdModelsEnabled && this._presentThresholdTemperature}
                    showInputs={this.state.hasGsdPointCloud && anyGsdModelsEnabled}
                    minMax={anyGsdModelsEnabled ? gsdMinMax : undefined}
                    minMaxFactor={anyGsdModelsEnabled ? (gsdMinMax !== undefined ? 1000.0 : 1.0) : undefined}
                    minMaxUnit={gsdMinMax !== undefined && anyGsdModelsEnabled ? 'mm' : undefined}
                  />
                </ContextMenuCondition>
                <ContextMenuCondition
                  closeFunction={this.stopEyeDropperInteraction}
                  when={[globals.EYE_DROPPER_ACTIVATED]}>
                  <EyeDropperContextMenu
                    measuringInImageMessage={i18n.t('components.eyedropper.measuring')}
                  />
                </ContextMenuCondition>
                <ContextMenuCondition
                  when={[globals.TEXTURE_LABEL_EYE_DROPPER_ACTIVATED]}>
                  <TextureLabelEyeDropperContextMenu
                    enableCrop={swea.util.getQueryParameters().reportPickedLabels !== '1'}
                    accuracy={this.state.measureAccuracy}
                  />
                  {unitButton}
                </ContextMenuCondition>
                <ContextMenuCondition
                  when={[globals.TIME_CONTROLS_ACTIVATED]}>
                  <TimeContextMenu
                    yearLabel={i18n.t('components.time.year')}
                    monthLabel={i18n.t('components.time.month')}
                    dayLabel={i18n.t('components.time.day')}
                    hourLabel={i18n.t('components.time.hour')}
                    minuteLabel={i18n.t('components.time.minute')}
                    secondLabel={i18n.t('components.time.second')}
                    animationFactorLabel={i18n.t('components.time.animationFactor')}
                  />
                </ContextMenuCondition>
                <ContextMenuCondition
                  when={[globals.VERSIONS_ACTIVATED]}
                >
                  <VersionsContextMenu
                    timeline={swea.util.getQueryParameters().timeline !== '0'}
                    compare={this.state.comparingVersions}
                    transparencyLabel={i18n.t('components.versions_context_menu.transparency')}
                  />
                </ContextMenuCondition>
                <ContextMenuCondition
                  when={[globals.DISTRIBUTE_ACTIVATED]}>
                  <DistributedContextMenu
                    widthSpacingLabel={i18n.t('components.distribute_context_menu.widthspacing')}
                    depthSpacingLabel={i18n.t('components.distribute_context_menu.depthspacing')}
                    heightSpacingLabel={i18n.t('components.distribute_context_menu.heightspacing')}
                  />
                </ContextMenuCondition>
                <ContextMenuCondition
                  closeFunction={this.stopResolutionInteraction}
                  when={[globals.RESOLUTION_ACTIVATED]}
                >
                  <ResolutionContextMenu
                    textureLabel={swea.i18n.t('components.resolution_context_menu.texture_resolution')}
                    imageLabel={swea.i18n.t('components.resolution_context_menu.image_resolution')}
                    accuracy={this.state.measureAccuracy}
                  />
                </ContextMenuCondition>
                <ContextMenuCondition
                  when={[globals.SPECIFY_TRANSFORM_ACTIVATED]}
                >
                  <SpecifyTransformContextMenu
                    interactionClass={CustomSpecifyTransformInteraction}
                    viewer={this._viewer}
                  />
                </ContextMenuCondition>
                <ContextMenuCondition
                  closeFunction={() => { MaskServiceActions.deactivate(); }}
                  when={[globals.MASK_CLASSES_ACTIVATED]}
                >
                  <MaskClassesContextMenu />
                </ContextMenuCondition>
              </ContextMenu>

              {homeButton}
              {freeViewButton}
              {topViewButton}
              {sideViewButton}
              {topFreeButton}
              {cylinderViewButton}
              {turnCylinderViewLeftButton}
              {turnCylinderViewRightButton}

              {downloadCsvButton}
              {toggleSweaModelButton}
              {toggle3dButton}
              {thermalButton}
              {textureLabelsButton}
              {filterButton}
              {shadowButton}
              {toggleLightsButton}
              {shareButton}
              {camerasButton}
              {inspectCamerasButton}
              {toggleAnnotationsButton}
              {filterAnnotationsButton}
              {toggleSectionVolumesButton}
              {exportSectionsButton}
              {toggleMeasurementsButton}
              {toggleTextureButton}

              {subModelBackButton}
              {inspectButton}
              {measureButton}

              {catalogButton}
              {bulldozeButton}
              {classificationButton}
              {drawAreaButton}
              {drawLineButton}
              {solidAreaButton}
              {sectionVolumeButton}
              {annotationButton}
              {distanceButton}
              {paletteButton}
              {eyedropperButton}
              {eyedropperDeltaButton}
              {depthColorButton}
              {elevationButton}

              {timeButton}

              {toggleModelsButton}
              {classificationReportButton}
              {annotationReportButton}

              {workspaceInfoButton}
              {saveImageButton}
              {moreImagesButton}

              {versionsButton}
              {versionComparisonButton}

              {loadButton}
              {saveButton}
            </Menu>
          </div>
          <span className={this.state.showControlsOutsideMenu ? null : s.hidden}>
            {labelFilterControl}
            {cameraControl}
            {clipSlider}
            {distanceSlider}
            {switchAnnotationsSpan}
            {version}
            <span className={s.overMenuRight}>
              {cameraScaleDialog}
              {helpIconDiv}
              {debugIconDiv}
              {debugMenu}
              {langIconDiv}
              {languageMenu}
              {compass}
              {axesIndicator}
              {altitude}
            </span>
          </span>
          {annotationFilterPanel}
          {lowerRightLogo}
        </div>
        {splitScreenDiv}
      </span>
    );
  }
}

export default withStyles(s)(Index);
